export default {
  seleccionaNegocio: "Selecciona negocio...",
  filtraPorEtiqueta: "Filtra por etiqueta",
  noEncontramosResultadosPara: "No encontramos resultados para ",
  mostrando: "Mostrando",
  resultado: "resultado",
  resultados: "resultados",

  // ALMACÉN
  totalAlmacen: "Total Almacén",
  totalAlmacenDto: "Total Almacén Dto",
  existenciasTeoricas: "Existencias Teóricas",
  diferencia: "Diferencia",
  noContabilizado: "No contabilizado",
  seleccioneUnaFechaDeInicioYUnaFechaDeFin:
    "Seleccione una fecha de inicio y una fecha de fin",

  // INFORMES
  inicio: "Inicio",
  informes: "Informes",
  productos: "Productos",
  ventasPorNegocio: "Ventas por negocio",
  casas: "Casas",
  facturasSimplificadas: "Facturas simplificadas",
  comprasPorNegocio: "Compras por negocio",
  comprasPorCasas: "Compras por casas",
  gastosPorProveedor: "Gastos por proveedor",
  gastosPorSubproductos: "Gastos por materias primas",
  sage: "SAGE",
  sageplancuentas: "Plan de Cuentas",
  sageclientes: "Clientes",
  sageefectos: "Efectos",
  sageasientos: "Asiento Contable",

  //CASAS
  nuevaCasa: "Nueva casa",
  casa: "Casa",
  negocio: "Negocio",
  desde: "Desde",
  hasta: "Hasta",
  consultar: "Consultar",
  infoCasas:
    "Este consumo de casas proviene de los gastos introducidos en el rango de fecha seleccionado",
  exportarInforme: "Exportar informe",
  exportarPdf: "Exportar como PDF",
  exportarExcel: "Exportar como Excel",
  exportarExcelSinSubproductos: "Exportar como Excel con materias primas",

  // TABLA
  fecha: "Fecha",
  subproductos: "Materias primas",
  subproducto: "Materia prima",
  unidades: "Unidades",
  partes: "Partes",
  precio: "Precio",
  total: "Total",
  infoConsumo:
    "Este consumo de casas proviene de los gastos introducidos en el rango de fecha seleccionado",
  noHay: "No hay",
  gastos: "Gastos",
  rangoDeFechas: "en este rango de fecha.",
  clickConsultarParaRealizarBusqueda: "Haga clic en el botón Consultar para realizar la búsqueda",
  avisoDatosUltimaConsulta: "Estos datos son de la última consulta realizada. Si has cambiado negocio, TPV o fechas, pulsa \"Consultar\" para actualizarlos.",
  ultimaActualizacion: "Última actualización",
  negocioBloqueadoConsultasEnCurso: "Hay consultas en curso. Espera a que terminen para cambiar de negocio.",
  configuracion: "Configuración",
  datosFiscales: "Datos Fiscales",

  // DATOS FISCALES
  nombreFiscal: "Nombre fiscal",

  // FORM CASA
  nombreCasa: "Nombre Casa",
  cifNif: "CIF NIF",
  direccion: "Dirección",
  provincia: "Provincia",
  ciudad: "Ciudad",
  codigoPostal: "Código postal",
  pais: "Pais",
  telefono: "Teléfono",
  correoElectronico: "Correo electrónico",
  iban: "IBAN",
  numeroRegistroSanitario: "Número registro sanitario",
  baja: "Baja",
  guardar: "Guardar",
  cancelar: "Cancelar",
  replicar: "Replicar en otros negocios",
  replicarCasa: "Replicar casa en otros negocios",
  seleccionarTodos: "Seleccionar todos",
  aceptar: "Aceptar",
  casaMin: "casas",

  compras: "Compras",
  agregarCasa: "Añadir Casa",
  email: "Email",
  acciones: "Acciones",
  turnos: "Turnos",
  editar: "Editar",
  enEsteNegocio: " en este negocio.",

  // PLACEHOLDER
  introduzcaNombre: "Introduzca nombre",
  introduzcaCifNif: "Introduzca CIF / NIF",
  introduzcaDireccion: "Introduzca dirección",
  introduzcaProvincia: "Introduzca provincia",
  introduzcaCiudad: "Introduzca ciudad",
  introduzcaCodigoPostal: "Introduzca código postal",
  introduzcaTelefono: "Introduzca teléfono",
  introduzcaCorreo: "Introduzca correo electrónico",
  introduzcaIban: "Introduzca IBAN",
  introduzcaNumeroRegistroSanitario: "Introduzca número registro sanitario",
  buscar: "Buscar...",

  // PROVEEDORES
  proveedores: "Proveedores",
  agregarProveedor: "Agregar Proveedor",
  categoria: "Categoría",
  proveedoresMin: "proveedores",

  // FORM
  nombreProveedor: "Nombre Proveedor",
  acreedor: "Acreedor",
  infoAcreedor: "(Si un proveedor es acreedor no aparecerá en Numier TPV)",
  replicarProveedor: "Replicar proveedor en otros negocios",
  category: "Categoría",
  replicarCategory: "Replicar etiqueta en otros negocios",

  // ETIQUETAS
  etiquetas: "Etiquetas",
  etiqueta: "Etiqueta",
  sinEtiqueta: "Sin etiqueta",
  nuevaEtiqueta: "Nueva etiqueta",
  agregarEtiqueta: "Añadir etiqueta",
  tipo: "Tipo",
  etiquetaPadre: "Etiqueta Padre",
  tipoPadre: "Tipo Padre",

  // FORM
  nombreEtiqueta: "Nombre Etiqueta",

  // SUBPRODUCTOS
  agregarSubproducto: "Añadir Materia prima",
  precioCompra: "Precio de compra",
  escandallo: "Escandallo",
  subproductosCreados: "Materia Primas Creadas",
  nuevaCategoria: "Nueva categoría",
  materiaPrima: "Materia prima",
  materiasPrimas: "Materias primas",

  // FORM
  nuevoProveedor: "Nuevo Proveedor",
  nombreSubproducto: "Nombre Materia prima",
  codigoBarra: "Código de barras",
  descripcion: "Descripción",
  tipoIva: "Tipo I.V.A.",
  cuotaIVA: "Cuota IVA",
  ivaIncluido: "(IVA incluido)",
  descuentoCompra: "Descuento compra",
  porcentaje: "(% Porcentaje)",
  guardarEnAlmacen: "Guardar en almacén",
  stockMinimo: "Stock mínimo",
  stockOptimo: "Stock óptimo",
  gastosPorProveedoresUnidos: "Gastos por proveedores unidos",
  caracteresRestantes: "Caracteres restantes",

  // INFORME SUBPRODUCTO
  referencia: "Referencia",
  uds: "Uds",
  iva: "IVA",
  importe: "Importe",
  imp: "Imp.",
  sinDto: "SIN DTO.",
  importeConIva: "Importe con IVA",
  importeSinIva: "Importe sin IVA",
  importeSinIvaDto: "Importe sin IVA con Dto",
  precioUdSinIva: "Precio / ud sin IVA",
  dto: "Dto",
  ttal: "Total",

  // PRODUCTOS
  producto: "Producto",
  precioDeCoste: "Precio de coste",
  tarifa1: "Tarifa 1",
  tarifa2: "Tarifa 2",
  tarifa3: "Tarifa 3",
  tarifa4: "Tarifa 4",
  agregarProductos: "Añadir producto",
  noHayProductosEnEsteNegocio: "No hay productos en este negocio",
  sinCategoria: "Sin Categoría",
  cliente: "Cliente",

  // FORM
  nombreProducto: "Nombre producto",
  codigoDeBarra: "Código de barras",
  colorBoton: "Color del botón",
  descuento: "Descuento",
  precioCoste: "Precio coste",
  opcionesAlSeleccionarElArticulo: "Opciones al seleccionar el producto",
  numeroDeOpcionales: "Número de materias primas opcionales",
  impresoraComandasTPV: "Impresora Comandas TPV",
  impresoraComandasPDA: "Impresora Comandas PDA",
  copiaImpresoraComandasTPV: "Copia Impresora Comandas TPV",
  copiaImpresoraComandasPDA: "Copia Impresora Comandas PDA",
  impresionPlano: "Impresora Plano ",
  impresionPlanoKDS: "Impresora Plano KDS",
  copiaImpresionPlano: "Copia Impresora Plano ",
  copiaImpresionPlanoKDS: "Copia Impresora Plano KDS",
  impresionPlano1: "Impresora Plano 1",
  impresionPlano2: "Impresora Plano 2",
  impresionPlano3: "Impresora Plano 3",
  impresionKDSTPV: "Enviar comanda desde TPV",
  impresionKDSPDA: "Enviar comanda desde PDA",
  copiaImpresionKDSTPV: "Copia comanda desde TPV",
  copiaImpresionKDSPDA: "Copia comanda desde PDA",
  pedirPrecio: "Pedir Precio",
  pedirPeso: "Pedir peso",
  pedirImporte: "Pedir Importe",
  promocionable: "Promocionable",
  mostrarPC: "Mostrar en PC",
  mostrarPDA: "Mostrar en PDA",
  noImprimir: "No Imprimir",
  numeroPlato: "Número de plato por defecto",
  seleccionIngredientes: "Activar selección de ingredientes",
  introduzcaDescripcion: "Introduzca descripción",
  introduzcaCodigoDeBarras: "Introduzca código de barras",
  introduzcaPrecioCoste: "Introduzca precio coste",
  opcion1: "Opción 1",
  opcion2: "Opción 2",
  opcion3: "Opción 3",
  opcion4: "Opción 4",
  opcion5: "Opción 5",
  numOpcionales: "Número de materias primas opcionales",

  // OPERARARIOS
  operarios: "Operarios",
  agregarOperario: "Añadir operario",
  apellido: "Apellido",
  nombreOperarios: "Nombre Operarios",
  pass: "Contraseña",
  salario: "Salario",
  passTurn: "Contraseña de turno",
  hombre: "Hombre",
  mujer: "Mujer",
  replicarProducto: "Replicar producto en otros negocios",
  introduzcaEscandallo: "Introduzca escandallo",
  introduzcaStockMinimo: "Introduzca stock mínimo",
  introduzcaStockOptimo: "Introduzca stock optimo",
  introduzcaPrecioCompra: "Introduzca precio compra",
  introduzcaApellido: "Introduzca apellido",
  introduzcaPass: "Introduzca Contraseña",
  introduzcaEmail: "Introduzca email",
  introduzcaSalario: "Introduzca salario",
  introduzcapassTurn: "Introduzca contraseña de turno",
  replicarOperario: "Replicar operario en otro negocio",
  TPV: "TPV",
  precioMed: "Precio Med.",
  precioMedSinIva: "Precio Med sin iva",
  porUnidad: "Por unidades",
  porImporte: "Por importe",
  contrasenya: "Contraseña PDA",
  repartidor: "Repartidor",
  buscaRepartidor: "buscaRepartidor",
  noMostrarEnVentas: "No mostrar en ventas",
  noHayOperariosEnEsteNegocio: "No hay operario en este negocio",
  VerDetalles: "Ver detalles",
  codigoTurno: "Código de turno",
  operarioDatosIncompletos: "Todos los campos son obligatorios",
  enviarQR: "Enviar QR de turnos",
  descargarTurnoQR: "Descargar PDF con QR de turnos",
  enviarEmailTurnoQR: " Enviar por email QR de turnos",
  emailEnviado: "El email se ha enviado correctamente",
  enviado: "Enviado",
  errorActualizar: "Error al actualizar el operario",
  errorEnviarEmail: "No se ha podido enviar el email",
  accesoDenegado: "Acceso Denegado",
  noTienesPermisosParaRealizar: "No tienes permisos para realizar esta acción",
  emailNoValido: "El email no tiene un formato válido",
  gestionTurnos: "Turnos por operario",
  gestionTurnosSubtitle: "Consulta y gestión de los fichajes de los operarios",
  gestionTurnosSubtitleConsulta: "Consulta y gestión",
  gestionTurnosSubtitleDeLos: "de los",
  gestionTurnosSubtitleFichajes: "fichajes",
  gestionTurnosSubtitleOperarios: "de los operarios",

  // CLIENTES
  clientes: "Clientes",
  companyia: "Campaña",
  agregarCliente: "Añadir cliente",
  nombreCliente: "Nombre cliente",
  saldo: "Saldo",
  infoCliente: "En el caso de utilizar tarjetas de saldo",
  tarifa: "Tarifa",
  descuentoImporte: "Descuento importe",
  noHayClientesEnEsteNegocio: "No hay clientes en este negocio",
  barCode: "Barcode",
  cuentaContableSocio: "Cuenta contable Socio",
  cuentaContableLevy: "Cuenta contable Levy",

  // IMPRESION
  impresionDeComandas: "Impresión de comandas",
  copiaDeImpresionDeComandas: "Copia de impresión de comandas",
  impresionPorPlana: "Impresión por plano",
  impresionPorKDS: "Impresión por KDS",
  monitorDeCocina: "Monitor de cocina",

  // INFORMES
  ventas: "Ventas",
  tarjetas: "Tarjetas",
  cheque: "Cheque",
  cambio: "Cambio",
  recuento: "Recuento",
  descuadre: "Descuadre",
  siguienteDia: "Siguiente día",
  incidencias: "Incidencias",
  recaudado: "Recaudado",
  noHayVentasEnEsteRangoDeFechas: "No hay ventas en este rango de fechas",
  tickets: "Tickets",
  factura: "Factura",
  noHayFormasDePagoEnEsteRangoDeFecha:
    "No hay formas de pago en este rango de fecha",
  desglose: "Desglose",
  sinBase: "Sin Base",
  base: "Base",
  baseTotal: "Base total",
  impuesto: "Impuesto",
  facturasEmitidas: "Facturas nominativas",
  mesa: "Mesa",
  cifnif: "CIF/NIF",
  cobro: "Cobro",
  noHayFacturasEmitidasEnEsteRangoDeFecha:
    "No hay facturas emitidas en este rango de fechas",
  estadisticasAgencias: "Estadisticas Agencias",
  agencia: "Agencia",
  comentario: "Comen.",
  noHayEstadisticasDeAgenciaEnEsteRangoDeFechas:
    "No hay estadisticas de agencias en este rango de fechas",
  desglosesImpuestos: "Impuestos por cierre de caja",
  desglosesImpuestosAgencia: "Impuestos por agencia",
  noHayFormasDePagoEnEsteRangoDeFechas:
    "No hay formas de pago en este rango de fechas",
  cuentasAparcadas: "Cuentas a crédito",
  operacion: "Operación",
  operario: "Operario",
  noExisteDesgloseImpuestos: "No existe desglose de impuestos.",
  noHayCuentasAparcadasEnEsteRangoDeFechas:
    "No hay cuentas a crédito en este rango de fechas",
  noHayCuentasAnuladasEnEsteRangoDeFechas:
    "No hay cuentas anuladas en este rango de fechas",
  cierreCaja: "Cierre caja",
  fechaCierre: "Fecha cierre",
  venta: "Venta",
  totalRecaudado: "Total recaudado",
  noHayCierresDeCajaEnEsteRangoDeFecha:
    "No hay cierres de caja eneste rango de fechas",
  cierreCajaZ: "Cierre de Caja Z",

  // MODAL
  n: "Nº.",
  apertura: "Apertura",
  cierre: "Cierre",
  totalVenta: "Total Venta",
  efectivo: "Efectivo",
  tarjetaCheques: "Tarj+Cheques",
  totalTeorico: "Total teórico",
  totalEnArqueo: "Total en arqueo",
  cambioSig: "Cambio sig",
  volver: "Volver",
  confirmacionImportacionHeader: "Confirmación de importación",
  confirmacionImportacionText: "¿Estás seguro de que quieres importar?",
  confirmar: "Confirmar",
  registros: "registros",
  headerError: "ERROR",
  bodyError: "Por favor, inserte un archivo con menos de 10.000 registros",
  en: "En ",

  // OPERARIOS
  ventasPorOperarios: "Cuentas cobradas por operario",
  invitaciones: "Invitaciones",
  horas: "Horas",
  sueldo: "Sueldo",
  categorias: "Categorías",

  // CLIENTES
  ventasPorClientes: "Ventas por cliente",
  companya: "Empresa",
  consumiciones: "Consumiciones",
  media: "Media",
  valorMedioDelTicket: "Valor medio del ticket",
  todosLosClientes: "Todos los clientes",
  todosLosOperarios: "Todos los operarios",
  operariosAplicar: "Operarios a los que se aplicará",
  rentabilidadInfo: "Precio medio menos el coste de sus materias primas (precio de coste del producto)",
  sinPrecioDeCoste: "Sin precio de coste: calcúlelo desde Herramientas o en la ficha del producto",
  buscarCliente: "Buscar cliente por nombre, código o CIF…",
  clientesConVentasEnElPeriodo: "con ventas en el periodo",
  noHayClientesConVentas: "No hay clientes con ventas en el periodo",
  ningunClienteCoincide: "Ningún cliente coincide con la búsqueda",
  seleccionados: "seleccionados",
  clientesSeleccionados: "clientes seleccionados",
  quitarFiltro: "Quitar filtro",
  deLosClientes: "de {total} clientes",
  buscarOperario: "Buscar operario...",
  ninguno: "Ninguno",
  mas: "más",
  ningunOperarioCoincide: "No hay operarios que coincidan",
  ningunOperario: "Ningún operario",
  deOperarios: "de {total} operarios",
  eligeAlMenosUnOperario: "Elige al menos un operario para aplicar las restricciones",
  mediaSesion: "Media sesión",

  // AGENCIAS
  noHayAgenciasEnEsteMomento: "No hay agencias en este momento",
  agencias: "Agencias",
  nombreAgencia: "Nombre agencia",
  comision: "Comisión",
  replicarAgencias: "Replicar agencia",
  agregarAgencias: "Añadir agencia",

  // MODIFICADORES
  nombreModificador: "Nombre modificador",
  grupos: "Grupos",
  variacion: "Variación",
  resta: "Resta",
  suma: "Suma",
  modificador: "Modificador",
  modificadores: "Modificadores",
  agregarModificador: "Añadir modificador",
  grupo: "Grupo",
  noHayModificadoresEnEsteNegocio: "No hay modificadores en este negocio",
  almacen: "Almacén",
  todos: "Todos",
  precioCompraConIva: "Precio compra CON IVA",
  precioCompraSinIva: "Precio compra SIN IVA",
  precioDescuentoSinIva: "Precio con descuento SIN IVA",
  codigoIdentificacion: "Código identificación",
  replicarModificador: "Replicar modificador",

  // SOPORTE ONLINE
  soporteOnline: "Soporte Online",
  soporteOnlineDetails: "Soporte Online - Detalles",
  abierto: "Abierto",
  esperandoRespuesta: "Esperando Respuesta",
  respondido: "Respondido",
  cerrado: "Cerrado",
  tecnico: "Técnico",
  comercial: "Comercial",
  facturacion: "Facturación",
  noTicketsEnNegocio: "No hay tickets en este negocio",
  responderTicket: "Responder ticket",
  mensaje: "Mensaje",
  cerrar: "Cerrar",
  enviarTicket: "Enviar Ticket",
  nuevoTicket: "Nuevo ticket",
  asunto: "Asunto",
  estado: "Estado",
  departamento: "Departamento",
  visitas: "Visitas",
  verTicket: "Ver ticket",
  tarjeta: "Tarjeta",

  // FORMAS DE PAGO
  nueva: "Nueva",
  replicarFormaDePago: "Replicar Forma de pago",
  nombreFormaPago: "Nombre forma de pago",
  formaDePago: "Forma de pago",
  formasDePago: "Formas de pago",
  agregarFormaDePago: "Añadir forma de pago",
  noHayFormasDePagoEnEsteNegocio: "No hay formas de pago en este negocio",
  nuevo: "Nuevo",
  renovado: "Renovado",

  // EDICIÓN MASIVA
  transferirProductosDeCategoria: "Transferir porductos de categoría",
  tranferir: "Transferir",
  impresionDeProductosDeCategorias: "Impresión de productos de categorías",
  impresoraComanda: "Impresora comanda",
  impresoraComandaTpv: "Impresora comanda TPV",
  impresoraComandaPda: "Impresora comanda PDA",
  copiaImpresionDeComanda: "Copia impresión de comandas",
  copiaImpresoraComandasTpv: "Copia impresora comandas TPV",
  copiaImpresoraComandasPda: "Copia impresora comandas PDA",
  impresionPorPlano: "Impresión por plano",
  enviarComandaDesdeTpv: "Enviar comanda desde TPV",
  enviarComandaDesdePda: "Enviar comanda desde PDA",
  respetarOtrasImpresiones: "¿Respetar otras impresiones?",
  cambioDePrecioProductos: "Cambio de precio productos",
  opcion: "Opción",
  tipoDeTarifa: "Tipo de tarifa",
  cambiarPrecio: "Cambiar precio",
  ajustes: "Ajustes",
  cambiarImpresionDeGrupo: "Cambiar impresión de grupo",
  tranferirProductosDeUnaCategoriaAOtra:
    "Transferir productos de una categoría a otra",
  cambiarPreciosAProductos: "Cambiar precios a productos",

  // WIDGETS
  consumoPorHoras: "Ventas por horas",
  productosMasVendidos: "Productos más vendidos",
  ultimosTickets: "Últimos tickets",
  verTodos: "Ver Todos",
  arqueoDeCaja: "Arqueo de Caja",
  cobrado: "Cobrado",

  cajaCerrada: "Caja Cerrada",
  licenciaCaducada: "Licencia Caducada",
  cajonInteligente: "Cajón inteligente",
  moneda: "Moneda",
  nivelReciclador: "Nivel Recicl.",
  totalReciclador: "Total Recicl.",
  nivelCasete: "Nivel Casete",
  totalCasete: "Total Casete",
  totalMonedas: "Total monedas",
  totalBilletes: "Total billetes",
  totalEnDirectoPorNegocio: "Ventas en directo por negocios/s",
  enCuenta: "En cuenta",
  cajaOnline: "Cajas Online",
  planoDeMesas: "Plano de mesas",
  planoDeTaquillas: "Plano de taquillas",
  nombrePlano: "Nombre plano",
  mesas: "Mesas",
  taquillas: "Taquillas",
  ocupacion: "Ocupación",
  enPlano: "En plano",
  desgloseTicket: "Desglose de ticket",
  precioMedio: "Precio medio",
  apuntado: "Apuntado",
  anulado: "Anulado",
  aparcado: "A crédito",
  indicencias: "Incidencias",
  filtrarOperario: "Filtrar operario",
  situacionActualDeLosNivelesDelCajonInteligente:
    "Situación actual de los niveles del cajón inteligente",
  verDetallesDeNiveles: "Ver detalles de niveles",
  noHayCajonInteligenteParaMostrar: "No hay cajón inteligente para mostrar",
  consulteConSuDistribuidor: "Consulte con su distribuidor",
  comparativaVentasAnteriores: "Comparativa ventas anteriores",
  graficaDeConsumoRespectoAHistoricoDeSesiones:
    "Gráfica de consumo respecto a histórico de sesiones",
  graficaDeConsumoAgrupadaPorTramosHorarios:
    "Gráfica de consumo agrupada por tramos",
  situacionActualDeOcupacionDeMesas: "Situación actual de ocupación de mesas",
  situacionActualDeOcupacionDeTaquillas:
    "Situación actual de ocupación de taquillas",
  verPlanoCompleto: "Ver plano completo",
  rankingDeLaSesionActual: "Ranking de la sesión actual",
  ultimosMovimientosDeLaCajaPorOperario:
    "Últimos movimientos de la caja por operario",
  estadoActualDeLaCaja: "Estado actual de la caja",
  turnosDeOperarios: "Turnos de operarios",
  relacionDeHorasTrabajadasYVentasRealizadasPorOperario:
    "Relación de horas trabajadas y ventas realizadas por operario",
  horarioInicio: "Hora inicio",
  horaFin: "Hora fin",
  horasTrabajadas: "Horas trabajadas",
  noHayTurnosDeOperarioParaMostrar: "No hay turnos de operarios para mostrar",
  propuestaDePedido: "Propuesta de pedido",
  pedidoAProveedor: "Pedido a proveedor",
  atencionHayMovimientosDeAlmacenQueNoSeHanDescargadoEnElNegocio:
    "Atención, hay movimientos de almacén que no se han descargado en el negocio",
  seleccionarNegocio: "Seleccionar negocio",
  seleccionarProveedor: "Seleccionar proveedor",
  generarPedidoEnBlanco: "Generar pedido en blanco",
  generarPedido: "Generar pedido",
  propuestaDePedidoA: "Propuesta de pedido a ",
  buscarMateriaPrimaEnElMismoProveedor:
    "Buscar materia prima en el mismo proveedor",
  precioIVAIncluido: "Precios IVA incluídos",
  ref: "Ref",
  nombre: "Nombre",
  existencias: "Existencias",
  pedido: "Pedido",
  precioArticuloUnidad: "Precio artículo / und",
  precioPedido: "Precio Pedido",
  sinIVA: "Sin IVA",
  porcentajeIVA: "% IVA",
  precioIVA: "Precio IVA",
  porcentajeDto: "% Dto",
  totalIVA: "Total IVA",
  observaciones: "Observaciones",
  noHaySubproductosEnEsteNegocioParaRealizarElPedido:
    "No hay subproductos en este negocio para realizar el pedido",
  recuerdeQueParaQueAparezcanLosSubproductosDebenDeEstarAsociadosAUnProveedorYConfiguradosElStockMinimoYStockOptimo:
    "Recuerde que para que aparezcan los subproductos deben de estar a sociados a un proveedor y configurados el stock mínimo y stock  óptimo",
  guardarPedido: "Guardar pedido",
  totalIVAInc: "Total IVA Inc.",
  pedidosAProveedor: "Pedido a proveedor",
  fechaInicio: "Fecha inicio",
  fechaFin: "Fecha fin",
  pedidosConvertidos: "Pedidos covertidos",
  nuevoPedido: "Nuevo pedido",
  enviarPedidos: "Enviar pedidos",
  convertido: "Convertido",
  convertirEnGasto: "Convertir en gasto",
  modificar: "Modificar",
  eliminar: "Eliminar",
  descargarComoPDF: "Descargar como PDF",
  descargarComoPDFSinPrecios: "Descargar como PDF sin precios",
  descargarComoExcel: "Descarcar como Excel",
  descargarComoExcelSinPrecios: "Descargar como excel sin precios",
  enviarPorCorreo: "Enviar por correo",
  eliminarListaCorreo: "Eliminar lista correo",
  anyadirListaCorreo: "Añadir lista correo",
  noHayPedidosAEsteProveedorEnEsteRangoDeFecha:
    "No hay pedidos a este proveedor en este rango de fecha",
  enviarPedido: "Enviar pedido",
  enviarPedidoA: "Enviar pedido a",
  formato: "Formato",
  PDF: "PDF",
  excel: "Excel",
  conPrecios: "Con precios",
  sinPrecios: "Sin precios",
  convertirPedido: "Convertir pedido",
  tipoDeDocumento: "Tipo de documento",
  albaran: "Albarán",
  generarEntradaEnAlmacenAlVerificar: "Generar entrada en almacén al verificar",
  gastosDeCasas: "Gastos de casas",
  gastosPorCasa: "Gastos por casa",
  noHayGastosPorCasasEnEsteRangoDeFechas:
    "No hay gastos por casas en este rango de fechas",
  ventasDeCategorias: "Ventas de categorías",
  ventasCategoriaDe: "Ventas categoría de ",
  volverAGeneral: "Volver a general",
  ventasDeProductos: "Ventas de productos",
  filtrarPorTPV: "Filtrar por TPV",
  filtrarTPV: "Filtrar TPV",
  turnosDe: "Turnos de ",
  enActivo: "En activo",
  ventasDeProductosDe: "Productos de cuentas cobradas por ",
  ignorarRecuentosNegativos: "Ignorar recuentos negativos",
  ventasOperarios: "Cuentas cobradas",
  costesDeProductos: "Costes de productos",
  totalImportesVentas: "Total Importes Ventas",
  totalCoste: "Total coste",
  costes: "Costes",
  costeUd: "Coste Ud",
  coste: "Coste",
  porcentajeCosto: "% Costo",
  varCostoMed: "Var. Costo Med.",
  listaDeInvitaciones: "Lista de invitaciones",
  valor: "Valor",
  volverALaLista: "Volver a la lista",
  ventasDeProductosGlobal: "Ventas de productos global",
  porUnidades: "Por unidades",
  gastosPorEtiquetas: "Gastos por etiquetas",
  desgloseDeGastos: "Desglose de gastos",
  referencias: "Referencias",
  concepto: "Concepto",
  gastosDeProveedores: "Gastos de proveedores",
  sinProveedor: "Sin Proveedor",
  sinCasas: "Sin casas",
  cierreDeCaja: "Cierre de caja",
  primerTicket: "Primer Ticket",
  ultimoTicket: "Último ticket",
  cheques: "Cheques",
  cambioSigDia: "Cambio sig. día",
  ventasPorAgencias: "Ventas por agencias",
  ventasPorFormasDePago: "Ventas por forma de pago",
  exportarComoHTML: "Exportar como HTML",
  pendiente: "Pendiente",
  gasto: "Gasto",
  desgloseDeImpuestos: "Desglose de impuestos",
  desgloseDelTicket: "Desglose del ticket",
  cuentasAnuladas: "Cuentas anuladas",
  buscarPorHoras: "Buscar por horas",
  buscarBaja: "Mostrar productos de baja",
  buscarSubProductoBaja: "Mostrar materias primas de baja",
  buscarCategoriasBaja: "Mostrar categorías de baja",
  buscarEtiquetasBaja: "Mostrar etiquetas de baja",
  mostrarClientesBaja: "Mostrar clientes de baja",
  deBaja: "de baja",
  mostrarVentasAcumuladasPorDia: "Mostrar ventas acumuladas por día",
  seleccionaUnTpv: "Debes seleccionar un TPV para ver sus detalles",
  deshabilitarCheckboxVentasAcumuladasPorDia:
    "Deshabilita el checkbox 'Mostrar ventas acumuladas por dia' para ver los detalles.",
  graficas: "Gráficas",
  dias: "Días",
  semanas: "Semanas",
  meses: "Meses",
  ventasPorComensales: "Ventas por comensales",
  numeroDeComensales: "Número de comensales",
  precioMedioPorComensal: "Precio medio por comensal",
  ventasPorRangosHorarios: "Ventas por rangos horarios",
  ops: "Ops",
  comensales: "Comensales",
  detalleDeOperaciones: "Detalle de operaciones",
  operaciones: "Operaciones",
  operacionMedia: "Operación media",
  detalleDeComensales: "Detalle de comensales",
  comensalMedio: "Comensal medio",
  noHayVentasEnLosRangosDeFechasDefinidos:
    "No hay ventas en los rangos de fechas definidos",
  transferencia: "Transferencia",
  domiciliacion: "Domiciliación",
  fechaGasto: "Fecha gasto",
  generarEntradaDeAlmacenAlVerificar: "Generar entrada de almacén al verificar",
  listaDeMateriaPrima: "Lista de materia prima",
  preciosIVAIncluido: "Precios IVA incluido",
  precioSinIVA: "Precio sin IVA",
  precioIVAInc: "Precio IVa inc",
  IVA: "IVA",
  totalBase: "Total base",
  totalDocumento: "Total documento",
  seleccioneUnaCasa: "Seleccione una casa",
  anyadirNuevoSubproducto: "Añadir nuevo subproducto",
  gestionDeGastos: "Gestión de gastos",
  deCaja: "De caja",
  fueraDeCaja: "Fuera de caja",
  contabilizado: "Contabilizado",
  si: "Si",
  no: "No",
  grafica: "Gráfica",
  lista: "Lista",
  avanzado: "Avanzado",
  noHayVentasDeProductosEnEsteRangoDeFechas:
    " No hay ventas de productos en este rango de fechas",
  historicoDeProductos: "Histórico de productos",
  volverA: "Volver a",
  general: "General",
  historialAlmacen: "Historial almacén",
  listadoDeExistencia: "Listado de existencia",
  listadoDeAlmacen: "Listado de Almacén",
  listadoHastaStockOptimo: "Listado hasta stock óptimo",
  listadoExistenciaBajoMinimo: "Listado existencia bajo mínimo",
  exportarValoracion: "Exportar valoración",
  importeDto: "Importe Dto",
  detalleDelSubproducto: "Detalle del subproducto",
  nombreNegocio: "Nombre negocio",
  noHaySubproductosConElMismoNombreEnTusOtrosNegocios:
    "No hay subproductos con el mismo nombre en tus otros negocios",
  detalleAlmacen: "Detalle almacén",
  entrada: "Entrada",
  inventario: "Inventario",
  salida: "Salida",
  valorDto: "Valor Dto.",
  noHayDatosEnEsteMovimientoDeAlmacen:
    "No hay datos en este movimiento de almacén",
  historial: "Historial",
  noHayMovimientoEnEstaMateriaPrima: "No hay movimiento en esta materia prima",
  dia: "Día",
  historialDeAlmacen: "Historial de almacén",
  inventarios: "Inventarios",
  entradas: "Entradas",
  salidas: "Salidas",
  completado: "Completado",
  verificado: "Verificado",
  descargado: "Descargado",
  diaActual: "Día actual",
  movimientos: "Movimientos",
  enEsteRangoDeFechas: "en este rango de fechas",
  rangosHorarios: "Rangos horarios",
  nuevoRangoHorario: "Nuevo rango horario",
  verUnInformeDeRangosHorarios: "Ver informe de rangos horarios",
  noHayRangosHorariosEnEsteNegocio: "No hay rangos horarios en este negocio",
  nombreRangosHorarios: "Nombre rangos horarios",
  vistaMosaico: "Vista mosaico",
  vistaLista: "Vista lista",
  ordenarProductos: "Ordenar productos",
  BAJA: "BAJA",
  frontalDeVenta: "Frontal de venta",
  agregarGasto: "Añadir gasto",
  entrAlmac: "Entr. Almac.",
  contab: "Contab",
  tranferencia: "Transferencia",
  verificar: "Verificar",
  entradaAlmacen: "Entrada de almacén",
  preciosIVAInluido: "Precios IVA Incluido",
  estaEntradaNoContieneNingunSubproducto:
    "Esta entrada no contiene ningún subproducto",
  cajasOnline: "Cajas online",
  minimo: "Mínimo",
  optimo: "Óptimo",
  posicionGlobal: "Posición global",
  empresa: "Empresa",
  todasLasEmpresas: "Todas las Empresas",
  ventasSinIVA: "Ventas sin IVA",
  neto: "Neto",
  fechaDeCumpleanyos: "Fecha de cumpleaños",
  recargoEquivalencia: "Recargo equivalencia",
  anyadirMateriaPrima: "Añadir Materia prima",
  partesT1: "Partes T1",
  partesT2: "Partes T2",
  partesT3: "Partes T3",
  partesT4: "Partes T4",
  costeDto: "Coste Dto",
  agregarMateriasPrimas: "Añadir Materias primas",
  frontalDeVentas: "Frontal de ventas",
  unidadesEnOtroNegocios: "Unidades en otros negocios",
  historialMateriaPrima: "Historial materia prima",

  borrarRangoHorario: "Borrar rango horario",
  detallesDeLaEntradaEnAlmacen: "Detalles de la entrada en almacén",
  desgloseHorasTrabajadas: "Desglose horas trabajadas",
  verProductosVendidos: "Ver productos vendidos",
  verTicketsDelProducto: "Ver tickets del producto",
  verTicketsDeEsasInvitaciones: "Ver tickets de esas invitaciones",
  verTicketsDeEsaAgencia: "Ver tickets de esa agencia",
  gastosPorMateriasPrimas: "Gastos por materias primas",
  alDarUnProductoDeBajaDesapareceEnElTPVParaSuVentaPeroSigueApareciendoEnLosInformesDeVenta:
    "Al dar un producto de baja desaparece en el TPV para su venta pero sigue apareciendo en los informes de venta",
  cuandoUnProductoEsDeTipoDescuentoSuPrecioSeDescuentaDelTotalDeLaCuenta:
    "Cuando un producto es de tipo descuento su precio se descuenta del total de la cuenta",
  alActivarEstaOpcionApareceLosIngredientesDelProductoParaSeleccionarlo:
    "Al activar esta opción aparece los ingredientes del producto para seleccionarlos",
  alActivarEstaOpcionPuedeSeleccionarElPrecioDelProductoAlMarcarlo:
    "Al activar esta opción puede seleccionar el precio del producto al marcarlo",
  alActivarEstaOpcionPuedeSeleccionarElPesoDelProductoAlMarcarlo:
    "Al activar esta opción puede seleccionar el peso del producto al marcarlo",
  alActivarEstaOpcionPuedeSeleccionarElImporteDelProductoAlMarcarlo:
    "Al activar esta opción puede seleccionar el importe del producto al marcarlo",
  alActivarEstaOpcionElProductoNoApareceraEnNumierTPV:
    "Al activar esta opción el producto no aparecerá en Numier TPV",
  alActivarEstaOpcionElProductoNoApareceraEnLaPda:
    "Al activar esta opción el producto no aparecerá en Numier PDA",
  alActivarEstaOpcionElProductoNoSeImprimiraEnElPendienteDeCobroNiEnLaFacturaSimplificada:
    "Al activar esta opción el producto no se imprimirá en el pendiente de cobro ni en la factura simplificada",
  guardarMateriaPrima: "Guardar materia prima",
  copiarMateriaPrima: "Copiar materia prima",
  seleccioneQueTipoDeMateriasPrimasQuiereCopiar:
    "Selecciones que tipo de materias primas quiere copiar",
  seleccioneAQueCategoriaQuiereCopiarLasMateriasPrimas:
    "Seleccione a que categorías quiere copiar las materias primas",
  copiaMateriaPrima: "Copia materia prima",
  notas: "Notas",
  pedidos: "Pedidos",
  atencionLaMediaSinContarLosDiasConVentas:
    "Atención: La media sin contar los días con ventas a 0€ es de: ",
  verDesgloseDeImpuestos: "Ver desglose de impuestos",
  verDetallesDetTicket: "Ver detalles del ticket",
  facturasNominativas: "Facturas nominativas",
  verDetallesDeGasto: "Ver detalles de gasto",
  desgloseDeGastosPorEtiquetasHijas: "Desglose de gastos por etiquetas hijas",
  procedencia: "Procedencia",
  suLicenciaDeNumierOnlineEstaAPuntoDeCaducar:
    "Su licencia de Numier Online está a punto de caducar",
  cajasOnlineTickets: "Cajas Online Tickets",
  cajasOnlineDetalles: "Cajas Online Detalles",
  cajasOnlinePlano: "Cajas Online Plano",
  cajasOnlineProductos: "Cajas Online Productos",
  transferir: "Transferir",
  herramientas: "Herramientas",
  ver: "Ver",
  detallesDeLaentradaEnAlmacen: "Detalles de la entrada en el almacén",
  ups: "Ups",
  laFechaDeInicioNoPuedeSerPosteriorALaDeFin:
    "La fecha de inicio no puede ser posterior a la de fin",
  exportarContabilidad: "Exportar contabilidad",

  seleccioneUnProveedor: "Seleccione un proveedor",
  detallesDelPedido: "Detalles del pedido",
  correoEnviadoCorrectamente: "Correo enviado correctamente",
  atencion: "Atención",
  debeIntroducirUnEmailParaEnviarElPedido:
    "Debe introducir un email para enviar el pedido",
  detalles: "Detalles",
  gastoVerificadoCorrectamente: "Gasto verificado correctamente",
  estasSeguroDeEliminarElPedido: "¿Estás seguro de eliminar el pedido?",

  // BUSINESS CENTRAL - MATERIAS PRIMAS
  noSeEncontraronMateriasPrimas: "No se encontraron materias primas",
  noSeEncontraronProductos: "No se encontraron productos",
  seleccionar: "Seleccionar",
  estado: "Estado",
  noDisponible: "No disponible",
  downgradedProducts: "Productos dados de baja",
  unknownProduct: "Producto desconocido",
  affectedRecipes: "Recetas afectadas",
  noRecipesAffected: "No hay recetas afectadas",
  detalle: "Detalle",
  noHayBajasQueMostrar: "No hay bajas para mostrar",
  resumenBajas: "Resumen de bajas",
  eliminado: "Eliminado",
  consultarTodo: "Consultar todo",
  desplegar: "Desplegar información",
  estaOperacionNoSePuedeDeshacer: "Esta operación no se puede deshacer",
  siEliminarPedido: "Sí, eliminar pedido",
  pedidoEliminadoCorrectamente: "Pedido eliminado correctamente",
  laReferenciaEsObligatoria: "La referencia es obligatoria",
  seleccioneLosNegociosParaHacerelPedido:
    "Seleccione los negocios para hacer el pedido",
  noTienesNingunNegocioAsignado: "No tienes ningún negocio asignado",
  noHayProveedoresEnEsteNegocio: "No hay proveedores en este negocio",
  cuentasRectificadas: "Facturas rectificativas",
  noHayCuentasRectificadasEnEsteRangoDeFechas:
    "No hay cuentas rectificadas en este rango de fechas",
  pedidosProveedor: "Pedidos proveedor",
  gestionDePersonal: "Gestión de personal",
  configuracionCarta: "Configuración carta",
  importacionExcels: "Importación Excels",
  carta: "Carta digital",
  camaras: "Cámaras",
  perfil: "Perfil",
  cerrarSesion: "Cerrar sesión",
  desarrolladoPorNexodoDigitalSL: "Desarrollado por Nexodo Digital S.L.",
  totalValores: "Total Valores",
  totalValoresDto: "Total Valores Dto.",
  totalValoresRecuento: "Total Valores de Recuento",
  ultimoInventario: "Último inventario",
  filtrarEntreInventarios: "Filtrar entre inventarios",
  ultInventario: "Ult. inventario",
  primerInventario: "Primer inventario",
  marcaDosInventariosParaVerLosDetallesEntreEllos:
    "Marca dos inventarios para ver los detalles entre ellos",
  salir: "Salir",
  anadirMovimientoAlmacen: "Añadir Movimiento Almacén",
  nuevoInventario: "Nuevo Inventario",
  tienesUnInventarioSinTerminarElDia:
    "Tienes un inventario sin terminar el día",
  pulseElBotonRealizarInventarioPara:
    "Pulse el botón 'Realizar inventario' para",
  volverARealizarlo: "volver a realizarlo",
  siDeseas: "Si deseas",
  comenzarElInventarioDeNuevo: "comenzar el inventario de nuevo",
  comaMarqueLaCasillaEliminarDatosDeInventarioActual:
    ", marque la casilla 'Eliminar datos de inventario actual'",
  eliminarDatosDelInventarioActual: "Eliminar datos del inventario actual",
  realizarInventario: "Realizar inventario",
  accesoDenegado: "Acceso denegado",
  soloPuedeComprobar2InventariosAlMismoTiempo:
    "Solo puede comprobar 2 inventarios al mismo tiempo",
  cargando: "Cargando...",
  configuracionAlmacen: "Configuración almacén",
  actualizada: "actualizada",
  correctamente: "correctamente",
  noSeAdmitenCamposEnBlanco: "No se admiten campos en blanco",
  todas: "Todas",
  categoriaClientes: "Categoría clientes",
  seleccionaCompania: "Selecciona compañía",
  agregarCategoriaDeClientes: "Agregar categoría de clientes",
  categoriaPadre: "Categoría Padre",
  elCampoNombreFiscalEsObligatorio: "El campo nombre fiscal es obligatorio",
  elCampoCifNifEsObligatorio: "El campo Cif Nif es obligatorio",
  datosActualizados: "Datos actualizados correctamente",
  elCampoNombreEsRequerido: "El campo nombre es requerido",
  creada: "creada",
  rangoHorario: "Rango horario ",
  soloPuedeCrearUnMaximoDeXRangosHorarios:
    "Solo puede crear un máximo de 12 rangos horarios",
  deAcuerdo: "De acuerdo",
  eliminado: "eliminado",
  deseaEliminarEsteRangoHorario: "¿Desea eliminar este rango horario",
  siBorrarRangoHorario: "Sí, borrar rango horario",
  ordenarProductosAlfabeticamente: "Ordenar productos alfabéticamente",
  ordenarMateriasPrimasAlfabeticamente:
    "Ordenar materias primas alfabéticamente",
  asignarImpresorasSeleccionadasEnBlanco:
    "Asignar impresoras seleccionadas en blanco",
  aplicarCambios: "Aplicar cambios",
  ordenarAlfabeticamenteProductos: "Ordenar alfabéticamente productos",
  ordenar: "Ordenar",
  ordenarAlfabeticamenteSubproductos: "Ordenar alfabéticamente subproductos",
  seleccioneElTipo: "Seleccione el tipo",
  impresionDeProductosEfectuadaCorrectamente:
    "Impresión de productos efectuada correctamente",
  tienesQueSeleccionarUnaCategoria: "Tienes que seleccionar una categoría",
  ningunaSeleccionada: "Ninguna seleccionada",
  transferenciaDeProductosEfectuadaCorrectamente:
    "Transferencia de productos efectuada correctamente",
  relleneLosCamposObligatorios: "Rellene los campos obligatorios",
  vistaFrontalTpv: "Vista frontal TPV",
  editarPrecios: "Editar precios",
  cancelarEdicion: "Cancelar edición",
  guardarOrden: "Guardar orden",
  bajaConBrackets: "[BAJA]",
  seleccionaUnaCategoria: "Selecciona una categoría...",
  cambiarImpresorasAProductos: "Cambiar impresoras a productos",
  igualar: "Igualar",
  sumar: "Sumar",
  restar: "Restar",
  multiplicar: "Multiplicar",
  todasLasTarifas: "Todas las tarifas",
  productosEditadosCorrectamente: "Productos editados correctamente",
  ordenActualizadoCorrectamente: "Orden actualizado correctamente",
  componentesDeVenta: "Componentes de venta",
  delNegocioAClientes: "del negocio a clientes",
  clasificacionDe: "Clasificación de",
  productosPorFamilia: "productos por familia",
  elementosQue: "Elementos que",
  varianALosProductos: "varian a los productos",
  paraLaComanda: "para la comanda",
  componentesComprados: "Componentes comprados",
  aProveedoresQueComponenProductos: "a proveedores que componen productos",
  empresas: "Empresas",
  proveedorasDeMateriasPrimasYServicios:
    "proveedoras de materias primas y/o servicios",
  alNegocio: "al negocio",
  fabricantesDeMateriasPrimas: "fabricantes de materias primas",
  aProveedores: "a proveedores",
  categoriasQueClasifican: "Categorías que clasifican",
  materiasPrimasYProveedores: "materias primas y proveedores",
  personalCon: "Personal con",
  acceso: "acceso",
  alSistema: "al sistema",
  baseDeDatosDe: "Base de datos de",
  consumidores: "consumidores",
  enElNegocio: "en el negocio",
  clasificacionDeLa: "Clasificación de la",
  deLasVentas: "de las ventas",
  metodosDeCobro: "Métodos de cobro",
  enElFrontalDeVenta: "en el frontal de venta",
  intervaloDeHorasParaConsultarVentas:
    "Intervalo de horas para consultar ventas",
  configurarAlmacén: "Configurar almacén",
  relacionDeMateriasPrimasParaLaConfiguracionDelAlmacen:
    "Relación de materias primas para la configuración del almacén",
  herramientasGenerales: "Herramientas generales",
  edicionMasiva: "Edición masiva",
  categoriasCarta: "Categorías carta",
  categoriaCarta: "categoría carta",
  orden: "Orden",
  editada: "editada",
  anadirCategoria: "Añadir categoría",
  esteNegocioNoTieneAccesoAEsteModulo:
    "Este negocio no tiene acceso a este módulo",
  paraMasInformacionContacteConSu: "Para más información contacte con su",
  distribuidor: "distribuidor",
  formasDePagoCarta: "Formas de pago carta",
  formaDePagoCarta: "forma de pago carta",
  informacionCarta: "Información carta",
  datosDelNegocio: "Datos del negocio",
  nombreMostrado: "Nombre mostrado",
  telefonoWhatsapp: "Teléfono WhatsApp",
  datosPedidos: "Datos pedidos",
  tiempoMedioDePreparacionRecogidaMin:
    "Tiempo medio de preparación recogida (min)",
  tiempoMedioDePreparacionDomicilioMin:
    "Tiempo medio de preparación domicilio (min)",
  gastosDeEnvio: "Gastos de envío",
  pedidoMinimo: "Pedido mínimo",
  interfaz: "Interfaz",
  textoEntrega: "Texto entrega",
  textoPresentacion: "Texto presentación",
  textoFormasDePago: "Texto formas de pago",
  textoHorarios: "Texto horarios",
  datosGuardadosCorrectamente: "Datos guardados correctamente",
  materiasPrimasCarta: "Materias primas carta",
  materiaPrimaCarta: "materia prima carta",
  referenciaMateriasPrimasTpv: "Referencia materias primas Tpv",
  nombreDeLaMateriaPrimaEnElTpv: "Nombre de la materia prima en el tpv",
  disponible: "Disponible",
  replicarMateriaPrima: "Replicar materia prima",
  replicarMateriasPrimas: "Replicar materias primas",
  nombreTpv: "Nombre Tpv",
  noDisponible: "No disponible",
  replicarTodasLasMateriasPrimas: "Replicar todas las materias primas",
  estasSeguroDeReplicarTodasLasMateriasPrimasALosNegociosSeleccionados:
    "¿Estás seguro de replicar todas las materias primas a los negocios seleccionados?",
  estaAccionNoSePuedeDeshacer: "¡Esta acción no se puede deshacer!",
  siReplicar: "Sí, replicar",
  productosCarta: "Productos carta",
  productoCarta: "producto carta",
  referenciaProductoTpv: "Referencia producto Tpv",
  nombreDelProductoEnElTpv: "Nombre del producto en el tpv",
  seleccionaCategoria: "Selecciona categoría",
  edicionRapida: "Edición rápida",
  supraCategoria: "SupraCategoría",
  supraCategoriaObligatoria: "Debes seleccionar una SupraCategoría antes de poder guardar este producto.",
  seleccionaTipo: "Selecciona tipo",
  nIngredientesSinCosto: "Nº ingredientes sin costo",
  maximoExtras: "Máximo extras",
  alergenos: "Alérgenos",
  nombreTarifa1: "Nombre tarifa 1",
  precioTarifa1: "Precio tarifa 1",
  nombreTarifa2: "Nombre tarifa 2",
  precioTarifa2: "Precio tarifa 2",
  nombreTarifa3: "Nombre tarifa 3",
  precioTarifa3: "Precio tarifa 3",
  nombreTarifa4: "Nombre tarifa 4",
  precioTarifa4: "Precio tarifa 4",
  imagen: "Imagen",
  copiarMateriasPrimas: "Copiar materias primas",
  basico: "Básico",
  buscarNombreDeLaMateriaPrima: "Buscar nombre de la materia prima",
  seleccionaTipoPunto: "Selecciona tipo...",
  bases: "Bases",
  opcionales: "Opcionales",
  extras: "Extras",
  cereales: "Cereales",
  crustaceos: "Crustáceos",
  huevos: "Huevos",
  pescado: "Pescado",
  cacahuetes: "Cacahuetes",
  soja: "Soja",
  leche: "Leche",
  frutosDeCascara: "Frutos de cáscara",
  apio: "Apio",
  mostaza: "Mostaza",
  granosDeSesamo: "Granos de sésamo",
  dioxidoDeAzufre: "Dióxido de azufre",
  altramuces: "Altramuces",
  moluscos: "Moluscos",
  cartaASecas: "Carta",
  extra: "Extra",
  opcional: "Opcional",

  estreProcesoBorraraLasMateriasPrimasActualesEnLasCategoriasSeleeccionadasDeLosTiposElegidos:
    "Este proceso borrara las materias primas actuales en las categorías seleccionadas de los tipos elegidos",
  aceptarProceso: "Aceptar proceso",
  necesitasMarcarAlMenosUnTipoYUnaCategoria:
    "Necesitas marcar al menos un tipo y una categoría",
  materiaPrimaCopiadaCorrectamente: "Materia prima copiada correctamente",
  editado: "editado",
  agregada: "agregada",
  relacion: "Relación",
  noPuedeHaberDosMateriasPrimasConElMismoTipo:
    "No puede haber dos materias primas con el mismo tipo",
  estasSeguroDeBorrarLaMateriaPrima:
    "¿Estás seguro de borrar la materia prima?",
  siDeseoBorrarlo: "Sí, deseo borrarlo",
  seleccionaUnaCarta: "Selecciona una carta",
  replicarProductos: "Replicar productos",
  verCarta: "Ver carta",
  verPedido: "Ver pedido",
  verQR: "Ver QR",
  nombreEnTpv: "Nombre en tpv",
  cartaYPedido: "Carta y Pedido",
  replicarTodosLosProductos: "Replicar todos los productos",
  editarImagen: "Editar imagen",
  esteNegocioNoContieneNingunaCarta: "Este negocio no contiene ninguna carta",
  estasSeguroDeReplicarTodosLosProductosALosNegociosSeleccionados:
    "¿Estás seguro de replicar todas los productos a los negocios seleccionados?",
  sustanciasQue: "Sustancias que",
  componenALosProductos: "componen a los productos",
  informacionAcercaDel: "Información acerca del",
  negocioMinuscula: "negocio",
  actualizarPedidos: "Actualizar pedidos",
  pendienteDeConfirmacion: "Pendiente de confirmación",
  confirmados: "Confirmados",
  enPreparacion: "En preparación",
  finalizados: "Finalizados",
  recogida: "Recogida",
  domicilio: "Domicilio",
  noHayPedidosPendientesDeConfirmacion:
    "No hay pedidos pendientes de confirmación",
  noHayPedidosConfirmados: "No hay pedidos confirmados",
  noHayPedidosEnPreparacion: "No hay pedidos en preparación",
  noHayPedidosTerminados: "No hay pedidos terminados",
  siBorrarPedido: "Sí, borrar pedido",
  estasSeguroDeSuspenderElServicioEnMesas:
    "¿Estás seguro de suspender el servicio en mesas?",
  siSuspendeElServicioEnMesasNoEntraranMasPedidosEnMesaHastaActivarloDeNuevo:
    "Si suspende el servicio en mesas, no entrarán más pedidos en mesa hasta activarlo de nuevo",
  siSuspenderElServicioEnMesa: "Sí, suspender el servicio en mesa",
  estasSeguroDeActivarElServicioEnMesas:
    "¿Estás seguro de activar el servicio en mesas?",
  siActivaElServicioDeMesasVolveranAEntrarPedidosDeMesa:
    "Si activa el servicio de mesas, volverán a entrar pedidos de mesa",
  siActivarElServicioEnMesa: "Sí, activar el servicio en mesa",
  estasSeguroDeSuspenderElServicio: "¿Estás seguro de suspender el servicio?",
  siSuspendeElServicioNoEntraranMasPedidosHastaActivarloDeNuevo:
    "Si suspende el servicio, no entrarán más pedidos hasta activarlo de nuevo",
  siSuspenderElServicio: "Sí, suspender el servicio",
  estasSeguroDeActivarElServicio: "¿Estás seguro de activar el servicio?",
  siActivaElServicioVolveranAEntrarPedidos:
    "Si activa el servicio, volverán a entrar pedidos",
  siActivarElServicio: "Sí, activar el servicio",
  pedidoAceptadoCorrectamente: "Pedido aceptado correctamente",
  pedidoEnPreparacion: "Pedido en preparación",
  pedidoFinalizado: "Pedido finalizado",
  pedidoArchivado: "Pedido archivado",
  servicioActualizadoCorrectamente: "Servicio actualizado correctamente",
  estasSeguroDeEditarLaObservacion: "¿Estás seguro de editar la observación?",
  siEditarObservacion: "Sí, editar observación",
  mesasActivadas: "MESAS⠀ACTIVADAS⠀",
  mesasDesactivadas: "MESAS⠀DESACTIVADAS⠀",
  crearNuevoProveedor: "Crear nuevo proveedor",
  crearMateriaPrima: "Crear Materia Prima",
  eliminarMateriaPrima: "Eliminar Materia Prima",
  sinCasaAsignada: "Sin casa asignada",
  buscarPorRefONombreDeLaMateriaPrima:
    "Buscar por Ref. o Nombre de la materia prima",
  mensajePorcentajeCompraDisminuido:
    "El precio ha disminuido del porcentaje de compra establecido",

  seleccioneEtiqueta: "Seleccione etiqueta...",
  unidadesStockMinimo: "Unidades stock mínimo",
  partesStockMinimo: "Partes stock mínimo",
  anadirProveedor: "Añadir proveedor",
  amarillo: "amarillo",
  cajas: "Cajas",
  botellas: "Botellas",
  barriles: "Barriles",
  palets: "Palets",
  bolsas: "Bolsas",
  litros: "Litros",
  rollos: "Rollos",
  visualizar: "Visualizar",
  sinCasa: "Sin casa",
  elProveedorEsObligatorio: "El proveedor es obligatorio",
  laFechaEsObligatoria: "La fecha es obligatoria",
  hayUnaMateriaPrimaSinUnidades: "Hay una materia prima sin unidades",
  hayUnaMateriaPrimaSinPrecio: "Hay una materia prima sin precio",
  guardandoGasto: "Guardando gasto...",
  actualizado: "actualizado",
  creado: "creado",
  laLongitudDelNombreNoPuedeSerMayorDe:
    "La longitud del nombre no puede ser mayor de ",
  relleneTodosLosDatosMarcadosConAsteriscoAntesDeEnviar:
    "Rellene todos los datos marcados con * antes de enviar",
  seleccionaProveedor: "Selecciona proveedor...",
  filtrarPorFecha: "Filtrar por fecha",
  convertirAlbaranes: "Convertir albaranes",
  cancelarConversion: "Cancelar conversión",
  convertir: "Convertir",
  convertirAlbaranEnFactura: "Convertir albarán en factura",
  refFactura: "Ref factura",
  albaranesDeLaFactura: "Albaranes de la factura",
  finalizada: "finalizada",
  conversion: "Conversión",
  error: "Error",
  estaSeguroDeVerificarEsteGasto: "¿Está seguro de verificar este gasto?",
  siVerficarGasto: "Sí, verificar gasto",
  estasSeguroDeEliminarElGasto: "¿Estás seguro de eliminar el gasto?",
  siEliminarGasto: "Sí, eliminar gasto",
  contabilizadoCambiadoCorrectamente: "Contabilizado cambiado correctamente",
  gastoEliminadoCorrectamente: "Gasto eliminado correctamente",
  hacerInventario: "Hacer inventario",
  seleccionarTodas: "Seleccionar Todas",
  inventarioRealizadoCorrectamente: "Inventario realizado correctamente",
  traspaso: "Traspaso",
  negocioDeDestino: "Negocio de destino",
  referenciaNecesaria: "Referencia necesaria",
  elMovimientoDeAlmacenTieneQueTenerAsignadoUnProductoOProductos:
    "El movimiento de almacén tiene que tener asignado un producto o productos",
  realizado: "realizado",
  enviarInventario: "Enviar inventario",
  volverAlAlmacen: "Volver al almacén",
  inventarioCompletado: "Inventario completado",
  inventarioNoEncontrado: "Inventario no encontrado",
  cargandoInventario: "Cargando inventario",
  inventarioExcluidosTitulo: "Hay materias primas que no se contabilizan en este inventario",
  inventarioExcluidosTexto: "Su código está repetido, así que no se puede saber a qué materia prima corresponde la cantidad. No aparecerán para contar hasta que se corrija el código.",
  inventarioExcluidoCodigoCompartido: "El código {codigo} lo comparten {total} materias primas activas.",
  inventarioExcluidoLineaDuplicada: "El código {codigo} aparece {total} veces en este inventario.",
  importacion: "Importación",
  importar: "Importar",
  tienesQueSeleccionarUnArchivoDeImportacion:
    "Tienes que seleccionar un archivo de importación",
  importandoVentasDelNegocio: "Importando ventas del negocio...",
  nuevosProductos: "Nuevos Productos",
  seHanCreadoLosSiguientesProductos: "Se han creado los siguientes productos",
  importandoMovimientosDeAlmacen: "Importando movimientos de almacén...",

  seleccionaCasa: "Selecciona casa...",
  desgloseDeVentasPorProductos: "Desglose de ventas por productos",
  noTienesPermisoParaVisualizarEsteInforme:
    "No tienes permiso para visualizar este informe",
  historicoVentasPorCliente: "Histórico ventas por cliente",
  buscarPorNombreDelCliente: "Buscar por nombre del cliente",
  importeSinDto: "Importe sin Dto.",
  seleccioneUnClienteValido: "Seleccione un cliente válido",
  seleccioneUnNegocioParaVerLosTickets:
    "Seleccione un negocio para ver los tickets",
  ventasDeCategoriasPorClientes: "Ventas de categorías por clientes",
  desgloseDeVentasDeLaCategoria: "Desglose de ventas de la categoría",
  verImporteEnCategoriasHijas: "Ver importe en categorias hijas",
  gestionDePedidos: "Gestión de pedidos",
  cargandoGastos: "Cargando gastos...",
  cargandoDatos: "Cargando Datos",
  tiempoMedioCocina: "Tiempo medio cocina",
  nComandas: "Nº Comandas",
  eliminada: "eliminada",
  tiempoMedio: "Tiempo medio",
  noHayComandasEnviadasAlKdsEnEsteRangoDeFechas:
    "No hay comandas enviadas al kds en este rango de fechas",
  tiempoMedioProducto: "Tiempo medio producto",
  nProductos: "Nº Productos",
  informePersonalizado: "Informe Personalizado",
  nombreDelDispositivo: "Nombre del dispositivo",
  dispositivo: "Dispositivo",
  registrosHorarios: "Registros horarios",
  marshallEjecutadoCorrectamente: "Marshall ejecutado correctamente",
  mes: "Mes",
  seleccionaUnaSemana: "Selecciona una semana",
  seleccioneUnaFechaValida: "Seleccione una fecha válida",
  noMayuscula: "NO",
  siMayuscula: "SI",
  editarObservacion: "Editar observación",
  anadirObservacion: "Añadir observación",
  editarHoraInicioYHoraFin: "Editar hora inicio y hora fin",
  verLocalizacionEnMapa: "Ver localización en mapa",
  noSeHaEncontradoLocalizacion: "No se ha encontrado localización",
  inicioJornada: "Jornada iniciada",
  finJornada: "Jornada finalizada",
  geolocalizacionJornada: "Geolocalización de la jornada",
  editarHorario: "Editar horario",
  editarHorarioDeTurno: "Editar horario de turno",
  observacion: "Observación",
  turnosOperarios: "Turnos operarios",
  compartirEnlaceTurnos: "Compartir enlace de turnos",
  hazClicConsultar: "Haga clic en el botón Consultar para realizar la búsqueda.",
  calculo: "Cálculo",
  alMinuto: "Al minuto",
  redondear: "Redondear",
  alSegundo: "Al segundo",
  horaCompleta: "Hora completa",
  haciaArriba30m: "Hacia arriba (30m)",
  haciaArriba45m: "Hacia arriba (45m)",
  verInfoCalculos: "Ver información de cálculos",
  infoCalculoTurnosTitulo: "Información sobre el Cálculo de Turnos",
  infoCalculoIntroP1: "El sistema permite calcular el tiempo y el sueldo de tres formas. Cuando se aplica un redondeo,",
  infoCalculoIntroDestacado: "el tiempo real trabajado aparecerá siempre entre paréntesis y en color gris",
  infoCalculoAlMinutoTitulo: "1. Al minuto",
  infoCalculoAlMinutoDesc: "Descarta los segundos. Si un operario trabaja 1h 30m 45s, se contabiliza como",
  infoCalculoAlMinutoSueldo: "El sueldo se calcula exactamente sobre esos minutos.",
  infoCalculoRedondearTitulo: "2. Redondear",
  infoCalculoRedondearDesc: "Ajusta el tiempo según la regla seleccionada:",
  infoCalculoHoraCompletaDesc: "No cuenta los minutos. Si trabaja 1h 55m, se paga",
  infoCalculoHaciaArribaDesc: "Si los minutos superan el umbral, redondea a la hora siguiente.",
  infoCalculoRedondearNota: "* El sueldo se calculará sobre este tiempo ya redondeado.",
  infoCalculoAlSegundoTitulo: "3. Al segundo",
  infoCalculoAlSegundoDesc1: "Máxima precisión. Contabiliza el tiempo exacto (ej.",
  infoCalculoAlSegundoDesc2: ") y el sueldo incluye hasta el último céntimo generado por esos segundos.",
  enlaceGeneradoExito: "Enlace generado correctamente",
  enlaceCopiadoAlPortapapeles: "Enlace copiado al portapapeles",
  enlaceExternoTurnosTitle: "Enlace externo para consulta de turnos",
  enlaceExternoTurnosLabel:
    "A través de este enlace podrás consultar los turnos de los operarios. Caducará en 24 horas.",
  errorComunicacionBackend: "Error de comunicación con el servidor.",
  errorNoSeHaPodidoGenerarElEnlace:
    "Lo sentimos, no se ha podido generar el enlace, inténtalo de nuevo",
  enlaceExternoTurnosOperariosTitle: "Turnos de operarios de ",
  enlaceExternoTurnosCaducadoTitle: "El enlace ha caducado",
  enlaceExternoTurnosCaducadoLabel:
    "Para consultar los turnos de los operarios, contacte con el administrador del negocio para que vuelva a generar un nuevo enlace.",
  ventasDeProductosMinusculas: "ventas de productos",
  pedidosGuionPasarelaDePago: "Pedidos - Pasarela de Pago",
  numPedidos: "Num.Pedidos",
  costoPorPedido: "Costo por pedido",
  totalComisiones: "Total Comisiones",
  totalSinComisiones: "Total sin comisiones",
  errorEnLaPeticion: "Error en la petición",
  rentabilidad: "Rentabilidad",
  buscarPorNombreDelRepartidor: "Buscar por nombre del repartidor",
  verDesgloseDeTarifas: "Ver Desglose de tarifas",
  ventasPorMeses: "Ventas por meses",
  ventasHoras: "Ventas horas",
  ventasPorHorasYMesas: "Ventas por horas y mesas",
  tarifasDelProducto: "Tarifas del producto",
  cantidad: "Cantidad",
  fechaDesde: "Fecha desde",
  fechaHasta: "Fecha hasta",
  seleccionaProcedencia: "Selecciona procedencia...",
  verDesgloseFacturas: "Ver desglose facturas",
  verDesgloseMateriasPrimas: "Ver desglose materias primas",
  seleccionaUnaEtiqueta: "Selecciona una etiqueta",
  buscarPorNombreDeLaMateriaPrima: "Buscar por nombre de la materia prima",
  ventasDeMateriasPrimas: "Ventas de materias primas",
  seleccionaTpv: "Selecciona TPV...",
  deVentas: "de ventas",
  totalComision: "Total comisión",
  totalSinComision: "Total sin comisión",
  desgloseFacturas: "Desglose facturas",
  facturasDelProveedor: "Facturas del proveedor",
  retiradas: "Retiradas",
  buscarTicket: "Buscar ticket...",
  baseMayusculas: "BASE",
  numServ: "Num. Serv.",
  ticketMed: "Ticket Med.",
  necesitasElegirUnTpvParaPoderVerLosDetallesDeEste:
    "Necesitas elegir un TPV para poder ver los detalles de este",
  ventasMinusculas: "ventas",
  totales: "Totales",
  noTienesNingunRangoDeFechaCreadoDeseasCrearUnRangoDeFecha:
    "No tienes ningun rango de fecha creado. ¿Deseas crear un rango de fecha?",
  siCrearUnRangoHorario: "Sí, crear un rango horario",
  detalleDe: "Detalle de ",
  cierresDeCaja: "cierres de caja",
  ventasNegocioPorZonaHoraria: "Ventas negocio por zona horaria",
  porZonaHoraria: " por zona horaria",
  detalleDeVentasSegun: "Detalle de ventas según",
  comensalesMinuscula: " comensales",
  desgloseDe: "Desglose de ",
  ticketsCobrados: "tickets cobrados",
  segunTipoDeIVA: "según tipo de IVA",
  facturasEmitidas: "Facturas emitidas",
  aClientes: " a clientes",
  desgloseDeVentasSegun: "Desglose de ventas según ",
  formasDePagoMinusculas: "formas de pago",
  agenciasMinusculas: "agencias",
  cuentasACredito: "cuentas a crédito",
  sumatorioDe: "Sumatorio de ",
  impuestos: "impuestos",
  porFechas: " por fechas",
  cuentasAnuladasMinusculas: "cuentas anuladas",
  delNegocio: " del negocio",
  cuentasRectificadas: "Facturas rectificativas",
  cuentasRectificadasMinusculas: "facturas rectificativas",
  retiradasMinusculas: "retiradas",
  ventaDeProductosPorNegocio: "Ventas de productos por negocio",
  rankingDe: "Ranking de",
  costeDeProductos: "Coste de productos",
  margenDeCostes: "Margen de costes",
  segunVentasPorRangoDeFecha: "según ventas por rango de fecha",
  historicoDeProducto: "Historico de producto",
  rankingAgrupadoDe: "Ranking agrupado de",
  enTodosLosNegocios: "en todos los negocios",
  ventasDeCategoriasPorNegocio: "Ventas de categorías por negocio",
  agrupacionDe: "Agrupación de",
  ventasDeCategoriasMinusculas: "ventas de categorías minúsculas",
  deProductos: "de productos",
  invitacionesMinusculas: "invitaciones",
  ventasPorMateriasPrimas: "Ventas por materias primas",
  ventasDeMateriasPrimasMinusculas: "ventas de materias primas",
  comprasDeMateriasPrimas: "compras de materias primas",
  porRangoDeFecha: "por rango de fecha",
  comprasAProveedores: "compras a proveedores",
  comprasAUnProveedor: "compras a un proveedor",
  porRangoDeFechaEn: "por rango de fecha en",
  todosLosNegocios: "todos los negocios",
  comprasAgrupadasPorEtiquetas: "compras agrupadas por etiquetas",
  comprasAFabricantes: "compras a fabricantes",
  comprasAUnFabricante: "compras a un fabricante",
  ranking: "Ranking",
  detallesDe: "Detalles de",
  turnos: "turnos",
  ventasPorClientesPlural: "Ventas por cliente",
  deVentasPorClientes: "de ventas por cliente",
  consultaDeVentasPorCliente: "Consulta de ventas por cliente",
  historico: "Histórico",
  deVentasPorCliente: "de ventas por cliente",
  numierPedidos: "Numier Pedidos",
  informeDePasarelaDePago: "Informe de Pasarela de Pago",
  desgloseDiarioDeLosPagosATraves: "Desglose diario de los pagos a través",
  pasarelaDePagoStripe: "Pasarela de pago Stripe",
  clicParaMasInformacion: "Clic para más información",
  cantidadMinusculas: "cantidad",
  totalMinusculas: "total",
  tarjetaYCheques: "Tarjeta y cheques",
  seleccionaOperario: "Selecciona operario...",
  necesitasSeleccionarUnProveedorParaPoderHacerUnPedido:
    "Necesitas seleccionar un proveedor para poder hacer un pedido",
  estePedidoNoEsValido: "Este pedido no es válido",
  quieresRestablecerElPedido: "¿Quieres restablecer el pedido?",
  siRestablecerPedido: "Sí, restablecer pedido",
  datosPersonales: "Datos Personales",
  datosDeAcceso: "Datos de Acceso",
  contrasenaAntigua: "Contraseña Antigua",
  contrasenaNueva: "Contraseña Nueva",
  confirmarContrasena: "Confirmar Contraseña",
  quieresDarDeAltaUnUsuario: "¿Quieres dar de alta un usuario?",
  quieresDarDeBajaUnUsuario: "¿Quieres dar de baja un usuario?",
  licencias: "Licencias",
  fechaCaducidad: "Fecha caducidad",
  ilimitado: "ILIMITADO",
  lasContrasenasNoCoinciden: "Las contraseñas no coinciden",
  seleccionaUsuario: "Selecciona usuario...",
  usuario: "Usuario",
  negocios: "Negocios",
  balance: "Balance",

  teHaParecidoUtilEsteArticulo: "¿Te ha parecido útil este artículo?",
  graciasPorTuOpinion: "Gracias por tu opinión",
  asignarTurno: "Asignar turno",
  vacaciones: "Vacaciones",
  descargarPDF: "Descargar PDF",
  enviarHorario: "Enviar Horario",
  incidenciasEnElMes: "incidencias en el mes",
  diasDeVacacionesEnElMes: "días de vacaciones en el mes",
  diasDeVacacionesEnElAno: "días de vacaciones en el año",
  nuevoTurno: "Nuevo turno",
  clonarTurno: "Clonar turno",
  nombreDelTurno: "Nombre del turno",
  diasDeLaSemana: "Días de la semana",
  editarTurno: "Editar turno",
  borrarTurno: "Borrar turno",
  evento: "Evento",
  nombreEvento: "Nombre evento",
  hayUnaIncidenciaEnEsteTurno: "Hay una incidencia en este turno",
  fechaInicioTurno: "Fecha inicio turno",
  fechaFinTurno: "Fecha fin turno",
  numHorasTurno: "Nº horas turno",
  fechaInicioTrabajada: "Fecha inicio trabajada",
  fechaFinTrabajada: "Fecha fin trabajada",
  numHorasTrabajadas: "Nº horas trabajadas",
  noIniciado: "No iniciado",
  noFinalizado: "No finalizado",
  fechaInicioVacaciones: "Fecha inicio vacaciones",
  fechaFinVacaciones: "Fecha fin vacaciones",
  turnoHorario: "Turno horario",
  nombreTurno: "Nombre turno",
  campoRequerido: "Campo requerido",
  introduzcaLosDiasDeLaSemana: "Introduzca los días de la semana",
  crearTurnoHorarioDeOperario: "Crear turno horario de operario",
  introduzcaLosOperarios: "Introduzca los operarios",
  laboral: "Laboral",
  vacacional: "Vacacional",
  seleccionaTurno: "Selecciona turno...",
  seleccionaLosNegociosALosQueQuiereClonarElTurno:
    "Selecciona los negocios a los que quiere clonar el turno",
  seleccionaLaFechaEnLaQueDeseasCopiarLosHorarios:
    "Selecciona la fecha en la que deseas copiar los horarios",
  seleccioneUnaSemana: "Seleccione una semana",
  lunes: "Lunes",
  martes: "Martes",
  miercoles: "Miércoles",
  jueves: "Jueves",
  viernes: "Viernes",
  sabado: "Sábado",
  domingo: "Domingo",
  laFechaSeleccionadaNoEsValida: "La fecha seleccionada no es válida",
  turnoClonadoCorrectamente: "Turno clonado correctamente",
  correoEnviadoCorrectamente: "Correo enviado correctamente",
  estasSeguroDeBorrarElTurnoSeleccionado:
    "¿Estás seguro de borrar el turno seleccionado",
  siBorrarTurno: "Sí, borrar turno",
  necesitasCrearAlgunTurnoParaPoderCrearCuadrantes:
    "Necesitas crear algún turno para poder crear cuadrantes",
  estasSeguroDeEditarElTurno: "¿Estás seguro de editar el turno?",
  siEditarTurno: "Sí, editar turno",
  hoy: "Hoy",
  turno: "Turno",
  turnoBorradoCorrectamente: "Turno borrado correctamente",
  informacion: "Información",
  elDiaNoCorrespondeConLaConfiguracionDelTurnoElegido:
    "El día no corresponde con la configuración del turno elegido",
  turnoCopiadoCorrectamente: "Turno copiado correctamente",
  turnoDeOperarioAgregadoCorrectamente:
    "Turno de operario agregado correctamente",
  turnoDeOperarioEliminadoCorrectamente:
    "Turno de operario eliminado correctamente",
  turnoDeOperarioEditadoCorrectamente:
    "Turno de operario editado correctamente",
  tecnicoConsultasTecnicasIncidencias:
    "Técnico (Consultas técnicas, Incidencias...)",
  comercialActivacionDeProductosInformacionServicios:
    "Comercial (Activación de productos, Información, Servicios...)",
  administracionFacturacionReclamaciones:
    "Administración (Facturación, Reclamaciones...)",
  elAsuntoEsObligatorio: "El asunto es obligatorio",
  elMensajeEsObligatorio: "El mensaje es obligatorio",
  soporteOnlineEnviadoCorrectamente: "SoporteOnline enviado correctamente",
  todosLosNegociosMayusculas: "Todos los negocios",
  recordarMisDatos: "Recordar mis datos",
  paraCualquierIncidenciaOMasInformacionPuedePonerseEnContactoConNosotros:
    "Para cualquier incidencia o más información puede ponerse en contacto con nosotros",
  iniciarSesion: "Iniciar sesión",
  haOlvidadoSuContrasena: "¿Ha olvidado su contraseña?",
  haHabidoUnErrorAlConectarPruebeDeNuevo:
    "Ha habido un error al conectar. Pruebe de nuevo",
  elEmailNoPuedeEstarEnBlanco: "El email no puede estar en blanco",
  elEmailNoEsValido: "El email no es válido",
  laContrasenaNoPuedeEstarEnBlanco: "La contraseña no puede estar en blanco",
  estaPaginaNoSeEncuentraEnElSistema:
    "Esta página no se encuentra en el sistema",
  volverAlInicio: "Volver a inicio",
  obtenerContrasena: "Obtener contraseña",
  disculpeLasMolestiasEstamosDeMantenimiento:
    "Disculpe las molestias, estamos de mantenimiento",
  funcionEnMantenimiento: "Función en mantenimiento",
  getDataCompanyMantenimiento: "Esta función se encuentra temporalmente en mantenimiento. Disculpe las molestias.",
  vuelvaAIntentarloMasTarde: "Vuelva a intentarlo más tarde",
  acepto: "Acepto",
  categoriasDeClientes: "Categorías de clientes",
  categoriaDeCliente: "categoría de cliente",
  nombreCategoria: "Nombre categoría",
  noSeleccionada: "No seleccionada",
  cobradoMayusculas: "COBRADO",
  envioProgramadoPara: "Envío programado para",
  eliminarPedido: "Eliminar pedido",
  aceptarPedido: "Aceptar pedido",
  pedidoConfirmado: "Pedido confirmado",
  archivarPedido: "Archivar pedido",
  detallesPedido: "Detalles pedido",
  nota: "Nota",
  precioUd: "Precio Ud",
  gratis: "GRATIS",
  guardarYAceptarPedido: "Guardar y aceptar pedido",
  seleccionaGrupo: "Selecciona grupo...",
  todosMayusculas: "TODOS",
  nombreOperario: "Nombre operario",
  apellidos: "Apellidos",
  claveAcceso: "Clave acceso",
  codigoDeTurnos: "Código de turnos",
  claveAccesoPDA: "Clave acceso PDA",
  seleccionaIVA: "Selecciona IVA",
  calcularCostoAPartirDeMateriasPrimas:
    "Calcular costo a partir de materias primas",
  seleccionaImpresoraDeComandasTPV: "Selecciona impresora de comandas TPV",
  seleccionaImpresoraDeComandasPDA: "Selecciona impresora de comandas PDA",
  buscarMateriaPrima: "Buscar materia prima",
  buscarProducto: "Buscar producto",
  nuevaMateriaPrima: "Nueva materia prima",
  ordenarSubproductos: "Ordenar subproductos",
  seleccionaEtiqueta: "Selecciona etiqueta...",
  clonarProducto: "Clonar producto",
  clonarProductoCarta: "Clonar producto",
  buscarSinPuntos: "Buscar",
  sinProveedores: "Sin proveedores",
  agregadas: "agregadas",
  modificadas: "modificadas",
  materiaPrimaEliminadaCorrectamente: "Materia prima eliminada correctamente",
  asociacion: "asociación",
  materiaPrimaOrdenadaCorrectamente: "Materia prima ordenada correctamente",
  productosCopiadosCorrectamente: "Productos copiados correctamente",
  menuCopiadoCorrectamente: "Menú copiado correctamente",
  responder: "Responder",
  administracion: "Administración",
  soporteTecnico: "Soporte técnico",
  horaInicioMayusculas: "Hora Inicio",
  horaFinal: "Hora Final",
  personaDeContacto: "Persona de contacto",
  motivoVisita: "Motivo visita",
  servicioBajoMantenimiento: "Servicio bajo mantenimiento",
  desplazamiento: "Desplazamiento",
  ticketEnviadoCorrectamente: "Ticket enviado correctamente",
  precioCompraConDescuento: "Precio compra con descuento",
  introduzcaLasPartesDelStockMinimo: "Introduzca las partes del stock mínimo",
  actualizarStockMinimoYOptimo: "Actualizar stock mínimo y óptimo",
  subproductoDeVerdad: "Subproducto",
  entregado: "Entregado",
  retirada: "Retirada",
  subtotal: "Subtotal",
  pagosACuenta: "Pagos a cuenta",
  horaDeApertura: "Hora de apertura",
  horaInicio: "Hora inicio",

  condicionesDeNumierOnline: "Condiciones de Numier Online",
  descripcionDelServicio: "Descripcion del Servicio",
  terminosIntroduccionParte1:
    "El servicio en la nube de Numier ofrecido por NEXODO DIGITAL S.L. (apartir de ahora NEXODO), facilita a sus clientes el acceso online a la información actualizada de sus negocios.",
  terminosIntroduccionParte2:
    "Para ello, las aplicaciones de punto de venta de Numier enviarán a través de internet detalles de las ventas realizadas y otro tipo de información que pueda ser interesante para sus clientes.",
  terminosIntroduccionParte3:
    "El acceso a este servicio se realizará a través de la página web https://www.numier.com/clientes, donde podrá consultar la información enviada por sus puntos de venta.",
  terminosIntroduccionParte4:
    "NEXODO reserva el derecho de mejorar, modificar o anular el servicio en cualquier momento.",
  politicaDePrivacidad: "Política de privacidad",
  privacidadParte1:
    "1. NEXODO ha realizado la siguiente declaración de privacidad con el objetivo de manifestar su firme propósito de proteger su privacidad. NEXODO le ruega que lea atentamente esta política de privacidad antes de utilizar este servicio ya que ello implica que NEXODO recopile y procese sus datos personales de acuerdo a esta política. NEXODO se reserva el derecho a modificar en cualquier momento la política de privacidad. En ese caso NEXODO se compromete a ponerse en contacto con usted para informarle de las modificaciones que le afecten.",
  privacidadParte2:
    "2. NEXODO respeta sus opciones de privacidad. En el caso de que nos proporcione alguna información se tratará de acuerdo a esta política.",
  privacidadParte3:
    "3. NEXODO le recomienda discreción a la hora de proporcionar información a operadores o propietarios del sitio. Es importante que tenga en cuenta que proporcionar información personal en lugares de acceso público, como salas de chat implica que cualquier persona con acceso a internet pueda disponer de su información. Le recomendamos que no introduzca ninguna información que no desee que otros puedan ver en estas zonas públicas.",
  privacidadParte4:
    "4. Si decide registrarse en NUMIER ONLINE es posible que deba aportar datos personales. Es importante que registre correctamente la información en la fecha de registro. Si su información personal cambia tras haber efectuado el registro deberá cambiarla o actualizarla inmediatamente. De no hacerlo es posible que no reciba algún servicio o información de NEXODO.",
  privacidadParte5:
    "5. NEXODO puede utilizar su información personal con la finalidad de realizar mejoras en este sitio.",
  privacidadParte6:
    "6. NEXODO recopila estos datos con la finalidad de obtener información para mejorar sus servicios y sus productos. Y es posible que utilicemos la información que nos ha proporcionado para enviarle ofertas por correo electrónico o postal que puedan ser de su interés.",
  privacidadParte7:
    "7. Para anular su suscripción a dichos correos deberá ponerse en contacto con NEXODO para informar de su decisión. De otro modo NEXODO mantendrá la información del usuario hasta el momento en que la suscripción sea anulada o hasta el vencimiento de cualquier período necesario descrito en la normativa vigente.",
  privacidadParte8:
    "8. NEXODO no revelará sus datos a ningún tercero sin su consentimiento, a menos que pensemos de buena fe que la ley lo requiere.",
  privacidadParte9:
    "9. Tiene la posibilidad de anular la totalidad de los datos de su suscripción que figuren en nuestra base de datos. Para ello deberá ponerse en contacto con la empresa y realizar su solicitud.",
  privacidadParte10:
    "10. 10. NEXODO ha tomado medidas para garantizar que la información sólo estará disponible para el usuario que introdujo la información en un principio. ",
  privacidadParte11:
    "11. Sólo se puede acceder a la información una vez se haya introducido la contraseña.",
  privacidadParte12:
    "12. Este sitio puede contener enlaces a otros sitios que no están asociados con NEXODO. Estos sitios tienen sus propias políticas de privacidad de las que NEXODO no se hace responsable. El acceso a estos sitios vinculados se realiza bajo su exclusiva responsabilidad.",
  privacidadParte13:
    "13. NEXODO garantiza la seguridad de la información referente a sus usuarios exceptuando los casos que se describen a continuación:",
  privacidadParte13dos: "- Si NEXODO dispone de su consentimiento.",
  privacidadParte13tres:
    "- Si se insta a NEXODO a proporcionar dicha información por indicación legal, requerimiento judicial u otro procedimiento jurídico.",
  privacidadParte13cuatro:
    "- Si la revelación de estos datos es necesaria para proteger los derechos y la propiedad de NEXODO.",
  privacidadParte13cinco:
    "- Si la revelación de información de sus datos es necesaria para mejorar los servicios y productos de nuestros clientes, incluido usted.",
  privacidadParte14:
    "14. NEXODO garantiza el mantenimiento adecuado de su información en un servidor seguro y encriptado al que sólo puedan acceder terceros autorizados. ",

  cartaDigital: "Carta digital",
  horarios: "Horarios",
  zonas: "Zonas",
  modificarHorariosDeLaCarta: "Modificar horarios de la carta",
  modificarZonasDeLaCarta: "Modificar zonas de la carta",
  diaDeLaSemana: "Día de la semana",
  esteNegocioNoTieneCarta: "Este negocio no tiene carta",
  tipoDeEnvio: "Tipo de envío",
  nuevoHorario: "Nuevo horario",
  elCampoDiaDeLaSemanaEsRequerido: "El campo día de la semana es requerido",
  borrarHorario: "Borrar horario",
  laHoraInicioNoPuedeSerMayorQueLaHoraFin:
    "La hora inicio no puede ser mayor que la hora fin",
  noHayHorariosEnEsteNegocio: "No hay horarios en este negocio",
  deseaEliminarEsteHorario: "¿Desea eliminar este horario?",
  siBorrarHorario: "Sí, borrar horario",
  seleccioneDiaDeLaSemana: "Seleccione día de la semana",
  seleccioneTipoDeEnvio: "Selecciones tipo de envío",

  importacionSage: "Importación Sage",
  importacionContable: "Importación contable",
  enlaceContable: "Enlace contable",
  ejercicio: "Ejercicio",
  codigoEmpresa: "Codigo Empresa",
  asiento: "Asiento",
  cargoAbono: "Cargo Abono",
  codigoCuenta: "Codigo Cuenta",
  fechaAsiento: "Fecha Asiento",
  comentario: "Comentario",
  importeAsiento: "Importe Asiento",
  numeroPeriodo: "Número Periodo",
  delegacion: "Delegación",
  canal: "Canal",
  ejercicioFactura: "Ejercicio Factura",
  serie: "Serie",
  factura: "Factura",
  suFacturaNo: "Su Factura No",
  fechaFactura: "Fecha Factura",
  importeFactura: "Importe Factura",
  tipoFactura: "Tipo Factura",
  codigoCuentaFactura: "Código Cuenta Factura",
  codigoRetencion: "Código Retención",
  baseRetencion: "Base Retención",
  porRetencion: "Por Retención",
  importeRetención: "Importe Retención",
  baselva1: "Baselva 1",
  porlva1: "Porlva 1",
  cuotaIva1: "Cuota IVA 1",
  porRecargoEquivalencia1: "Por Recargo Equivalencia 1",
  recargoEquivalencia1: "Recargo Equivalencia 1",
  codigoTransaccion1: "Código Transacción 1",
  descargarComoTxt: "Descargar como .txt",

  noHayAsientosContablesEnEsteTpvEnEsteRangoDeFecha:
    "No hay asientos contables en este tpv con este rango de fecha",
  cargandoAsientosContables: "Cargando asientos contables",
  fechaDeAperturaDeCaja: "Fecha de apertura de caja",
  fechaDeCierreDeCaja: "Fecha de cierre de caja",
  descargarVentas: "Descargar ventas",
  descargarGastos: "Descargar gastos",
  noHasCerradoEstaCaja: "No has cerrado esta caja",
  numeroDeCierres: "Número de cierres",
  introduzcaElUltimoNumeroDeAsientoContableQueTieneEnSAGE:
    "Introduzca el ultimo número de asiento contable que tiene en SAGE",
  porFavorRelleneElAsientoContable: "Por favor, rellene el asiento contable",
  descargar: "Descargar",
  elAsientoContableDebeSerUnNumero: "El asiento contable debe ser un número",
  elAsientoContableNoPuedeSerMayorA10Digitos:
    "El asiento contable no puede ser mayor a 10 dígitos",
  TengaEnCuentaQueUtilizaremosLosSiguientesNumerosAEsteParaCompletarLosDatos:
    "Tenga en cuenta que utilizaremos los siguientes números a este para completar los datos",
  noExistenVentasEsteDia: "No existen ventas este día",
  noExistenGastosEsteDia: "No existen gastos este día",
  enSage: "en SAGE",
  proyecto: "Proyecto",
  codigoEmpresaHelp:
    "Recuerda que el dato empresa se comparte entre todos los negocios de la misma empresa",
  cuentasDelTpvSeleccionado: "Cuentas del TPV seleccionado",
  nuevaCuenta: "Nueva cuenta",
  nombreDeCuenta: "Nombre de cuenta",
  codigoCuentaMinuscula: "Código cuenta",
  tipoDeCuenta: "Tipo de cuenta",
  noHayCuentasCreadasConElTpvSeleccionado:
    "No hay cuentas creadas con el TPV seleccionado",
  crearNuevaCuenta: "Crear nueva cuenta",
  codigoDeLaCuenta: "Código de la cuenta",
  codigoDeLaSubcuenta: "Código de la sub cuenta",
  configuracionCuentasIva: "Configuración cuentas IVA",
  configuracionCuentasEspeciales: "Configuración cuentas especiales",
  cuenta: "Cuenta",
  subcuenta: "Sub cuenta",
  editarCuenta: "Editar cuenta",
  sage200: "SAGE 200",
  exportarCAPTE: "Exportar CAPTE",
  losCamposNombreCodigoDeCuentaYCodigoDeSubcuentaDebenEstarRellenos:
    "Los campos nombre, código de cuenta y código de subcuenta deben estar rellenos",
  estaSeguroDeQueDeseaEliminarEstaCuenta:
    "¿Está seguro de que desea eliminar esta cuenta?",
  siBorrarCuenta: "Sí, borrar cuenta",
  cuentaEditadaCorrectamente: "Cuenta editada correctamente",
  cuentaCreadaCorrectamente: "Cuenta creada correctamente",
  configuracionSAGE: "Configuración Sage",
  sinCuentaAsociada: "Sin cuenta asociada",
  loSientoSuNegocioNoTieneContratadoSAGE:
    "Lo sentimos, su negocio no tiene contratado SAGE",
  loSientoSuNegocioNoTieneContratadoEsteModulo:
    "Lo sentimos, su negocio no tiene contratado este módulo",
  paraMasInformacionContacteConComerciales:
    "Para más información contacte con comerciales",
  laLongitudMaximaDeLasSubCuentas:
    "La longitud máxima de la sub cuenta tiene que ser de 12 caracteres",

  preparados: "Preparados",
  enReparto: "En reparto",
  noHayPedidosPreparados: "No hay pedidos preparados",
  noHayPedidosEnReparto: "No hay pedidos en reparto",
  pedidoListo: "Pedido listo",
  pedidoEnReparto: "Pedido en reparto",

  codigo: "Código",
  crearNuevoCodigoCuenta: "Crear nuevo código cuenta",
  editarNuevoCodigoCuenta: "Editar nuevo código cuenta",
  seleccioneUnaFormaDePagoParaElGasto:
    "Seleccione una forma de pago para el gasto",
  hasSeleccionadoAlbaranesConDiferentesFormasDePagoPorFavorSeleccioneUna:
    "Has seleccionado albaranes con diferentes formas de pago, por favor seleccione una",
  seleccioneUnaFormaDePago: "Seleccione una forma de pago",
  zonasActualizadasCorrectamente: "Zonas actualizadas correctamente",
  zonaCreadaCorrectamente: "Zona creada correctamente",
  zonaEditadaCorrectamente: "Zona editada correctamente",
  guardarCambios: "Guardar cambios",
  laZonaNoPuedeTenerElNombreEnBlanco:
    "La zona no puede tener el nombre en blanco",
  zonasDeReparto: "Zonas de reparto",
  editarZona: "Editar zona",
  color: "Color",
  costeDeReparto: "Coste de reparto",
  pedidoMinimo: "Pedido mínimo",
  crearNuevaZona: "Crear nueva zona",
  estasSeguroDeQueQuieresEliminarLaZona:
    "¿Estás seguro de que quieres eliminar la zona?",
  estaZonaDejaraDeEstarDisponibleInmediatamenteYNoSePodranHacerPedidos:
    "Esta zona dejará de estar disponible inmediatamente y no se harán pedidos desde la misma",
  siEliminarZona: "Sí, eliminar zona",
  zonaEliminadaCorrectamente: "Zona eliminada correctamente",
  ventasExportadas: "Ventas exportadas",
  gastosExportados: "Gastos exportados",
  todosLosCierresDeEsteDiaHanSidoExportados:
    "Todos los cierres de este día han sido exportados",
  faltanVentasPorExportarEsteDia: "Faltan ventas por exportar este día",
  todosLosGastosDeEsteDiaHanSidoExportados:
    "Todos los gastos de este día han sido exportados",
  faltanGastosPorExportarEsteDia: "Faltan gastos por exportar este día",
  exportar: "Exportar",

  // 10-02-2021
  otros: "Otros",
  restriccionHorarios: "Restricción Horarios",
  restriccionHorariosDesc:
    "Restringir algunas franjas horarias(cerrado, lleno, no reparto...)",
  borrar: "Borrar",
  restriccion: "Restricción",
  nMaximoPedidos: "Nº Máximo de pedidos",
  cerrarFranja: "Cerrar franja",
  limitePedidos: "Límite Nº Pedidos",
  loSentimosSuNegocioNoTieneContratadoEsteModulo:
    "Lo sentimos, su negocio no tiene contratado este módulo",
  numeroPedidosPermitidos: "Número de pedidos permitidos",
  estaSeguroDeQueDeseaEliminarEstaRestriccion:
    "¿Está seguro de que desea eliminar esta restricción?",
  siBorrarRestriccion: "Sí, borrar restricción",
  loSentimosParaAccederAEsteModuloNecesitaActivarLaConfiguracion:
    "Lo sentimos, para acceder a este módulo necesita activar la configuración",
  costeSinIVA: "Coste sin IVA",

  // 11.3.2021
  importeIVA: "Importe IVA",

  // 17.3.2021
  pasarAPreparacion: "Pasar a preparación",
  pasarAPreparados: "Pasar a preparados",
  pasarAEnReparto: "Pasar a en reparto",
  finalizarPedido: "Finalizar pedido",

  // Tener en cuidado con los espacios, ya que son los espacios Braille
  domicilioActivado: "‏‏‎DOMICILIO⠀ACTIVADO",
  domicilioDesactivado: "DOMICILIO⠀DESACTIVADO",
  recogerActivado: "RECOGER⠀ACTIVADO",
  recogerDesactivado: "RECOGER⠀DESACTIVADO",

  conDetalles: "con detalles",
  zonasRepartoActivadas: "ACTIVADAS⠀",
  zonasRepartoDesactivadas: "DESACTIVADAS⠀",
  siEliminarCategoria: "Sí, eliminar categoría",
  confirmaEliminarCategoria:
    "¿Está seguro de que quiere eliminar esta categoría?",
  pedidoPreparado: "Pedido preparado",
  configuracionParaLaImportacionExportacionDeDatosDeSage:
    "Configuración para la importación/exportación de datos de Sage",
  enEstaPantallaSeConfiguranLosCodigosDeLasCuentas:
    "En esta pantalla se configuran los códigos de las cuentas",
  formadosPor3Digitos: "formados por 3 dígitos",
  estosSonNecesariosParaConfigurarLasCuentasContables:
    "Estos son necesarios para configurar las cuentas contables",
  alEditarUnCodigoRelacionadoConUnaCuentaContableYaExistente:
    "Al editar un código relacionado con una cuenta contable ya existente",
  todoCambioQueSeProduzcaSobreEsteAfectaraTambienALaPropiaCuenta:
    "todo cambio que se produzca sobre este afectará también a la propia cuenta",
  aContinuacionSeListaranLasCuentasDeTipo:
    "A continuación se listarán las cuentas de tipo",
  gastoMinuscula: "gasto",
  paraQue: "para que",
  asocieMinuscula: "asocie",
  ventaMinuscula: "venta",
  unaParaSuPosterior: "una para su posterior",
  relacionEnSage: "relación en SAGE",
  relacionEnContabilidad: "relación en contabilidad",
  seleccioneUnaCuenta: "Seleccione una cuenta",
  aDomicilio: "A domicilio",
  aRecoger: "A recoger",
  tipoDeZona: "Tipo de zona",
  seleccioneUnTipo: "Seleccione un tipo",
  kilometrosDelArea: "Kms del área",
  codigoEmpleado: "Codigo empleado",
  exportarReservas: "Exportar reservas",
  importacionSinqro: "Importación Sinqro",
  configuracionParaLaImportacionDeDatosDeSinqro:
    "Configuración para la importación de datos de Sinqro",
  pasarelaDePago: "Pasarela de pago",
  importeSinDescuento: "Importe sin descuento",
  desactivarZona: "Desactivar zona",
  activa: "ACTIVA",
  inactiva: "INACTIVA",
  exportarPdfConMateriasPrimasAsociadas:
    "Exportar PDF con materias primas asociadas",
  exportarExcelConMateriasPrimasAsociadas:
    "Exportar Excel con materias primas asociadas",

  // Pedidos archivados 18/05/21
  informePedidosDetalle: "Desglose de pedidos",
  informePedidos: "Informe de pedidos",
  tipoPago: "Forma de pago",
  tipoPedido: "Tipo de pedido",
  domicilio: "Envio a domicilio",
  recoger: "Recogida en local",
  pagoLocal: "Pago en local",
  otro: "Otro",

  // 25/05/2021
  configuracionTurnos: "Configuración turnos",

  // 2021/05/20
  estasSeguroDeImportarTusProductosASinqro:
    "¿Desea importar sus productos a Sinqro?",
  esteProcesoPuedeTardarVariosMinutos:
    "Este proceso puede tardar varios minutos.",
  siImportarConSinqro: "Sí, importar a Sinqro",
  estasSeguroDeDarDeBajaElProducto: "¿Desea dar de baja el producto?",
  podraDarloDeAltaEnUnFuturo: "Podrá darlo de alta en un futuro",
  siDarDeBaja: "Sí, dar de baja",
  estasSeguroDeDarDeAltaElProducto: "¿Desea dar de alta el producto?",
  podraDarloDeBajaEnUnFuturo: "Podrá darlo de baja en un futuro.",
  siDarDeAlta: "Sí, dar de alta",
  laImportacionTardara:
    "Importando... este proceso puede tardar varios minutos",
  importacionFinalizada: "Importación completada con exito",
  completo: "Completado",
  vale: "Vale",
  importarSinqro: "Importar Sinqro",
  importandoProductos:
    "La importación se está llevando a cabo en estos momentos...",
  generandoCarta: "Un momento, por favor. Estamos generando su carta.",
  procesoFin: "El proceso se ha completado con éxito",
  procesoCompletado: "Proceso completado",
  yaFaltaPoco: "Ya falta poco...",
  estamosEnEllo:
    "Estamos trabajando en la importacion. Por favor, no recargue el navegador. ",
  finProgres: "El progreso terminó con exito.",
  textoInfo: "Esta columna muestra el precio de compra sin IVA",
  textoInfoImporteDTO:
    "Esta columna muestra el precio total de compra con descuento (el cual se calcula a partir del precio sin IVA)",
  correosEnviados: "Correos enviados",
  correosEnviadosCorrectamente: "Los correos se enviaron correctamente.",
  errorAlEnviar: "Error al enviar",
  noSePudieronEnviarTodosLosCorreos: "No se pudieron enviar todos los correos:",
  errorInesperadoEnvioCorreos:
    "Ocurrió un error inesperado. Por favor, inténtelo de nuevo más tarde",

  // 07/06/2021
  valorRecuento: "Valor Recuento",

  // 08/06/2021
  obligatorioEmail: "Obligatorio rellenar email",
  datosCliente: "Datos cliente",

  // 11/06/2021
  recuerdeQueElHacerCobrosAvanzadosPuedeGenerarPequenosDescuadres:
    "Recuerde que el hacer cobros avanzados puede generar pequeños descuadres",
  yQue: "y que",
  losDescuentosDeLasVentasEstanAlCeroPorcientoDeIva:
    "los descuentos de las ventas estan al 0% de IVA",

  // 16/06/2021
  totalValoresNegativos: "Total Valores Negativos",
  solamenteSeTieneEnCuentaValoresPositivos:
    "Solamente se tiene en cuenta valores positivos",
  totalValoresDiferencia: "Total Valores Diferencia",
  totalValoresDiferenciaDto: "Total Valores Diferecia Dto.",
  valorDiferencia: "Valor diferencia",
  valorDifereciaDto: "Valor diferencia dto.",
  precioDto: "Precio Dto.",

  // 24/06/2021
  exportarMateriasPrimasAsociadasAEsteProducto:
    "Exportar materias primas asociadas a este producto",
  sinIVA: "Sin IVA",
  errorAlIntentarObtenerLosTpvs: "Error al intentar obtener los TPVs",

  // 01/07/2021
  deseaguardarelproductoencarta:
    "A continuación, se procederá a replicar los nombres y los precios de las tarifas que sean mayor a 0€, asi como el campo baja. Estos cambios afectarán a todos los productos de NumierPEDIDOS, que estén relacionados con este producto.",
  leidoyacepto: "¡Lo entiendo!",
  replicarencarta: "¿Estás seguro?",
  aceptarreplicarencarta: "Aceptar y replicar en carta",
  guardaryreplicar: "Guardar y replicar en Carta",

  // Modal seleccionar categoría al crear en carta
  enlazarACategoria: "Enlazar a una categoría",
  deseaEnlazarProductoCategoria: "¿Desea enlazar el nuevo producto a una categoría existente en la carta?",
  categoria: "Categoría",
  seleccionarCategoria: "Seleccionar categoría",
  omitirYCrear: "Crear sin enlazar",
  aceptarYAgregar: "Aceptar y agregar",

  // 01/07/2021
  porRangosHorarios: " por rangos horarios",

  // 22/07/2021
  recuerdeQueLasLineasDeDescuentoNoSeSumanAlTotal:
    "Recuerde que las líneas de descuento no se suman al total",

  // 16/07/21
  destacado: "Destacado",
  sugerido: "Sugerido",

  // 23/07/2021
  totalSinDescuento: "Total sin descuento",

  // MENÚS
  menus: "Menús",
  descripcionMenus: "Grupo de productos que se venden de forma conjunta",
  numeroDePlatos:
    "Número de platos que el cliente podrá elegir por cada plato:",
  platosTip1: "En esta pantalla se pueden crear los distintos platos que",
  platosTip2:
    "componen el menú para su posterior asignación con los productos.",
  productosPlatosTip:
    "En esta pantalla se pueden relacionar platos y productos para su posterior visualización en la carta.",
  plato: "Plato",
  platos: "Platos",
  primerPlato: "Primer plato",
  segundoPlato: "Segundo plato",
  tercerPlato: "Tercer plato",
  cuartoPlato: "Cuarto plato",
  quintoPlato: "Quinto plato",
  sextoPlato: "Sexto plato",
  seleccionaUnPlato: "Selecciona un plato",
  noPuedeDejarEnBlancoElNombreDeUnPlato:
    "No puede dejar en blanco el nombre de un plato",
  estaSeguroDeQueQuiereBorrarEstePlato:
    "¿Está seguro de que quiere borrar este plato?",
  seBorraranTodasLasAsociacionesDeProductosConElMismo:
    "Se borrarán todas las asociaciones de productos con el mismo",
  siEstoySeguro: "Sí, estoy seguro",
  estaSeguroDeQueQuiereDesvincularEsteProductoDelPlatoSeleccionado:
    "¿Está seguro de que quiere desvincular este producto del plato seleccionado?",
  dejaraDeFormarParteDelMenuDeFormaInstantanea:
    "Dejará de formar parte del menú de forma instantánea",
  noMostrarSuelto: "No mostrar suelto (sólo disponible en menús)",
  clonarMenu: "Clonar menú",
  // 29/07/2021
  totalPedidosDevueltos: "Nº de devoluciones",
  totalImportesDevueltos: "Total importe devuelto",

  // 06/08/2021
  NoMostrarRecargasSaldo: "No mostrar recargas de saldo",
  // 10/08/2021
  noMostrarDescuento: "No mostrar descuentos",
  // 17/08/2021
  operarioApertura: "Operario apertura",
  aperturasPorOperarios: "Cuentas abiertas por operario",
  aperturasPorOperariosMinuscula: "cuentas abiertas por operario",
  aperturasOperarios: "Cuentas abiertas",
  productosPorAperturaDe: "Productos por apertura de",
  productosPorApertura: "Productos por apertura",
  facturasEmitidasMinuscula: "facturas emitidas",

  // 18/08/21
  restriccionesProductos: "Restricciones por producto",
  restriccionesProductosDesc:
    "Configurar restricciones horarias para la venta de productos",
  // 19/08/21
  noHayRestriccionesParaProductos:
    "No hay restricciones horarias para productos en este negocio.",
  alcohol: "Alcohol",
  // 20/08/21
  inforestriccionesproducto:
    "Una vez que haya creado la restriccion de venta horaria, podra asignarla en la configuracion de los productos.",
  noMostrarDescuento: "No mostrar descuentos",

  // 17/08/2021
  rangosDeMesas: "Rangos de mesas",
  agrupacionesDeMesasParaConsultarVentas:
    "Agrupaciones de mesas para consultar ventas",
  verUnInformeDeRangosDeMesas: "Ver informe de rangos de mesas",
  nuevoRangoMesa: "Nuevo rango mesa",
  mesaInicial: "Mesa inicial",
  mesaFinal: "Mesa final",
  noHayRangosDeMesasEnEsteTpv: "No hay rangos de mesas en este TPV",
  nombreRangoDeMesas: "Nombre rango de mesas",
  borrarRangoMesas: "Borrar rango de mesas",
  deseaEliminarEsteRangoDeMesas: "¿Desea eliminar este rango de mesas?",
  siBorrarEsteRangoDeMesas: "Sí, borrar este rango de mesas",
  ventasPorRangoDeMesas: "Ventas por rango de mesas",
  porRangoDeMesas: " por rango de mesas",
  numeroDeOperaciones: "Número de operaciones",
  precioMedioPorOperacion: "Precio medio por operación",
  propuestoParaCierre: "Propuesto para cierre",
  esteTicketHaSidoPropuestoParaSuCierreComaEstaUstedDeAcuerdo:
    "Este ticket ha sido propuesto para su cierre, ¿está usted de acuerdo?",
  siCerrarTicket: "Sí, cerrar ticket",
  propuestaDeCierreDeTicket: "Propuesta de cierre de ticket",
  noEstoyDeAcuerdo: "No estoy de acuerdo",
  ultimaRespuestaDelEquipoTecnico: "Última respuesta del equipo técnico",
  escribaAquiSuRespuesta: "Escriba aquí su respuesta",
  enviarRespuesta: "Enviar Respuesta",
  tienesTicketsPendientesDeCerrar: "Tienes tickets pendientes de cerrar",

  // 27/08/2021
  cuandoUnProductoEsDeTipoMenuSeCreaUnProductoMenuEnElTPV:
    "Cuando un producto es de tipo Menú, se crea un Menú que se sincroniza con el TPV",
  platosDelMenu: "Platos del menú",
  productosDelMenu: "Productos del menú",
  paraConfigurarUnProductoComoTipoMenu:
    "Para configurar un producto como tipo Menú, primero debe guardar el producto",
  ocultarSaldo: "Ocultar productos relacionados con saldo",

  // 26/08/21
  resActiva: "Activada",
  resInactiva: "Desactivada",

  // 26/08/2021
  exportarExcelDeTodosLosTickets: "Exportar Excel de todos los tickets",
  soloPuedesSacarInformesDeUnMesComoMaximo:
    "Solo puedes sacar informes de un mes como máximo",
  loSentimos: "Lo sentimos",
  noTienesNingunRangoDeMesasCreadoDeseasCrearUnRangoDeMesas:
    "No tienes ningun rango de mesas creado. ¿Deseas crear un rango de mesas?",
  siCrearUnRangoMesas: "Sí, crear un rango mesas",

  // 07/08/2021
  usuarioSinAcceso: "Su usuario no tiene acceso a este modulo",

  // 08/09/21
  pedidosHoras: "Pedidos por horas",
  graficaPedidosHoras:
    "Gráfica que muestra el número de pedidos agrupado por tramo horario en el dia de hoy",

  // 20/09/21
  personalizacionCarta: "Personalizacion de la Carta Online",
  personalizacion: "Personalización",
  conLasOpcionesQueTeOfrecemos: "con las opciones que te ofrecemos",
  opcionesConfiguracion: "Opciones de configuración",
  vistaPrevia: "Vista previa",
  imagenCargando: "Imagen de carga",

  // 21/09/21
  diagnosis: "Diagnosis",
  diagnosticoProductos: "Diagnóstico de productos",
  comprobacionProducts: "Comprobación de productos",
  diagnosticarProductos: "Diagnosticar productos",
  productosSinRelacionEnElTpv: "¡Todo correcto!",
  pulseElBoton: "Pulse el botón deseado",
  paraRealizarDiagnosis: "para realizar la diagnosis",
  productoRelacionadoConTpv: "Relacionado en el TPV con",
  noTieneRelacion: "No tiene relacion",
  hayProductosSinRelacion: "Hay productos que no estan relacionados en el TPV",

  // 20/09/21
  destacadosTitulo: "Titulo destacado",
  nuevoTitulo: "Nuevo titulo",
  tituloActual: "Titulo actual",

  // 22/09/21
  textos: "Textos",

  // 21/09/21
  facturas: "Facturas",
  facturasMinusculas: "facturas",
  facturacionGeneral: "Facturación general",
  deTodasLasSeries: " de todas las series",

  // 29/09/21
  permisoBusinessGestion:
    "Lo sentimos. No tienes permiso para utilizar esta herramienta en el negocio actual",
  permisoUsuarioGestion:
    "Lo sentimos. Este negocio no cuenta con este módulo activado.",
  traduccion: "Traducción",
  traduccionDe: "Traducción de",
  idioma: "Idioma",
  losDescuentosDeLasVentasEstanAlCeroDeIva:
    "Los descuentos de las ventas están al 0% de iva",
  recuerdeQueAlRealizarCobrosAvanzadosLosComensalesSeAsignaranALaFormaDePagoEfectivo:
    "Recuerde que al realizar cobros avanzados los comensales se asignaran a la forma de pago efectivo",
  mapasYZonas: "Mapas y zonas",
  idiomas: "Idiomas",
  permisoControlIdiomas:
    "Lo sentimos, este negocio no cuenta con el control de idiomas activado.",
  idiomasCartaTip1:
    "Para activar o desactivar un idioma puedes hacer clic en los interruptores.",
  idiomasCartaTip2:
    "Para ordenar los idiomas en la carta, puedes utilizar el campo orden.",
  idiomasCartaTip3: "Los idiomas con un orden menor aparecerán primero.",
  menu: "Menú",

  // 30/11/21
  totalVentasDevueltos: " total ventas y devueltos",

  // 24/11/21
  tpvOrigen: "Tpv de origen",
  validez: "Validez (días)",
  dateConsumo: "fecha de Consumo",
  dateCreacion: "fecha de Emision",
  nombreTpvDestino: "tpv de canje",
  nombreTpvOrigen: "TPV de Origen",
  hash: "CODIGO (hash)",
  proveedor: "Proveedor",

  // 14/12/2021
  apuntes: "Apuntes",
  apunte: "Apunte",
  cuentaContableGastos: "Cuenta contable gastos",
  cuentaContableApuntes: "Cuenta contable apuntes",
  retrocederEstado: "Retroceder estado",

  // 23/12/2021
  excluirDeSage: "Excluir de Sage",
  costeDeProductosPorAgencias: "Coste de productos por agencias",
  agrupadoPorAgencias: " agrupado por agencias",

  // 27/10/21
  selectCategory: "Seleccione las categorias para la importación",
  errorCategorySelect: "ATENCIÓN",
  txtErrorCategorySelect:
    "Se ha cancelado la importación debido a que las categorias seleccionadas solo contienen menús.",

  // 24/01/22
  consultarPorAperturaDeCuenta: "Consultar por apertura de cuenta",
  consultarPorCierreDeCuenta: "Consultar por cierre de cuenta",
  informeAperturaCuentas: "Informe apertura cuentas",
  informeCierreCuentas: "Informe cierre cuentas",
  activado: "Activado",
  desactivado: "Desactivado",
  rango: "Rango",
  pedidosPlataformaDePagoSinCompletar:
    "Pedidos plataforma de pago sin completar",
  estaAccionAnadiraUnPedidoEstaSeguro:
    "Esta acción añadirá un pedido, ¿Está seguro de que ha sido pagado?",
  estaAccionNoSePuedeDeshacerEstaSeguro:
    "Esta acción no se puede deshacer, ¿está seguro?",
  haHabidoUnPedidoConEsteTelefonoEnLasUltimas12Horas:
    "Ha habido un pedido con este teléfono en la últimas 12 horas",
  interrogacionQuiere: "¿Quiere ",
  elPedidoTemporalInterrogacion: " el pedido temporal?",
  aceptarMinuscula: "aceptar",
  eliminarMinuscula: "eliminar",
  excluirPrecioMedioMenu:
    "Excluir del precio medio los productos vendidos en menús",

  // 28/01/22
  categoriasPadre: "Categorías padre",
  quieresConvertirLaCategoria: "¿Quieres convertir la categoría",
  quieresQueLaCategoria: "¿Quieres que la categoría",
  enUnaCategoriaPadre: "en una categoría padre?",
  dejeDeSerUnaCategoriaPadre: "deje de ser una categoría padre?",
  porFavorAnadaUnaCategoriaPadreAntesDeActivarLaConfiguracion:
    "Por favor, añada una categoría padre antes de activar la configuración",
  deseaActivarLasCategoriasPadreParaLaCartaDigital:
    "¿Desea activar las categorías padre para la carta digital?",
  deseaDesactivarLasCategoriasPadreParaLaCartaDigital:
    "¿Desea desactivar las categorías padre para la carta digital?",
  recuerdeQueLasCategoriasQueNoEstenRelacionadasAUnaCategoriaPadreNoApareceranEnLaCartaDigital:
    "Recuerde que las categorías que no estén relacionadas a una categoría padre no aparecerán en Numier Pedidos",
  activadas: "ACTIVADAS",
  desactivadas: "DESACTIVADAS",
  categoriasPadreTextoExplicativo:
    "Las categorías padres sirven para agrupar las categorías de Numier Pedidos en agrupaciones mayores. Ejemplo: Puedes tener una categoría padre Primeros que contenga Carne, Pescado y Vegetariano",
  lasImagenesSoloSeraVisibleEnLasCategoriasPadre:
    "Las imágenes solo serán visibles en las categorías padre",

  // 09/02/2022
  consultarInventarioPorSectores: "Consultar inventario por sectores",
  inicioReal: "Inicio real",
  precarga: "Precarga",
  mermas: "Mermas",
  finalBarra: "Final barra",
  porSectores: "por sectores",
  buscarPorRefONombreDelProducto:
    "Buscar por código de barras o nombre del producto",
  textoAyudaProductoCompleto:
    "Cuando esta opción se encuentra desmarcada se trabajará con materias primas",
  accion: "Acción",

  metodoLiquidacionSinqro: "Método liquidación Sinqro",
  metodoLiquidacionSinqroInfo:
    "La modificación de este campo debe solicitarse al soporte técnico.",
  horaRepartidorAsignado: "Hora repartidor asignado",
  envioProgramado: "Envío programado",
  tiempoEstimado: "Tiempo estimado",
  gastosEnvio: "Gastos envío",
  buscarPedidoPorCliente: "Buscar pedido por cliente...",
  obligatorioApellidos: "Obligatorio los dos campos de apellidos",

  // 13/06/2022
  introduzcaElPorcentajeDeLaPrimeraCuentaContable:
    "Introduzca el porcentaje de la primera cuenta contable",
  porcentajeContable: "Porcentaje contable",

  // 7/7/2022
  incidenciaOperario: "Incidencias por operario",
  deIncidenciaOperario: "de incidencias por operario",
  verIncidenciaOperario: "Ver Incidencias",
  Incidencia: "Incidencia",

  // 11/07/2022
  nTickets: "Nº Ticket",
  propina: "Propina",
  serviceCharge: "Service Charge",

  // 15/07/2022
  totalCompleto: "Total completo",

  // 31/08/2022
  sinConsumir: "Sin consumir",

  // 06/09/2022
  integraciones: "Integraciones",
  GStock: "G-Stock",

  // 13/09/2022
  estasSeguroDeExportarLasVentas:
    "¿Estás seguro de exportar las ventas a G-Stock?",
  ventasExportadasExsitosamente: "Ventas exportadas con éxito",
  rangoFechasExcedidoMaximo: "El rango de fechas no puede exceder 3 meses",
  rangoSolicitadoMayorAlPermitido: "El rango solicitado es mayor al permitido (máximo 3 meses)",
  respuestaInvalida: "Respuesta inválida del servidor",

  // 04/10/2022
  referenciaYaExiste: "La referencia coincide con la de otro gasto",
  continuar: "¿Continuar?",
  guardarGasto: "Guardar gasto",
  maximoOpcionales: "Máximo opcionales",

  // 04/11/2022
  totalImpuestoIva: "Total impuesto IVA",

  // 09/11/2022
  enviarFacturaECorreo: "Enviar facatura electrónica por correo",

  // 10/11/2022
  baseImponible: "Base imponible",
  cuotaIVA: "Cuota IVA",
  baseSinDto: "Base sin dto.",
  importeTotalSinDto: "Imp. total s/ dto.",

  // 17/11/2022
  identificador: "Identificador contable",

  // 13/12/2022
  cambiarAgencia: "Cambiar agencia",
  facturaEditadaCorrectamente: "La factura se ha editado correctamente",
  editarNumeroComensales: "Editar número de comensales",
  buscarPorNombreDeAgencia: "Buscar por nombre de agencia",

  // 10/01/2023
  exportadoSage: "Exportado SAGE",
  updateExportadoSageCorrectamente: "Exportado SAGE actualizado correctamente",
  titleModificarExportadoSage: "Modificar exportado a SAGE",
  askUpdateExportadoSageTrue:
    "¿Está seguro que desea poner el gasto como exportado?",
  askUpdateExportadoSageFalse:
    "¿Está seguro que desea poner el gasto como NO exportado?",

  // 01/02/2023
  ProgramacionCarta: "Planificador de la carta",
  guardados: "Guardados",
  publicados: "Publicados",
  dePublicacion: "de Publicación",
  sinPublicar: "Sin Publicar",
  publicado: "publicado",
  publicar: "Publicar",
  Ocultar: "Ocultar",
  Publicado: "Publicado",
  aliasMayuscula: "Alias",

  // 03/02/2023
  porcentajeRespectoTotal: "% respecto total",

  // 13/02/2023
  ultimoPrecioCompra: "Último precio compra",

  // 21/02/2023
  basePropina: "Base Propina",
  impuestoPropina: "Impuesto Propina",
  baseServiceCharge: "Base Service Charge",
  impuestoServiceCharge: "Impuesto Service Charge",

  // 02/03/2023
  socios: "Socio",
  noSocios: "No socio",

  // 20/04/2023
  productoCartaSinRelacionar: "Sin relacionar",

  // 21/04/2023
  precioTarifa: "Precio / Tarifa 1",

  resetearDias: "Resetear Días",
  resetearButton: "Resetear",
  fechaIni: "Fecha de Inicio",
  fechaFin: "Fecha de Fin",
  reseteoExitoso: "Reseteo realizado correctamente",
  reseteoError: "Ha habido un error al realizar el reseteo",

  productosNoRelacionados: "Productos sin PLU",
  productosNoRelacionadosDescripcion:
    "Herramienta para encontrar productos sin PLU",

  // 23/05/29023
  verDetallesDeCuentaAnulada: "Ver detalles de cuenta anulada",
  desgloseDeCuenta: "Desglose de cuenta",

  // 29/03/2023
  exportarExcelValderrama: "Exportar Excel completo",

  // 20/04/2023
  productoCartaSinRelacionar: "Sin relacionar",

  // 21/04/2023
  precioTarifa: "Precio / Tarifa 1",

  // 29/05/2023
  pendientePago: "Pendiente de pago",
  fechaVencimiento: "Fecha de vencimiento",
  pendientePagoCambiadoCorrectamente:
    "Pendiente de pago cambiado correctamente",
  numeroTickets: "Número tickets",

  //  06/06/2023
  mensajePorcentajeCompraAumento:
    "El precio ha aumentado del porcentaje de compra establecido",
  avisoPorcentajeCompra: "Aviso de porcentaje de compra",

  // 19/06/2023
  conIvaDesglosado: "con IVA desglosado",

  // 21/06/2023
  ventasPorProductos: "Ventas por productos",
  sinRecoger: "Sin recoger",
  sinDomicilio: "Sin domicilio",
  recogerEnPedidos: "Recoger",
  domicilioEnPedidos: "Domicilio",
  informeDeVentasDeProductosDePedidos:
    "Informe de ventas de productos de pedidos",

  // 22/06/2023
  numeroPedidosDomicilio: "Nº pedidos domicilio",
  numeroPedidosRecoger: "Nº pedidos recoger",

  // 25/07/2023
  exportarSage200Fechas: "Exportar Sage200 por fechas",
  fechas: "Fechas",
  soloExportarGastos: "Solo exportar gastos",

  // 05/09/2023
  noMostrarInformeSectores: "No mostrar informe sectores",
  totalCargar: "Total a cargar",
  deshabilitar: "Deshabilitar",
  noMostrar: "No Mostrar",

  // 19/09/2023
  verificarTodo: "Verificar todo",
  estaSeguroDeVerificarTodosLosGastos:
    "¿Estás seguro de verificar todos los gastos?",
  gastosVerificadosCorrectamente: "Gastos verificados correctamente",

  // 26/09/2023
  siVerificarGastos: "Sí, verificar gastos",
  seleccionarTodosDelMismoProveedor: "Seleccionar todos del mismo proveedor",

  // 28/09/2023
  mostrarSinIva: "Mostrar sin IVA",
  modificarPrecio: "Modificar precio",

  // 05/10/2023
  nDeComensales: "Nº de comensales",

  // 13/10/2023
  archivoEnFormatoExcel: "Archivo en formato Excel",
  importarExcelClientes: "Importar Excel clientes",
  importarExcelSaldoClientes: "Importar Excel saldo clientes",
  importarClientes: "Importar clientes",

  // 31/10/2023
  ticketMedioRecoger: "Ticket medio recoger:",
  ticketMedioDomicilio: "Ticket medio domicilio:",

  // 23/11/2023
  ultimoPrecioCompraSinIva: "Último precio compra sin IVA",

  // 08/01/2024
  ventaDeProductosPorRangoDeMesas: "Ventas de productos por rango de mesas",
  filtradoPorRangoDeMesas: " filtrado por rango de mesas",
  vecesQueSeHaVendidoDentroDeMenus: "Veces que se ha vendido dentro de menús",
  delMenu: "del menú",
  cEnMenus: "C. en Menús",
  cFueraDeMenus: "C. Fuera de Menús",
  rangoDeMesas: "Rango de mesas",

  // 10/01/2024
  // ToolTip
  tolTipLogo:
    "Añade el logo de tu restaurante para que aparezca en la pantalla de inicio y en tu tarjeta QR. El tamaño recomendado es de 90 x 90 px.",
  tolTipFondo:
    "Añade una foto de alta calidad para que aparezca como portada en tu menú QR. El tamaño recomendado es de 1280 x 1024 px",
  tolTipImagenProducto:
    "Añade una imagen de alta calidad para mostrar tu producto de manera visual y atractiva. Para productos en el menú, crea uno nuevo con una resolución ideal de 500 x 500 píxeles o 12 cm x 12 cm.",
  tolTipNombreMostrado:
    "Escribe aquí el nombre que quieres que se muestre de tu negocio.",
  tolTipEmail: "Facilita un Email de contacto para tus cliente.",
  tolTipTelefono: "Facilita un teléfono de contacto.",
  tolTipDescripcion:
    "Describe brevemente tu restaurante: el concepto y la experiencia que ofreces.",
  tolTipDireccion:
    "Facilita la dirección del restaurante que perteneza a esta carta.",
  tolTipPresentacion:
    "Escribe una llamada a la acción adecuada para que tus clientes quieran abrir tu tarjeta en la pantalla de inicio.",
  tolTipHorario:
    "Presenta tu horario o comparte información extra (vacaciones, fuera de servicio...).",
  tolTipMostrarCategoriaDeBaja:
    "Si marcas la casilla, se mostrarán las categorías que has dado de baja, pero no aparecerán en tu carta.",
  tolTipMostrarProductoDeBaja:
    "Si marcas la casilla, se mostrarán los productos que has dado de baja, pero no aparecerán en tu carta.",
  tolTipTraducirCategoria:
    "Traducir al idioma que quieras el título de las categorías",
  tolTipConvertirCategoriaPadre: "Convertir en categoría padre",
  tolTipOrdenCategorias:
    "Si quieres que aparezca esta categoria como la primera, el número debería ser “1”, y así consecuentemente según el orden.",
  tolTipBajaCategoria:
    "Al activar esta opción, la categoría seleccionada dejará de aparecer en tu menú digital cuando los clientes accedan a él. La desactivación de una categoría implica que todos los productos que hayas incluido bajo esa categoría específica también dejarán de ser visibles para tus clientes.",
  tolTipVerQr: "Accede y descarga el código QR de tu carta",
  tolTipDisponibleProducto:
    "Marcar la disponibilidad del producto: Indica si un producto está disponible o no en tu carta.",
  tolTipIdiomaProducto:
    " Elige el idioma en el que también quieres que se presente el producto",
  tolTipOrdenProducto:
    "Elige el orden en que deseas que aparezca el producto dentro de la categoría seleccionada.",
  tolTipProductoDestacado:
    " Si seleccionas esta opción, el producto aparecerá en un apartado destacado al inicio de la carta. Resalta productos especiales o promociones.",
  tolTipBaja: "Este producto no se mostrará en tu carta (si está activado).",
  tolTipDisponible:
    "Activa el botón si el producto está disponible para la venta. Desactiva si el producto está 'Fuera de Stock' (cuando no hay existencias)''.",
  tolTipImagenCarga:
    "imagen que se mostrará durante los breves segundos en que tu carta se carga.",
  tolTipTituloDestacado:
    "Aquí puedes definir el texto que nombrará la sección de productos destacados. Ej: 'Sugerencias del Chef', 'Nuestros Top Ventas' o 'No te Puedes Perder' .",
  tolTipIdiomaMateriaPrima:
    "Elige el idioma en el que también quieres que se presente la materia prima",
  guiaUsuario: "Guía de usuario",

  // 14/02/24
  pedidosPorRepartidores: "Pedidos por repartidores",
  nombreRepartidor: "Nombre del repartidor",
  cantidadDePedidos: "Cantidad de pedidos",

  // 13/02/2024
  herramientaControlStockControlComprasInventarios:
    "Herramienta de control de stock, control de compras e inventarios",
  fidelizacion: "Fidelización",
  cheerfy: "Cheerfy",
  plataformaGestionPromocionesClientes:
    "Plataforma de gestion de promociones de clientes",
  nuevaPromocion: "Nueva promoción",
  noHayPromocionesEnEsteTpv: "No hay promociones en este tpv",
  tolTipDisponiblePromocion:
    "Marcar la disponibilidad de la promoción: Indica si la promoción está disponible o no.",
  promocion: "promoción",
  fechaCreacion: "Fecha creación",
  activo: "Activo",
  inactivo: "Inactivo",
  borrarPromocion: "Borrar promoción",
  promociones: "Promociones",
  codigoPromocion: "Código promoción",
  elCampoCodigoEsRequerido: "El campo codigo es requerido",
  deseaEliminarEstaPromocion: "¿Desea eliminar esta promoción?",
  siBorrarEstaPromocion: "Sí, borrar esta promocion",

  // 12/03/24
  basesFree: "Bases extras gratis",
  extrasFree: "Bases / Extras gratis",
  tooltipBaseExtra:
    "Si la base está activada, no suma extra gratis. Si el extra está activado, no contará como gratis al añadirse.",

  // 09/04/24
  permisoControlModulos:
    "Lo sentimos. Este negocio no cuenta con este módulo activado.",
  calcularCosteTodosLosProductos: "Calcular coste de todos los productos",
  trabajarSinIva: "Trabajar sin IVA",
  filtrarPorAgencias: "Filtrar por agencia",
  seleccioneLaTarifaParaMostrarSuNombre:
    "Seleccione la tarifa para mostrar su coste",
  conIVA: "Con IVA",
  calcular: "Calcular",
  productosIncluidosConEsteMenu: "Productos incluidos con este menú",
  abonarFacturaQr: "Abonar Factura QR",
  deseasAbonarEstaFacturaQR: "¿Deseas abonar esta factura QR?",
  abonarFactura: "Abonar factura",

  exportar: "Exportar",
  codigoBarras: "Código de barras",
  codBarras: "C.Barras",

  // 18/08/24
  listadoTicketRepartidor: "Tickets por repartidor",

  // WALLET
  passbooks: "Passbooks",
  sharePassbooks: "Compartir wallets",
  copyToClipboard: "Copiar al portapapeles",
  shareViaEmail: "Enviar por e-mail",
  shareViaWhatsapp: "Enviar por Whatsapp",
  copied: "Copiado al portapapeles",
  selectBusinessForWallet:
    "Elige el negocio para el que desear enviar las Wallets",
  sendMethod: "Método de envío",
  share: "Enviar",
  sendAndSaveButton: "Sí, enviar y guardar",
  sendAndNoSaveButton: "No, enviar y no guardar",
  titleSaveInfoModalText:
    "La información del cliente ha cambiado ¿desea guardar esta información?",
  verifyNumberText: "Verifique el teléfono",
  verifyEmailText: "Verifique el e-mail",
  selectOption: "Seleccione una opción",
  clipboardCopied: "Copiado al portapapeles",
  clipboardFailedToCopy:
    "El API del portapapeles no está disponible en este navegador.",
  enviarWallet: "Enviar Wallet",
  confirmacionEnvioWallet: "Confirmación de Envío de Wallet",
  confirmacionTextoEnviarWallet:
    "¿Está seguro de que desea enviar la wallet a todos los clientes?",
  mensajeConfirmacion:
    "Esta acción no se puede deshacer y sólo se enviará a los clientes cuyo email esté agregado y posean un Código de barras.",
  enviar: "Enviar",
  noHayCorreosElectronicos: "No hay correos electrónicos.",
  ningunClienteConCorreoElectronico:
    "No se encontró ningún cliente con correo electrónico configurado.",
  clientHasNoBarcode: "El cliente no tiene un código de barras establecido.",
  exportarCarta: "Exportar Carta",
  exportarSimplifiedExcel: "Exportar como Excel (Sin cabeceras)",

  // GESTIÓN DE IMPUESTOS
  taxes: "Impuestos",
  tax: "Impuesto",
  gestionImpuestos: "Gestión de Impuestos",
  administracionTiposTasas: "Administración",
  administracionTiposTasasImpositivas: " de tipos y tasas impositivas",
  agregarImpuesto: "Agregar Impuesto",
  taxRate: "Impuesto Aplicado",
  taxDescription: "Descripción",
  taxType: "Tipo de Impuesto",
  taxBoldType: "impuestos",
  impuestoAplicadoEsCero: "El Impuesto Aplicado no puede ser menor de ",
  impuestoYaCreado: "Este impuesto ya existe y no puede ser creado nuevamente",

  // IMPORTAR CLIENTES
  previewClientData: "Previsualización de Clientes",
  editarCliente: "Editar cliente",
  importarData: "Importar datos",
  importandoDatos: "Importando datos",
  preview: "Previsualizar",
  importacionRealizada: "Importación realizada",
  datosImportados: "Los datos se importaron correctamente",
  confirmarImportacion: "Confirmar importación",
  seguroContinuarImportacion:
    "¿Estás seguro de que quieres continuar? Esta acción es irreversible",

  // 18/11/24 - Update-Logo
  inserteImagen: "Inserte una imagen",
  seleccioneArchivoImagen: "Seleccione un archivo Imagen",
  archivoDemasiadoGrande:
    "El archivo es demasiado grande. El tamaño máximo permitido es 5MB.",
  dimensionesExcedenLimite:
    "Las dimensiones de la imagen exceden el límite permitido (2000x2000px).",
  mensajeconfirmacion:
    "Estás a punto de reemplazar la imagen existente. ¿Quieres guardar?",
  botonGuardar: "Guardar",
  botonCancelar: "Cancelar",
  Guardado: "Guardado",
  guardarOvisualizarLogo: "Visualizar o guardar logo",
  configurarLogoNegocio: "Configurar el logo del negocio",
  seleccionLogo: "Haz clic para seleccionar un logo",
  volver: "Volver",
  noExisteLogoNegocio: "No existe un logo para el negocio.",
  informacion: "Información: ",
  tamaño: "Tamaño: ",
  dimensiones: "Dimensiones: ",
  restriccionesLogo: "Restricciones del logo:",
  tamañoMaximo: "Tamaño max: ",
  dimensionesMaximas: "Dimensiones max: ",

  // 13/12/24 - ProductosNoRelacionados
  mensajeAviso:
    "¿Está seguro de que desea generar automáticamente los PLUs? Este proceso generará un código para cada producto y tarifa no configurados, y se guardará automáticamente.",
  mensajeAvisoSubProducto:
    "¿Está seguro de que desea generar automáticamente los PLUs? Este proceso generará un código para cada materia prima no configurada y se guardará automáticamente.",
  generarPlu: "Generar automaticamente PLUs",
  botonAceptar: "Aceptar",
  PLUsGenerados: "¡PLUs generados correctamente!",
  errorGenerandoPLUs: "Error al generar los PLUs",

  // 21/01/2025
  nosmudamos: "¡Nos mudamos!",
  noscambiamosaselfi:
    "Tu negocio ha dado un gran paso: ahora su carta forma parte de la familia Selfibar. A partir de ahora, todas las configuraciones y gestiones, relativas a la carta, las podrás realizar directamente en Selfibar. ",
  esteNegocioEsSelfi: "Este negocio es Selfibar",
  paraContinuar:
    "Para continuar, haz clic en Selfibar y accede a tu cuenta de Selfibar con tu usuario y contraseña",
  irASelfibar: "Ir a selfibar",
  barcodeUnico: "Código de barras único",
  barcodeNecesarioSeActualizara:
    "El código de barras es necesario para esta acción y se actualizará para este cliente al enviar o copiar al portapapeles.",
  emailenviado: "Email Enviado",

  // ListadomateriaPrima-Proveedor
  // 14/01/25
  verListado: "Listado materias primas",
  listadoMateriaPrimaProveedor: "Listado materia prima por proveedor",
  noTiene: "No tiene ",
  esteProveedor: " este proveedor",
  precioAcordado: "Precio Acordado con Proveedor",
  porcentajeAcordado: "Porcentaje acordado ",
  filtrarPorEtiqueta: "Filtrar por etiqueta: ",
  precioAcordadoGuardadoCorrectamente: "Precio fijado. Guardado correctamente!",
  fijarprecio: "Fijar precio ",
  preciofijado: "(Fijar el precio de la materia prima)",
  mensajePrecioFijado: "El precio de la materia prima es de  ",
  explicacionFijarPrecio:
    "Al activarlo, el precio de la materia prima y el porcentaje de descuento se quedarán fijado. Al hacer un nuevo gasto ni el precio ni el descuento se verán modificado.",
  porcentajeAcordado: "Porcentaje de aviso",
  porcentajeAcoradoGuardado: "Porcenaje acordado. Guardado correctamente!",
  losSubproductosSeHanIncrementado:
    "Se ha detectado un incremento en el precio de las siguientes materias primas con respecto al porcentaje acordado con el proveedor",
  errorverificar: "Error al verificar",
  mensajeErrorVerificarTodo:
    "Se ha detectado en los siguientes gastos un incremento en el precio de la materia prima con respecto al porcentaje acordado con el proveedor",
  explicacionPorcentajeAcordado:
    "Este es el porcentaje acordado para el proveedor, para el control del precio de las materias primas a la hora de realizar un gasto.",
  generarBusinessHash: "Generar URL para operarios",
  enlaceFicharTurnosOperario: "Acceso para fichar y consultar turnos",
  enlaceFicharTurnosOperarioDescripcion:
    "Los trabajadores del negocio podrán iniciar sesión con las mismas credenciales que en el TPV para registrar el inicio y fin de su turno, así como consultar los últimos 14 turnos realizados junto con sus tiempos.",

  // KIOSKOS
  kioskos: "Kioscos",
  stockBreak: "Rotura de stock",
  kiosksMenu: "Kioskos carta",
  barcode: "BARCODE",

  sort: "Ordenar",
  productSorted: "Producto ordenado correctamente",
  subproductSorted: "Materia prima ordenada correctamente",
  categorySorted: "Categoria ordenada correctamente",

  saldoAnterior: "SALDO PREV.",
  saldoActual: "SALDO ACTUAL",

  // 31/01/2025
  guardarOreplicar:
    "Este producto se encuenta en una carta ¿Desea guardar los cambios del producto o guardarlos y replicarlos en la carta?",
  guardarYreplicar: "Guardar y replicar en carta",
  CrearProductoEnCarta: "Guardar y Crear producto en carta",
  tienesProductosSinActualizar:
    "Tienes productos y/o materias primas en la carta sin relacionar o de baja en el TPV",
  porFavorDirijaseADiagnosticoParaActualizar:
    "Por favor, dirijase a Carta digital > Configuración Carta > Diagnosis > Diagnóstico para revisar los productos y materias primas pendientes de actualización",
  irAdiagnosis: "Ir a Diagnosis",
  realizarDespues: "Realizar después",
  actualizarProductos: "Quedan por revisar ",
  activoEnCarta: "Activo en carta",
  activoEnTPV: "Activo en TPV",
  relacionarProducto: "Relacionar producto carta con TPV",
  editarProductoCarta: "Editar producto carta",
  editarProductoTpv: "Editar producto TPV",
  editarMateriaPrimaCarta: "Editar materia prima carta",
  editarMateriaPrimaTpv: "Editar materia prima TPV",
  sinErroresProductos:
    "No se han encontrado potenciales errores con los productos en la carta ",
  sinErroresMateriasPrimas:
    "No se han encontrado potenciales errores con las materias primas en la carta ",

  // Sinqro refactor
  seleccionePrecioAgenciaSinqro: "Precio de la agencia que desea sincronizar",
  iniciandoImportacion: "Iniciando importación",
  limpiandoSinqro: "Eliminando registros de Sinqro",
  obteniendoCategorias: "Obteniendo categorías",
  obteniendoProductos: "Obteniendo productos",
  obteniendoSubproductos: "Obteniendo subproductos",
  sincronizandoConSinqro: "Sincronizando con Sinqro",
  finalizandoSincro: "Finalizando sincronización",
  errorSincronizacion: "Error al sincronizar con Sinqro",
  estamosTrabajandoEnEllo: "Estamos trabajando en ello, espera por favor...",
  creandoCategoriasSinqro: "Creando categorías en Sinqro",
  errorSincronizacionPruebeOtraVez:
    "Error al sincronizar con Sinqro. Por favor, inténtelo de nuevamente.",
  losentimos: "¡Lo sentimos!",
  estamosPreparandoTuCarta: "Estamos preparando tu carta",
  borrandoCartasObsoletas: "Borrando cartas obsoletas",
  creandoCarta: "Creando carta en Sinqro",
  ultimoPasoCasiTerminado: "Último paso, ya estamos terminando",

  exportarPdfSinDesglose: "Exportar como PDF (Sin Desglose)",
  exportarPdfConDesglose: "Exportar como PDF (Desglosado)",
  exportarExcelSinDesglose: "Exportar como Excel (Sin Desglose)",
  exportarExcelConDesglose: "Exportar como Excel (Desglosado)",

  // 14/07/2025
  replicarPLUs: "Replicar PLUs",
  pluReplicadosExitosamente: "PLUs replicados exitosamente",
  replicarPLUPRod: "Replicar PLUs de productos en TPVs",
  replicarPLUSubPRod: "Replicar PLUs de materias primas en TPVs",
  replicarPLUsaBusinesses: "Replicar PLUs de productos en negocios",
  replicarPLUaBusinesses: "Replicar PLU de materias primas en negocios",
  noSeActualizoNingunProducto: "No se actualizó ningun producto",
  productosActualizadosCorrectamente: "Producto actualizado correctamente",

  importarExcelTarjetas: "Importar Excel Tarjetas",
  importarTarjetas: "Importar Tarjetas",
  editarTarjeta: "Editar Tarjeta",
  previewTarjetasData: "Previsualización de Tarjetas",

  estaSeguroPLU: "¿Esta seguro de querer replicar PLU?",
  conEstaAcciónPLU:
    "Con esta acción, el PLU se replicará en todos los negocios seleccionados.",

  porDiaNatural: "por día natural",
  actualizados: "Actualizados",
  conErrores: "Con Errores",
  estasSeguro: "¿Estás seguro?",
  conEstaAccionPLUTpvs:
    "Con esta acción, el PLU se replicará en todos los TPVs relacionados a este negocio",
  advertenciaPLUTexto1Prod:
    "Este proceso de replicación de PLUs entre negocios utiliza el nombre de producto para su funcionamiento.",
  advertenciaPLUTexto2Prod:
    "Si tiene nombres duplicados en productos, este proceso no podrá realizarse para ellos.",
  advertenciaSubPLUTexto1:
    "Este proceso de replicación de PLUs de materias primas utiliza el nombre de la materia prima para su funcionamiento.",
  advertenciaSubPLUTexto2:
    "Si tiene nombres duplicados en materias primas, este proceso no podrá realizarse para ellos.",

  advertenciaPLUsDuplicadosProductos:
    "⚠️ Los PLUs de los productos con nombres duplicados no han podido ser replicados porque el nombre se utiliza como referencia en este proceso.",
  advertenciaPLUsDuplicadosSubproductos:
    "⚠️ Los PLUs de los subproductos con nombres duplicados no han podido ser replicados porque el nombre se utiliza como referencia en este proceso.",

  productosActualizadosResumen: "Productos Actualizados",
  productosNoEncontradosResumen: "Productos No Encontrados",
  productosSinCambiosResumen: "Productos Sin Cambios",

  subproductosActualizadosResumen: "Subproductos Actualizados",
  subproductosNoEncontradosResumen: "Subproductos No Encontrados",
  subproductosSinCambiosResumen: "Subproductos Sin Cambios",

  seRepite: "se repite",

  ordenarProductosAlfabeticamenteDesc:
    "Ordenar productos alfabéticamente de forma ascendente.",
  ordenarMateriasPrimasAlfabeticamenteDesc:
    "Ordenar materias primas alfabéticamente de forma ascendente.",
  configurarFechaCaducidadFacturas: "Fecha de vencimiento de FACTURAS QR",
  configurarFechaCaducidadFacturasDesc:
    "Configura el tiempo que tendrán los clientes para abonar sus FACTURAS QR antes de que venzan.",
  configurarLogoNegocioDesc:
    "Configura el logo del negocio que se mostrará en las facturas.",
  cambiarPreciosAProductosDesc: "Cambiar precios a productos de forma masiva.",
  calcularCostoProductos: "Coste de los productos",
  calcularCostoProductosDesc: "Calcular el coste de los productos por TPV.",
  gestionAvanzadaHerramientas: "Gestión avanzada de herramientas",
  gestionAvanzadaHerramientasDesc:
    "Configuración avanzada de impresoras, categorías y monitor de cocina para tu negocio.",
  hora: "Hora",
  cancelaciones: "Cancelaciones",
  totalNeto: "Total Neto",
  identificadorPostit: "Identificador Post-it",

  // VentasNegocios internationalization
  totalMesasPostit: "Total Mesas de Post-it",
  noHayVentasDisponibles:
    "No hay ventas disponibles para el plano seleccionado",
  intentaSeleccionarOtroPlano:
    "Intenta seleccionar otro plano o verifica los datos del período seleccionado",
  loSentimos: "Lo sentimos",
  esteNegocioNoCuentaConModulo:
    "Este negocio no cuenta con este módulo activado",
  mesasDePostit: "Mesas de Post-it",
  totalConsolidado: "Total Consolidado",
  totalMesa: "Total Mesa",
  pagosaldo: "Pago saldo",
  desgloseVentasPorMesasHoras: "Desglose de Ventas por Mesas y Horas",

  configurar: "Configurar",
  configurarLogoFacturas: "Logo de facturas",
  configurarFechaDeVencimientoDeFacturas:
    "Configurar fecha de vencimiento de facturas",
  introduzcaElNumeroDeDiasEnElQueVenceranLasFacturas:
    "Introduzca el número de días en el que vencerán las facturas.",
  datoInformativo:
    "Esta fecha no tendrá efecto a nivel de sistema, es simplemente informativa para el cliente.",
  calcularCostoDeTodosLosProductos: "Calcular costo de todos los productos",

  // Business Central
  summary: "Resumen de bajas de productos",
  productDowngrades: "Se han encontrado bajas en productos",
  subproductDowngrades: "Se han encontrado bajas en materias primas",
  totalDowngrades: "Total de bajas",
  totalAffectedRecipes: "Total de recetas afectadas",
  downgradedProducts: "Productos dados de baja",
  downgradedSubproducts: "Materias primas dadas de baja",
  noRecipesAffected: "No hay recetas afectadas",

  actualizar: "Actualizar",
  crear: "Crear",
  terminar: "Terminar",

  departamentosSeleccionados: "Departamentos selecionados",

  seleccionarProducto: "Seleccionar\nproducto",
  seleccionarDepartamentos: "Seleccionar\ndepartamentos",
  completarCampos: "Completar\ncampos",
  asignarMateriasPrimas: "Materias\nprimas",
  seleccionaMateriasPrimasBusinessCentralAlertInfo:
    "Esta es la lista de materias primas vendibles de Business Central pendientes de crear o actualizar en Numier. Selecciona la materia prima de la lista para continuar. <strong>Tienes {PRODUCT_LIST_LENGTH} materias primas pendientes.</strong>",
  seleccionaProductosBusinessCentralAlertInfo:
    "Esta es la lista de productos de Business Central pendientes de crear o actualizar en Numier. Selecciona el producto de la lista para continuar. <strong>Tienes {PRODUCT_LIST_LENGTH} productos pendientes.</strong>",
  seleccionaDepartamentosBusinessCentralAlertInfo:
    "<strong>¿Dónde debe estar disponible el producto {PRODUCT_NAME}?</strong> Selecciona los departamentos donde quieres que esté disponible el producto {PRODUCT_NAME}.",
  completarCamposProductosBusinessCentralAlertInfo:
    "A continuación <strong>completa los campos y tarifas</strong> de {PRODUCT_NAME}.",
  asignarMateriasPrimasProductosBusinessCentralAlertInfo:
    "Se han detectado las siguientes materias primas para <strong>{PRODUCT_NAME}</strong>. Estas se añadirán automáticamente al producto al finalizar el proceso.",
  estasMateriasPrimasSeAnadiranAlProducto:
    "Estas materias primas se añadirán automáticamente al producto al finalizar el proceso.",
  completarTarifasBusinessCentralAlertInfo:
    "<strong>{PRODUCT_NAME} puede tener diferentes categorías, IVA y precios dependiendo del departamento</strong>. Por ejemplo, un precio de 2.50€ para la Tarifa 1 en el Departamento 1 y 3.00€ en Departamento 2. Si está marcado el checkbox de replicar valores e introduces un valor, se completará toda la columna con ese valor.",
  CategoriayTarifasPorDepartamento: "Categoria, IVA y Tarifas por departamento",
  replicarValoresTarifasEnTodaLaColumnaCheckbox:
    "Replicar valores de Tarifa en toda la columna",
  sincronizado: "sincronizado",
  swalSalirFromProductosBusinessCentralTitle: "Antes de continuar...",
  swalSalirFromProductosBusinessCentralText:
    "Si sales ahora, perderás tu progreso actual.",
  swalSalirFromProductosBusinessCentralButtonConfirm: "Sí, salir",
  swalCamposObligatoriosFromProductosBusinessCentralText:
    "Debes completar todos los campos marcados con *",
  swalNombreProductoObligatorioFromProductosBusinessCentralText:
    "Nombre producto",
  swalColorObligatorioFromProductosBusinessCentralText: "Color del botón",
  swalCategoriaObligatorioFromProductosBusinessCentralText:
    "Categoría en cada departamento",
  swalTipoIvaObligatorioFromProductosBusinessCentralText:
    "IVA en cada departamento",
  noPuedenCoincidirLosValoresDeLosCodigosDeBarrasEntreDiferentesFormatos:
    "No pueden coincidir los valores de los códigos de barras entre diferentes formatos.",
  yaExisteUnProductoConEseCodigoDeBarras:
    "Ya existe un producto con ese código de barras",
  swalProductoSincronizadoTitle: "¡Producto sincronizado!",
  swalProductoSincronizadoTextNPendientes:
    "¿Quieres seguir sincronizando productos o prefieres terminar por ahora?",
  swalProductoSincronizadoText0Pendientes:
    "Todos los productos han sido sincronizados.",
  swalProductoSincronizadoButtonSeguir: "Seguir sincronizando",
  swalProductoSincronizadoButtonTerminar: "Terminar",
  swalProductoActualizadoTitle: "¡Producto actualizado!",
  swalProductoActualizadoText0Pendientes:
    "Todos los productos han sido actualizados.",
  swalSuplementoTarifa1ObligatoriaFromProductosBusinessCentralText:
    'Falta precio de SUPLEMENTO (Tarifa 1) en el departamento/TPV "{tpv}".',

  modalUnidadesMedidaTitle: "ℹ️ IMPORTANTE",
  modalUnidadesMedidaTextIntro:
    "{PRODUCT_NAME} tiene {UD_COUNT} unidades de medida en Business Central ({UD_LIST}). Hay 2 opciones:",
  modalUnidadesMedidaOpcionMultiples:
    "🔹 Crear {UD_COUNT} productos → Ideal si son materias primas distintas (ej: Agua BOT500ML y Agua BOT1L son materias primas diferentes).",
  modalUnidadesMedidaOpcionUnico:
    "🔹 Crear 1 producto y usar hasta 4 tarifas → Mejor si es la misma materia prima con distintas cantidades (ej: usar tarifas 'Tapa' y 'Ración' de Ensaladilla).",
  modalUnidadesMedidaRecomendacion:
    "Recomendación: Si es la misma base (ej: Ensaladilla en distintas cantidades), usa 1 producto. Si son materias primas diferentes, crea {UD_COUNT} productos.",
  modalUnidadesMedidaButtonMultiples: "Crear {UD_COUNT} productos",
  modalUnidadesMedidaButtonUnico: "Crear 1 producto",

  modalConfirmarDatosTitle: "ℹ️ CONFIRMA LOS DATOS DEL PRODUCTO",
  modalConfirmarDatosIntro:
    "{PRODUCT_NAME} ya se había sincronizado y guardado en Numier, pero ha sido modificado en Business Central.",
  modalConfirmarDatosExplicacion:
    "A continuación, vamos a cargar en el formulario los datos que tenemos en Numier de este producto para que confirmes y pulses en continuar si son correctos.",
  continuar: "Continuar",

  cargandoListaProductos: "Cargando lista de productos...",
  seHaDetectadoCambioUdmEsNecesarioActualizarPorFormato: "Se ha detectado un cambio en las unidades de medida. Es necesario actualizar los precios por formato para esta nueva unidad de medida.",
  productoYaCreadoMateriasPrimasIguales: "El producto ya existe en Numier, por lo que las materias primas serán las mismas.",
  seHanDetectadoMasUdmQueSoportaNumierSeCrearanProductosIndividuales: "Se han detectado más unidades de medida en Business Central de las que soporta Numier. Se crearán productos individuales para cada unidad de medida.",
  error: "Error",
  serverError: "Hubo un problema al comunicarse con el servidor",
  errorRecetasBC: "No se pudieron obtener las recetas desde Business Central.",
  erroresAddTipoMateriaPrima: "Debes elegir el tipo de cada materia prima.",
  erroresAddTodasMateriasPrimas: "Debes añadir todas las materias primas",
  redirigidoIntegracionesBC:
    "Te hemos redirigido al punto de partida para confirmar que la empresa seleccionada es la correcta.",
  redirigidoFaltanDatos:
    "Has sido redirigido porque faltaban datos necesarios.",
  unknownProduct: "Producto desconocido",

  // BussinessCentral MateriasPrimas
  nombreMateriaPrima: "Nombre de la Materia Prima",
  descripcion: "Descripción",
  codigoDeBarra: "Código de Barras",
  seleccionaCategoria: "Selecciona una Categoría",
  seleccionaTipo: "Selecciona un Tipo",
  precioCompraSinIva: "Precio de Compra (sin IVA)",
  baja: "Baja",
  escandallo: "Escandallo",
  quieresSeguirSincronizando: "¿Quieres seguir sincronizando?",
  seguirSincronizando: "Seguir sincronizando",
  seleccionar: "Seleccionar",
  materiaPrimaGuardada: "¡Materia prima guardada!",
  seleccionarMateriaPrima: "Seleccionar\nmateria prima",
  completarCamposMateriaPrima: "Completar\ncampos y asigar\nmaterias primas",
  queQuieresHacerAhora: "¿Quieres seguir sincronizando materias primas?",
  seguirEditando: "Seguir editando",
  materiaPrimaSincronizadaCorrectamente:
    "Materia prima sincronizada correctamente",
  estaMateriaPrimaTieneMateriasPrimasRelacionadasAlertInfo:
    "La materia prima <strong>{MATERIA_PRIMA_NAME}</strong> tiene a su vez otras materias primas asociadas. Añádelas para completar la sincronización.",
  finalizar: "Finalizar",
  seleccionaLosDepartamentos: "Selecciona los departamentos",
  noHayEtiquetasTPV: "No hay etiquetas para este TPV",
  aniadir: "Añadir",
  aniadirTodas: "Añadir todas",
  listo: "Todo listo",
  errorDesconocido: "Error desconocido",
  nombreMateriaPrimaObligatorio:
    "El nombre de la materia prima es obligatorio.",
  submateriasPrimasObligatorio: "Debes añadir todas las submaterias primas.",

  actualizacionMateriaPrima: "Actualización de Materia Prima",
  mensajeCambioMateriaPrimaInfo:
    "Se han detectado cambios en esta materia prima desde Business Central.",
  antesContinuarMateriaPrimaInfo:
    "Antes de continuar, revise los departamentos en los que esta materia prima debe estar disponible, por si hubiera cambios.",
  accionNecesariaMateriaPrimaInfo:
    "Es necesario realizar esta acción para mantener la información actualizada correctamente.",
  entendido: "Entendido",
  noVolverAMostrarEsteAviso: "No volver a mostrar este aviso",
  cerrarYNoVolverAMostrar: "Cerrar y no volver a mostrar",
  preferenciasGuardadas: "Preferencias guardadas correctamente",
  errorAlGuardarPreferencias: "Error al guardar las preferencias",
  seleccioneCategoria: "Seleccione categoría...",

  // Formulario combinado de productos
  precioRequerido: "Precio requerido",
  introduzcaPrecio: "Introduzca el precio del suplemento",
  errorValidandoCodigosBarras: "Error validando códigos de barras",
  asignaPreciosMateriasPrimas: "Asigna precios a las materias primas",
  rateNameRequired: "Es obligatorio indicar el nombre de la tarifa nº: ",
  categoryRequiredForDept: "Es obligatorio seleccionar una categoría para el departamento: ",
  validationError: "Error de validación de los campos",
  pleaseFillRequiredFields: "Por favor, complete todos los campos obligatorios.",
  configuracionPorDepartamento: "Configuración por departamento",
  productoNormal: "Producto Normal",
  productoCON: "Producto CON",
  productoSUPL: "Producto SUPL.",
  esProductoCON: "Es producto CON",
  esProductoSUPL: "Es producto SUPL.",
  categoriaNormal: "Normal",
  categoriaCON: "CON",
  categoriaSUPL: "SUPL",
  suplemento: "SUPLEMENTO",
  mensajeProductoCON:
    "Se ha detectado que estás creando un producto CON. Se generarán 2 productos: uno normal y otro CON.",
  mensajeProductoSUPL:
    "Se ha detectado que estás creando un producto SUPL. Se generarán 2 productos: uno normal y otro SUPL.",
  mensajeProductosCONySUPL:
    "Se ha detectado que estás creando un producto CON y SUPL. Se generarán 3 productos: uno normal, uno CON y uno SUPL.",
  completeCamposObligatorios:
    "Por favor, complete todos los campos obligatorios.",
  completeNombreProductoCON: "Por favor, complete el nombre del producto CON.",
  completeNombreProductoSUPL:
    "Por favor, complete el nombre del producto SUPL.",
  productosGuardadosCorrectamente:
    "Los productos se han guardado correctamente.",
  errorAlGuardarProductos:
    "Se produjo un error al intentar guardar los productos.",
  dataNegocioVisualizar: "Departamentos",
  formaPagoFiltrado: "Filtrar por forma de pago",
  fechaExportacionDisponible: "Fecha de exportación detectada",
  todasLasFormasPago: "Todas las formas de pago",
  seleccioneSubtipoFormaPago:
    "Por favor, seleccione una forma de pago específica (como Visa, Mastercard o el tipo de cheque).",
  noCambiosFormaPago: "No se han realizado cambios en la forma de pago",
  finalizarProcesoActualizar:
    "Finalizar proceso de actualización de materia prima",
  actualizarFinalizarText:
    "Para completar el proceso y actualizar correctamente la materia prima, haga clic en el botón de abajo 'Actualizar y finalizar'.",
  cambiosDepartamentosMateriaPrimaInfo:
    "Si se han realizado cambios en los departamentos donde esta materia prima debe estar activa —ya sea para agregarla o eliminarla de alguno—, dichos cambios se aplicarán automáticamente durante la actualización.",
  actualizarFinalizar: "Actualizar y finalizar",
  verDetallesFormaPago: "Ver detalles de forma de pago",
  detallesFormaPago: "Detalles de la forma de pago",
  formaDePago: "Forma de pago",
  medioDePago: "Medio de pago",
  medioPagoFiltrado: "Filtrar por medio de pago",
  advertenciaExportacionVentas: "Advertencia sobre la exportación de ventas",
  seExportaranTodosLosDepartamentos:
    "Se exportarán las ventas de TODOS los departamentos",
  advertenciaExportacionTodosLosDepartamentos:
    "Al continuar, se exportarán las ventas de todos los departamentos, incluyendo sus respectivas formas de pago, no solo las del departamento actual.",
  noHayVueltaAtras: "Una vez realizada la exportación, no se podrá deshacer.",
  reviseYEditeFormasPagoAntes:
    "Revise y edite las formas de pago antes de proceder.",
  eleccionModoExportacion: "El modo de exportación solo determina si las ventas se envían por lotes o todas juntas. En cualquier caso, se enviarán las ventas de todos los puntos de venta.",
  estaSeguroDeExportar:
    "¿Está seguro de que desea continuar con la exportación?",
  todosLosMediosPago: "Todos los medios de pago",
  tpv: "TPV",
  department: "Departamento",
  productoEspecialDetectado: "Producto especial detectado",
  productoEspecialDetectadoMensaje: "Se ha detectado un producto especial.",
  seCrearanTresProductos: "Se crearán {cantidad} productos en Numier: uno normal, uno CON y uno SUPLEMENTO.",
  seCrearanDosProductosCon: "Se crearán {cantidad} productos en Numier: uno normal y uno CON.",
  seCrearanDosProductosSuplemento: "Se crearán {cantidad} productos en Numier: uno normal y uno SUPLEMENTO.",
  relleneFormularios: "Por favor, rellene los formularios correspondientes a continuación.",
  categoriaEnlazada: "Categoría enlazada",
  dadoDeBaja: "Dado de baja",
  refrescar: "Refrescar",
  errorAlRefrescar: "No se han podido actualizar los datos. Vuelve a intentarlo.",
  sinPermisoExportacionBC: "No tienes permiso para acceder a la exportación de ventas a Business Central. Habla con tu administrador.",
  productoDeBajaTitulo: "Producto dado de baja",
  productoDeBajaTexto: "Este producto está dado de baja y no puede añadirse como plato del menú. Actívalo en Business Central y vuelve a sincronizar: Numier lo reactivará en la siguiente sincronización.",
  categoriaFijadaPorTipo: "La fija el tipo {TIPO}",
  categoriaFijadaPorTipoAviso: "La categoría no se puede elegir: un {TIPO} se crea siempre en la categoría que tiene en el negocio de origen. Si no existe en el destino, se crea.",
  sinNegociosParaReplicar: "No hay ningún otro negocio disponible para replicar este producto.",
  negocioSinCategorias: "Sin categorías creadas",
  resultadoReplicacion: "Resultado de la replicación",
  replicados: "Replicados",
  replicaFamiliaAviso: "Este producto forma familia. Se replicarán:",
  replicaTipoDetectado: "Tipo de producto detectado:",
  productosPorNegocio: "productos por negocio",
  faltaCategoriaEnNegocios: "Selecciona una categoría en estos negocios:",
  seleccionaAlMenosUnNegocio: "Selecciona al menos un negocio.",
  seleccionaPreviamenteCategoria: "Seleccione previamente una categoría",

  // Producto solo con/suplemento
  crearProductoSinNormal: "Crear producto normal como inactivo",
  crearProductoSinNormalExplicacion: "Si activas esta opción, el producto normal se creará pero con estado 'baja' (inactivo). Esto es útil cuando el producto solo tiene sentido venderlo como CON o SUPLEMENTO, ya que no se venderá como un producto individual por sí solo. Solo estará visible en el TPV si lo activas manualmente.",
  crearProductoSinNormalDetalle: "El producto normal siempre se creará, pero con esta opción marcada aparecerá desactivado. Los productos CON y SUPLEMENTO estarán activos para su uso inmediato.",
  crearProductoSinNormalImportante: "IMPORTANTE: Deberás seleccionar una categoría obligatoriamente antes de marcar esta casilla, ya que se requiere para mantener la integridad de los datos aunque el producto esté inactivo.",
  productoNormalOculto: "Producto normal oculto",
  productoNormalOcultoExplicacion: "Este formulario está oculto porque el producto normal se creará como inactivo",
  activarProducto: "Activar producto",

  // Business Central - Exportación de ventas
  exportacionVentasBC: "Exportar ventas",
  noHayDiasParaExportar: "No hay días para exportar",
  dailyExportCardTitle: "Exportación diaria de ventas",
  dailyExportCardSubtitle: "Revisa las ventas y expórtalas a Business Central",
  todoExportadoCorrectamente:
    "Todas las ventas han sido exportadas correctamente o no existen ventas para este departamento.",
  hayVentasPendientesExportar: "Existen ventas pendientes de exportar.",
  debesExportarPrimeroDiasAnteriores:
    "Debes exportar primero los días anteriores para mantener la correlatividad.",
  fechaExportacion: "Fecha de exportación",
  formapago: "Forma de pago",
  noPuedeCambiarFechaSinExportarPrimero:
    "No se puede exportar una nueva fecha sin antes exportar el día más antiguo pendiente.",
  trabajador: "Trabajador",
  exportData: "Exportar ventas",
  exportacionExitosa: "La exportación se ha realizado con éxito",
  errorExportarDatos: "Error al exportar los datos",
  falloExportarDatos: "Fallo al exportar los datos",
  exportacionRealizada: "Exportación realizada",
  exportacionRealizadaParcial: "Exportación realizada parcialmente",
  exportacionExitosaConErrores: "La exportación se ha realizado con éxito con algunos errores",
  editarFormaPago: "Editar forma de pago",
  noExistenDatosNoPudieronCargar: "No existen datos o no se pudieron cargar",
  mensajeEfectivoSeleccionado:
    "Se ha seleccionado efectivo como forma de pago. No es necesario indicar más detalles.",
  guardarFormaPago: "Guardar forma de pago",
  tipoFormaPago: "Tipo de forma de pago",
  seleccioneUnTipo: "Seleccione un tipo",
  formaPagoTarjeta: "Forma de pago con tarjeta",
  formaPagoCheque: "Forma de pago con cheque",
  updatePagoCorrecto: "Forma de pago actualizada correctamente",
  noSePudoActualizarFormaPago: "No se pudo actualizar la forma de pago",
  errorAlGuardarFormaPago: "Error al guardar la forma de pago",
  noHayVentasConEstaFormaPago: "No hay ventas con esta forma de pago",
  formaPagoNoEncontrada: "Forma de pago no detectada para este departamento",
  totalCash: "Total efectivo",
  totalCard: "Total tarjeta",
  totalCheque: "Total cheque",
  totalPagosaldo: "Total pago saldo",
  totalAvanzado: "Total avanzado",
  avanzadoEfectivo: "Avanzado efectivo",
  avanzadoTarjeta: "Avanzado tarjeta",
  avanzadoCheque: "Avanzado cheque",
  avanzadoPagosaldo: "Avanzado pago saldo",
  avanzadoOtros: "Avanzado otros",
  cashPaymentMethod: "Forma de pago efectivo",
  cardPaymentMethod: "Forma de pago tarjeta",
  chequePaymentMethod: "Forma de pago cheque",
  importeTotal: "Importe total",
  sinDatos: "SIN DATOS",

  // Integración Business Central > Business Central
  businessCentral: "Business Central",
  sincronizacionBusinessCentralSubtitle:
    "Sincronización de productos, departamentos y más en tiempo real",
  sincronizaMateriasPrimasBusinessCentralSubtitle:
    "Tienes <strong>{MATERIAS_PRIMAS_LENGTH}</strong> materias primas pendientes de actualizar",
  noHayParaActualizar: "No hay nada pendiente de actualizar o sincronizar",
  obteniendoDatos: "Obteniendo datos...",
  relacionesProcesadas: "Relaciones procesadas",
  exportacionDeshabilitada: "Exportación deshabilitada",
  sincronizaProductosBusinessCentralSubtitle:
    "Tienes <strong>{NUMERO_PRODUCTOS_PENDIENTES}</strong> productos pendientes de sincronizar",
  sincronizaFormasDePagoBusinessCentralSubtitle:
    "Tienes <strong>{NUMERO_FORMAS_PAGO_PENDIENTES}</strong> formas de pago pendientes de sincronizar",
  productoFormCompleto: {
    info: "Editando producto: {productName}",
  },
  completaProductosBussinessCentralSubtitle:
    "Completa primero la sincronización de las materias primas para comenzar con los productos ",

  seleccionaMateriaPrimaBusinessCentralAlertInfo:
    "Esta es la lista de materias primas de Business Central pendientes de crear o actualizar en Numier. Selecciona la materia prima de la lista para continuar. <strong>Tienes {PRODUCT_LIST_LENGTH} materias primas pendientes.</strong>",
  seleccionaDepartamentosMateriasPrimasBusinessCentralAlertInfo:
    "<strong>¿Dónde debe estar disponible la materia prima {PRODUCT_NAME}?</strong> Selecciona los departamentos donde quieres que esté disponible {PRODUCT_NAME}.",
  completarCamposMateriasPrimasBusinessCentralAlertInfo:
    "Para finalizar, completa los campos de {PRODUCT_NAME}.",
  materiaPrimaDisabledByPendingsChildrenTooltip:
    "Esta materia prima pertenece a una receta cuya materia prima aún están pendientes de sincronizar.",

  swalMateriaPrimaSincronizadaTitle: "¡Materia prima sincronizada!",
  swalMateriaPrimaSincronizadaTextNPendientes:
    "¿Quieres seguir sincronizando materias primas o prefieres terminar por ahora?",
  swalMateriaPrimaSincronizadaText0Pendientes:
    "Todas las materias primas han sido sincronizadas.",
  swalMateriaPrimaSincronizadaButtonSeguir: "Seguir sincronizando",
  swalMateriaPrimaActualizadaTitle: "¡Materia prima actualizada!",
  swalMateriaPrimaActualizadaText0Pendientes:
    "Todas las materias primas han sido actualizadas.",

  // Integración Business Central > Empty entidades pendientes
  esteNegocioNoTieneProductosParaSincronizar:
    "Todos los productos sincronizados",

  // Integración Business Central > Formas de pago
  formasDePagoBC: "Formas de pago",
  swalTipoObligatorioFormasDePago:
    "Debes seleccionar un tipo para cada forma de pago antes de finalizar.",
  formasDePagoBusinessCentralAlertInfo:
    "Relaciona las formas de pago de Business Central con las formas de pago (tipos) Efectivo, Tarjeta o Cheque de Numier. <strong>Sólo se puede seleccionar un único tipo como Efectivo, el resto como Tarjeta y Cheque.</strong>",
  noHayFormasDePagoPorConfigurar:
    "No hay formas de pago pendientes por configurar.",
  formasDePagoConfiguradasCorrectamente:
    "Todas las formas de pago han sido establecidas correctamente.",
  formaPagoGuardada: "¡Formas de pago guardadas!",
  todasFormasPagoConfiguradas: "Todas las formas de pago han sido configuradas",
  formasPagoDarDeBajaMensaje:
    "Las siguientes formas de pago deben darse de baja en Numier porque ya no están disponibles en el sistema Business Central",
  pulsaDarDeBaja: "Pulsa en dar de baja para confirmar",
  darDeBaja: "Dar de baja",
  dandoDeBajaFormasPago: "Dando de baja formas de pago...",
  formasPagoDadasDeBaja: "Formas de pago dadas de baja correctamente.",
  errorDarDeBajaFormasPago: "Error al dar de baja formas de pago.",
  errorServidorDarDeBaja: "Error al comunicar con el servidor al dar de baja.",

  // Verifactu Dashboard
  verifactu: "VERI*FACTU",
  verifactu2: "Verifactu",
  declaracionesResponsables: "Declaraciones responsables",
  conectaNumierConHacienda: "Conecta Numier con Hacienda en tan solo un par de clicks.",
  solicitar: "Solicitar",
  esperandoRespuestaNumier: "Esperando respuesta de Numier",
  seleccionarCertificado: "Seleccionar certificado.",
  enviarCertificado: "Enviar certificado.",
  subeTuCertificadoParaConectarConHacienda: "Sube tu certificado para conectar tu negocio con Hacienda.",
  seleccionarArchivo: "Seleccionar archivo.",
  ustedYaHaGuardadoElCertificadoDigital: "Ya ha guardado el certificado digital en este Negocio correctamente.",

  paraComenzarVerifactuSeleccionaNegocio: "Para comenzar con VERI*FACTU, por favor <strong>selecciona un negocio</strong> en el desplegable inferior.",
  bienvenidoA: "Bienvenido a",
  verifactuDescripcion: "<strong>Verifactu</strong> es el sistema de la Agencia Estatal de Administración Tributaria (AEAT) que permite la verificación automática de facturas, garantizando su autenticidad e integridad ante Hacienda.",
  informacionSobreVerifactu: "Información sobre VERI*FACTU",

  importanteEmpresasSII: "Importante: Empresas adscritas al SII",
  siTuEmpresaEstaAdscritaSII: "Si tu empresa está adscrita al Sistema de Suministro Inmediato de Información (SII), estás exenta de utilizar VERI*FACTU.",
  masInformacionAqui: "Más información aquí",

  automatizacionInteligente: "Automatización Inteligente",
  automatizacionInteligenteDesc: "Verificación automática de facturas sin intervención manual. El sistema procesa y valida cada documento al instante.",
  automatizacionInteligenteDetalle: "Ahorra hasta 8 horas semanales de trabajo manual",
  automatizacionInteligenteStat: "100% Automático",

  cumplimientoNormativo: "Cumplimiento Normativo",
  cumplimientoNormativoDesc: "Total conformidad con las normativas de Hacienda. Actualización automática según cambios legislativos.",
  cumplimientoNormativoDetalle: "Compatible con todas las regulaciones AEAT vigentes",
  cumplimientoNormativoStat: "Normativo AEAT",

  controlDeCalidad: "Control de Calidad",
  controlDeCalidadDesc: "Elimina errores humanos y previene fraudes mediante validación avanzada de datos.",
  controlDeCalidadDetalle: "Detección automática de inconsistencias y anomalías",
  controlDeCalidadStat: "-95% Errores",

  seguridadAvanzada: "Seguridad Avanzada",
  seguridadAvanzadaDesc: "Máxima protección en todas tus transacciones con cifrado de nivel bancario.",
  seguridadAvanzadaDetalle: "Certificados SSL y autenticación de doble factor",
  seguridadAvanzadaStat: "Cifrado SSL",

  configuracionDeVerifactu: "Configuración de Verifactu",
  paraComenzarNecesitasCertificado: "Para comenzar a trabajar con VERI*FACTU, necesitas subir tu <strong>certificado digital.</strong>",
  certificadoPermiteAutenticacion: "Este certificado permite la autenticación segura con la AEAT.",
  formatosSoportados: "Formatos soportados: <code>.pfx</code>, <code>.p12</code>.",
  aunNoTienesCertificado: "¿Aún no tienes certificado digital?",
  puedesObtenerCertificadoEn: "Puedes obtener tu certificado digital de persona física en:",
  fabricaNacionalMonedaTimbre: "Fábrica Nacional de Moneda y Timbre (FNMT)",
  yaTienesCertificadoListo: "¿Ya tienes tu certificado digital listo?",
  hazClickAbrirSelector: "Haz click aquí para abrir el selector de archivos.",
  tengoUnCertificado: "Tengo un certificado",
  hazClickSeleccionarCertificado: "Haz click y selecciona tu certificado",
  formatosMaximo: "Formatos: .pfx, .p12 (máx. 60KB)",
  subirCertificado: "Subir certificado",
  debeSeleccionarFechaInicioVerifactu: "Debe seleccionar una fecha de inicio para VERI*FACTU antes de continuar.",
  porFavorSeleccionaFechaInicioNuevamente: "Se ha encontrado un error. Por favor, selecciona la fecha de inicio nuevamente.",
  porFavorSeleccionaCertificadoNuevamente: "Por favor, selecciona el certificado nuevamente.",

  certificadoConfiguradoCorrectamente: "¡Certificado Configurado Correctamente!",
  certificadoValidadoConfigurado: "Tu certificado digital ha sido validado y configurado.",
  certificadoValidoHasta: "Certificado válido hasta",
  noSeHaPodidoVerificarFecha: "No se ha podido verificar la fecha de validez del certificado",
  facturasComplianNormativa: "Tus facturas cumplirán con la normativa VERI*FACTU.",
  sistemaListoVerificacion: "Sistema listo para la verificación automática.",
  comoFuncionaVerifactu: "¿Cómo funciona VERI*FACTU?",

  generacionAutomatica: "Generación Automática",
  generacionAutomaticaDesc: "Las facturas se generarán automáticamente con el formato y requisitos de VERI*FACTU",

  codigoQRenTickets: "Código QR en Tickets",
  codigoQRenTicketsDesc: "Cada ticket de cobro incluirá un código QR para verificar la factura en la sede de la AEAT",

  comprobacionInstantanea: "Comprobación Instantánea",
  comprobacionInstantaneaDesc: "El estado de cada factura puede ser verificado escaneando el QR desde cualquier dispositivo",

  seguridadGarantizada: "Seguridad Garantizada",
  seguridadGarantizadaDesc: "Todas las transacciones quedan registradas y protegidas con firma electrónica avanzada",

  contrasenaCertificado: "Contraseña del Certificado",
  introduceContrasenaDesc: "Por favor, introduce la contraseña de tu certificado digital para poder procesarlo correctamente.",
  contrasena: "Contraseña:",
  introduceContrasenaPlaceholder: "Introduce la contraseña del certificado",
  contrasenaRequerida: "La contraseña es requerida",
  procesando: "Procesando…",
  continuar: "Continuar",
  cancelar: "Cancelar",

  exito: "Éxito",
  seleccionaArchivoAntes: "Por favor, selecciona un archivo antes de enviar.",
  errorNegocioNoValido: "Error: No se ha seleccionado un negocio válido.",

  // Textos para negocio exento
  negocioExentoVerifactu: "Negocio Exento de VERI*FACTU",
  negocioRegistradoComoExento: "Este negocio está registrado como exento de VERI*FACTU.",
  noRequiereVerifactu: "No requiere certificado ni configuración adicional.",
  facturacionNormalContinua: "Tu facturación continuará funcionando de forma normal.",
  queSignificaExento: "¿Qué significa esto?",
  queSignificaExentoDesc: "Tu negocio no necesita cumplir con los requisitos de VERI*FACTU. Esto puede deberse a que está adscrito al Suministro Inmediato de Información (SII) o cumple con otros criterios de exención establecidos por la normativa fiscal.",
  siHayAlgunError: "¿Ha habido algún error?",
  siHayAlgunErrorDesc: "Si crees que esta clasificación es incorrecta o has tenido algún problema, por favor contacta con nuestro equipo de soporte para que podamos ayudarte.",
  noSePudoObtenerIdUsuario: "No se pudo obtener el ID de usuario.",
  verificandoCertificado: "Verificando certificado...",
  certificadoEnviadoCorrectamente: "Certificado enviado correctamente",
  respuestaInesperadaServidor: "Respuesta inesperada del servidor",

  verifactuError449: "Contraseña incorrecta o fichero inválido.",
  verifactuError552: "Ha ocurrido un error inesperado. Por favor, inténtalo de nuevo.",
  errorAlEnviarCertificado: "Error al enviar el certificado",
  noSeRecibioRespuestaServidor: "No se recibió respuesta del servidor",
  errorDeConfiguracion: "Error de configuración:",
  noSeSeleccionoArchivo: "No se seleccionó ningún archivo.",
  formatoArchivoNoValido: "Formato de archivo no válido. Use .pfx o .p12",
  archivoDemasiadoGrande: "El archivo es demasiado grande. Tamaño máximo permitido: 60KB",

  // Selector de fecha de inicio Verifactu
  cuandoDebeComenzarTuNegocio: "¿Cuándo debe comenzar tu negocio con VERI*FACTU?",
  antesDeConfigurarDebesIndicar: "Antes de configurar VERI*FACTU, debes indicar la fecha obligatoria de inicio según tu tipo de negocio.",
  consultarInformacionOficial: "Consultar información oficial",
  paraContribuyentesSociedades: "Para los contribuyentes del Impuesto sobre Sociedades",
  restoNegociosAutonomos: "Resto de negocios y autónomos. Para facilitar la adaptación al nuevo sistema.",
  miNegocioAdscritoSII: "Mi negocio está adscrito al Sistema de Información Inmediata",
  estoyExentoSII: "Estoy exento (SII)",
  seleccionar: "Seleccionar",
  fechaInicioSeleccionada: "Fecha de inicio seleccionada",
  exentoSII: "Exento (SII)",
  cambiar: "Cambiar",
  negocioExentoVerifactu: "Negocio exento de VERI*FACTU",
  tuNegocioNoRequiereVerifactu: "Tu negocio no requiere la configuración de VERI*FACTU al estar adscrito al Sistema de Información Inmediata (SII).",
  alEstarEnSIINoNecesitas: "Al estar en el SII, no necesitas implementar VERI*FACTU",
  confirmacionExencionSII: "Confirmación de exención SII",
  antesDeConfirmar: "Antes de confirmar, asegúrate de que:",
  miNegocioEstaAdscritoSistemaInmediato: "Mi negocio está adscrito al Sistema de Información Inmediata (SII)",
  tengoDocumentacionQueLoAcredita: "Tengo documentación que lo acredita",
  entiendoQueNoDebereUsarVerifactu: "Entiendo que no debo usar VERI*FACTU si estoy en SII",
  siNoEstasSegurotConsultaAsesor: "Si no estás seguro, consulta con tu asesor fiscal",
  confirmarExencion: "Confirmar exención",
  negocioMarcadoComoExento: "Negocio marcado como exento de VERI*FACTU",
  errorAlMarcarExencion: "Ha habido un error a la hora de marcar la exención. Por favor, inténtelo más tarde",

  certificadoExpiradoAlerta: "<strong>Atención:</strong> El certificado digital de este negocio ha <strong>expirado</strong>. Debes renovarlo urgentemente para mantener el cumplimiento con VERI*FACTU.",
  certificadoProximoExpirarAlerta: "<strong>Aviso:</strong> El certificado digital de este negocio está <strong>próximo a expirar</strong>. Te recomendamos renovarlo pronto para evitar interrupciones.",
  certificadoExpirado: "Certificado Expirado",
  certificadoProximoExpirar: "Certificado Próximo a Expirar",
  certificadoExpiroEl: "El certificado expiró el",
  certificadoExpiraEl: "El certificado expira el",
  certificadoYaNoValido: "El certificado digital ya no es válido. Es necesario renovarlo con urgencia.",
  certificadoProntoVencera: "El certificado digital vencerá próximamente. Se recomienda renovarlo lo antes posible.",
  sinCertificadoNoEsPosibleVerificar: "Sin el certificado en regla, no es posible realizar la verificación automática de facturas.",
  EsperarAExpiracionPuedeProvocarErrores: "No renovar a tiempo puede provocar errores en la verificación automática.",
  pongaseEnContactoConSoporteParaProceder: "Si ocurre algún error en el proceso, póngase en contacto con soporte para informarse sobre cómo proceder.",
  renovarCertificado: "Renovar tu Certificado",

  //unidades de medida dadas de baja
  unidadesMedidaDadasDeBaja: "Se han encontrado bajas en productos",
  bajasDeProductos: "Bajas de productos",

  // 21/05/2025 - Listado productos por operario
  listadoDeProductosPorOperario: "Venta de producto por operario",
  listadoProductosOperario: "Venta por operario",

  // 29/10/2025 - Bajas
  bajaEntidades: "Bajas de entidades",
  checkBajaEntidades: "Consultar y aplicar bajas de entidades eliminadas en Business Central",

  bajaProductos: "Bajas de productos",
  bajaSubproductos: "Bajas de materias primas",
  bajaFormasPago: "Bajas de formas de pago",
  bajaUdMedida: "Bajas de unidades de medida",
  bajaLineaProd: "Bajas de líneas de producto",
  bajaFormaPago: "Bajas de forma de pago",

  checkBajaProductos: "Consultar bajas de productos",
  checkBajaSubproductos: "Consultar bajas de materias primas",
  checkBajaFormasPago: "Consultar bajas de formas de pago",
  checkBajaUdMedida: "Consultar bajas de unidades de medida",
  checkBajaLineaProd: "Consultar bajas de líneas de producto",

  loadingBajaProductos: "Consultando bajas de productos...",
  loadingBajaSubproductos: "Consultando bajas de materias primas...",
  loadingBajaFormasPago: "Consultando bajas de formas de pago...",
  loadingBajaUdMedida: "Consultando bajas de unidades de medida...",
  loadingBajaLineaProd: "Consultando bajas de líneas de producto...",

  emptyBajaUdMedida: "No se han encontrado unidades de medida dadas de baja.",

  errorUnidadMedidaNoConfigurada: "No se puede crear el producto porque no tiene unidad de medida configurada desde Business Central.",
  errorUnidadMedidaMateriasPrimas: "Las siguientes materias primas no tienen unidad de medida configurada desde Business Central",

  configurarVerifactuUrgente: "Numier TPV ya esta certificada con VERI*FACTU",
  debesConfigurarVerifactuAntes15Nov: "Ya tenemos todo listo para conectar tu negocio con <span><i>VERI*FACTU</i></span>.<br />Para ello solo necesitamos que subas tu <strong>certificado digital en cada uno de tus negocios</strong>, de esa manera, llegada la fecha tendremos tu versión actualizada a la nueva <strong>normativa obligatoria de la AEAT</strong>.<br />Si necesitas más información, visita nuestras <i><a href='#/novedades' style='color: #1E22AA; text-decoration: underline; font-weight: 600;'>Novedades</a></i>.",
  subirCertificadoVerifactu: "Subir certificado <i class='fas fa-file-upload ml-1'></i>",
  verNovedades: "Ver Novedades",
  verifactuAplazadoTitulo: "VERI*FACTU aplazado hasta 2027",
  verifactuAplazadoMensaje: "Debido al <strong><a style='text-decoration: underline; font-weight: 600;' href='https://sede.agenciatributaria.gob.es/Sede/iva/sistemas-informaticos-facturacion-verifactu/nota-informativa-ampliacion-plazo-adaptacion-facturacion.html' target='_blank' rel='noopener noreferrer'>aplazamiento de la normativa VERI*FACTU</a></strong> hasta el año 2027, todos los certificados digitales alojados en los servidores de <b><i>Numier</i></b> han sido <strong>eliminados</strong> por motivos logísticos.<br/><br/>Las nuevas fechas de implementación serán:<br/><strong>• 1 de enero de 2027</strong> para contribuyentes y sociedades.<br/><strong>• 1 de julio de 2027</strong> para el resto de negocios y autónomos.<br/><br/>A medida que se acerquen las nuevas fechas, comunicaremos cualquier <b>novedad</b> o <b>cambio importante</b>.",

  verifactuProximoTitulo: "Prepárate para VERI*FACTU 2027",
  verifactuProximoMensaje: "La fecha de implementación de <span><i>VERI*FACTU</i></span> se acerca. En <strong>enero</strong> y <strong>julio de 2027</strong> entrará en vigor la nueva normativa obligatoria de facturación electrónica.<br/><br/>Para garantizar el correcto funcionamiento de tu negocio, es fundamental que <strong>subas los certificados digitales</strong> en cada una de tus sucursales lo antes posible.<br/><br/>Si necesitas ayuda, no dudes en <strong>contactar con soporte</strong>.",

  errorVariasUdsMedidasProductoConSuplemento:
    "No se puede crear el producto porque el producto base tiene varias unidades de medida configuradas desde Business Central.",

  //17/11/25 Diagnostico PLU
  diagnosticoPLU: "Diagnóstico de PLU",
  todosPluIguales: "Todos los PLU iguales",
  pluDiferentes: "PLU diferente",
  noExiste: "No existe",
  productoNoDisponible: "Producto no encontrado",
  subproductoNoDisponible: "Materia prima no encontrada",
  productoNoEncontrado: "Producto no encontrado en este negocio",
  coincide: "Mismo PLU",
  noCoincide: "PLU diferente",

  //12/12/25
  tipoRol: "Tipo de rol",

  updatedPaymentMethod: "Se han actualizado las siguientes formas de pago:",
  paymentMethodNameChanged: "El nombre de la forma de pago ha cambiado de <strong>{oldName}</strong> a <strong>{newName}</strong>.",
  noEsProductoValidoParaMutarProductoConSuple: "Este producto no cumple los requisitos para poder admitirse como producto CON o producto SUPLEMENTO.",

  paymentMethodDowngrades: "Se han encontrado bajas en formas de pago",
  downgradedPaymentMethods: "Formas de pago dadas de baja",
  unknownPaymentMethod: "Forma de pago desconocida",
  configuracionRol :  "(Esta configuración solo aplica a Numier TURNOS)",
  sinIdDeProducto: "Sin detalles",

  addSupplementPriceTitle: "Definir precio del suplemento",
  addSupplementPriceText: "Se ha detectado que el producto <strong>{PRODUCT_NAME}</strong> ahora admite ser suplemento, cuando anteriormente no lo hacía. Para poder finalizar la actualización, es necesario especificar la variación de precio que se aplicará al seleccionar este producto como suplemento. Esto se utiliza para calcular el precio final del producto incluyendo el suplemento.",
  addSupplementPriceInputLabel: "Variación de precio: ",
  productComputedInfo: "El producto seleccionado se ha detectado con más de una unidad de medida y, al mismo tiempo, es de tipo CON o SUPLEMENTO, lo cual no está admitido. Por lo tanto, se procederá a ignorar las unidades de medida y a crear un producto de tipo con/suplemento. Puede continuar rellenando el formulario o modificarlo desde Business Central.",
  materiaPrimaComputedInfo: "La materia prima vendible seleccionada se ha detectado con más de una unidad de medida y, al mismo tiempo, es de tipo CON o SUPLEMENTO, lo cual no está admitido. Por lo tanto, se procederá a ignorar las unidades de medida y a crear un producto de tipo con/suplemento. Puede continuar rellenando el formulario o modificarlo desde Business Central.",

  ocultarDTOInvitaciones: "Ocultar descuentos e invitaciones",

  modalUnidadesMedidaOpcionUnicoMasDeCuatro:
    "⚠️ Atención → Es obligatorio crear un producto independiente por cada unidad de medida, ya que el sistema admite un máximo de 4 tarifas por producto.",

  exportarPorLotesTPV: "Exportar por lotes TPV",
  modoExportacion: "Modo de exportación",
  exportacionNormal: "Exportación normal",
  exportarDatos: "Exportar datos",
  descripcionExportacionNormal: "Exporta todas las ventas juntas en una sola operación",
  descripcionExportacionTPV: "Exporta las ventas agrupadas por punto de venta (TPV)",
  importeSinDto: "Importe sin DTO.",

  //14/04/26
  invertirSeleccionIngredientes: "Invertir selección de ingredientes",
  alActivarEstaOpcionSeInvierteLaSeleccionDeIngredientes : "Al activar esta opción aparece los ingredientes del producto des-selecionados para seleccionarlos",

  //28/07/26
  actualizandoCartaSinqro : "Actualizando carta de productos en Sinqro...",
  cartaActualizadaSinqro : "Carta de productos actualizada correctamente en Sinqro.",

  businessCentralCode : "Código de Business Central",
  errorCargandoDatos: "Error al cargar los datos",
  noSeHaPodidoConsultarIntenteloMasTarde: "No se ha podido consultar, inténtelo más tarde.",
  listaPresentaMateriasPrimasNoSincronizadas: "La lista presenta materias primas que no han sido sincronizadas en su TPV, por favor inténtelo más tarde.",
  
  noTieneProveedor: "Sin proveedor, se seleccionará durante el guardado del pedido",
  seleccionarProveedorMateriasPrimas: "Seleccionar proveedor para materias primas",
  lasSiguientesMateriasPrimasNoTienenProveedor: "Las siguientes materias primas no tienen proveedor asignado. Seleccione un proveedor para cada una antes de guardar el pedido:",
  seleccioneUnProveedor: "Seleccione un proveedor",
  guardarYEnviar: "Guardar y enviar",
  dividirPedidoEntreProveedores: "Dividir pedido entre proveedores",
  modalTextMp0: "Tienes materias primas con uds y partes a 0. ¿Quieres excluirlas del pedido?",
  pedidoSinMp: "El pedido se ha quedado vacío tras excluir las materias primas.",
  excluir: "Excluir",
  
  materiaPrimaNoSincronizada: "Este subproducto aún no ha sido sincronizado con su TPV",

  noHayProductosAutoEditables: "No hay productos que se puedan sincronizar automáticamente en este momento",
  confirmarSincronizacionMasivaTitle: "¿Sincronizar todos los productos automáticos?",
  confirmarSincronizacionMasivaText: "Se van a sincronizar automáticamente {COUNT} productos sin necesidad de revisarlos uno a uno. ¿Deseas continuar?",
  siSincronizar: "Sí, sincronizar",
  sincronizando: "Sincronizando",
  sincronizacionMasivaCompletadaTitle: "Sincronización masiva completada",
  sincronizadosCorrectamente: "Sincronizados correctamente",
  errorDesconocido: "Error desconocido",
  sincronizarTodosAuto: "Sincronizar todos ({COUNT})",
  sincronizarTodos: "Sincronizar todos",
  sincronizarTodosAutoTooltip: "Sincroniza de una vez todos los productos cuyos cambios no requieren rellenar el formulario.",
  // Exportación de ventas a Business Central: tabla unificada, resúmenes y avisos
  exportacionPorLotesFija: "La exportación se envía por lotes de TPV.",
  resumenPorMedioPago: "Por medio de pago",
  resumenPorTpv: "Por TPV",
  resumenPorTipoDocumento: "Por tipo de documento",
  documento: "Documento",
  verDetalle: "Ver detalle",
  facturaQR: "Factura generada desde un pedido por QR: no pertenece a ningún día de caja",
  rectificaA: "Rectifica el documento",
  socio: "Socio",
  variasFormas: "Varias formas",
  verDetallesVenta: "Ver detalles de la venta",
  editarMedioPago: "Editar medio de pago",
  desglosePagos: "Desglose de pagos",
  valesRegalo: "Vales regalo",
  valesDelDocumentoOriginal: "del documento rectificado",
  avisos: "Avisos",
  totalDeVenta: "Total de venta:",
  ticket: "Ticket",
  rectificativa: "Rectificativa",
  origenImporteVales: "importe del vale",
  origenImporteValesOriginal: "vale del documento rectificado",
  origenImporteCobrosAvanzados: "Suma del cobro avanzado",
  seleccioneUnMedioPago: "Seleccione un medio de pago",
  importesNoEditables: "Los importes no se pueden modificar desde aquí.",
  buscarClientePorNombreCodigoODni: "Buscar por nombre, código de socio o DNI",
  medioPagoRequiereClienteTexto: "Este medio de pago se cobra contra un cliente, así que hay que asignar uno.",
  medioActual: "Medio actual",
  detallesVenta: "Detalles de la venta",
  tipoDocumento: "Tipo de documento",
  dni: "DNI / CIF",
  codigoSocio: "Código de socio",
  pago: "Pago",
  edicion: "Edición",
  ventaSinCliente: "La venta no tiene cliente asignado.",
  ventaNoEditable: "Esta venta no admite cambio de medio de pago.",
  errorCargandoFormasPago: "No se han podido cargar las formas de pago.",
  avisoFacturaSinNombre: "Factura sin nombre de cliente",
  avisoFacturaSinDocumento: "Factura sin DNI / CIF",
  avisoSocioSinCodigo: "Socio sin código: la exportación lo va a rechazar",
  avisoSocioSinCodigoSalesforce: "Socio sin código: se le pedirá a Salesforce al exportar",
  avisoMedioPagoSinCliente: "Medio de pago sin cliente asignado",
  avisoCuentaCasaClienteGenerico: "Cuenta casa sin cliente: se exportará con el cliente genérico de cuentas casa",
  avisoValeSinRegistro: "Vale regalo sin registro en la tabla de vales",
  avisoVentaSinImporte: "Venta sin importe: viajaría sin ningún pago",
  avisoRectificativaSinOriginal: "No se encuentra el documento que rectifica",
  avisoProductoSinMapeoBC: "Producto sin código de integración",
  avisoProductoSinUnidadMedida: "Producto sin unidad de medida",
  motivoVentaAvanzada: "Venta con pago avanzado: el reparto de importes no se edita desde aquí.",
  motivoVentaConVale: "Venta con vale regalo: el vale ya está consumido y registrado.",
  motivoRectificativa: "Rectificativa: tiene que cobrarse igual que el documento que corrige.",
  motivoDestinoVale: "No se puede pasar una venta a vales regalo: el vale se consume en el TPV.",
  debeCambiarFormaPagoParaGuardar: "Debe cambiar el medio de pago o el cliente para poder guardar.",
  // Exportacion BC: resumen de avisos, filtros y paginacion de la tabla
  evCargandoVentas: "Cargando las ventas pendientes de exportar...",
  evDocumentosPendientes: "Documentos pendientes",
  evDelDiaDeCaja: "del día de caja",
  evConAvisos: "Con avisos",
  evNoSeExportaran: "No se exportarán",
  evSinAvisos: "Sin avisos",
  evFiltrarPorAviso: "Pulsa un aviso para ver solo esas ventas en la tabla.",
  evVerDetalles: "Ver detalles",
  evOcultarDetalles: "Ocultar detalles",
  evErrorCargaVentas: "No se han podido cargar las ventas",
  evErrorCargaVentasTexto: "No sabemos si hay ventas pendientes: la consulta ha fallado. Vuelve a intentarlo en unos segundos.",
  evYOtros: "y {n} más",
  evBuscarVenta: "Buscar por documento o cliente",
  evFiltroTodas: "Todas",
  evFiltroListas: "Listas para exportar",
  evFiltroConAvisos: "Con avisos",
  evFiltroBloqueantes: "No se exportarán",
  evTodosLosTpv: "Todos los TPV",
  evQuitarFiltros: "Quitar filtros",
  evFiltroAviso: "Aviso",
  evSinCoincidencias: "Ningún documento coincide con los filtros.",
  evMostrandoRango: "{desde}–{hasta} de {total}",
  evPorPagina: "por página",
  evIrAlDocumento: "Ir al documento",
  evOriginalYaExportado: "exportada",
  evOriginalYaExportadoTexto: "El documento original (del {fecha}) ya se exportó",
  evRectificadaPor: "Rectificada por",
  evNivelBloqueante: "No se exportará",
  evNivelRevisar: "Revisar",
  evNivelBloqueanteTexto: "Esta venta no se enviará: se quedará pendiente hasta que se corrija.",
  evNivelRevisarTexto: "La venta se exporta, pero conviene revisarla.",
  evConNotasInformativas: "Con notas informativas",
  evCuentasSinCobrar: "Cuentas sin cobrar",
  evCuentasSinCobrarTitulo: "Cuentas sin cobrar en este día de caja",
  evCuentasSinCobrarTexto: "Suman {importe}. No se exportan mientras sigan sin cobrar.",
  evNivelInfo: "Información",
  evNivelInfoTexto: "Es solo informativo: la venta se exporta con normalidad.",
  evExportando: "Exportando…",
  evExportandoTexto: "Exportando ventas. Puede tardar unos minutos: no cierres esta página.",
  evExportarUnTpv: "Exportar un TPV",
  evExportarUnTpvDesc: "Exporta solo las ventas del TPV que elijas",
  evEligeTpv: "Elige un TPV",
  evPrimeraPagina: "Primera página",
  evUltimaPagina: "Última página",
  evSoloSeExportaraTpv: "Solo se exportará el TPV {tpv}.",
  evQueSeEnviara: "Qué se enviará",
  evSeEnviaran: "Se enviarán",
  evQuedaranPendientes: "Quedarán pendientes hasta que se corrijan",
  evCifrasDelTpv: "Cifras del TPV {tpv}.",
  evCifrasDelDepartamento: "Cifras de este departamento; los demás departamentos de la compañía también se exportan.",
  evFiltrosNoAfectanExportacion: "Los filtros de la tabla no afectan a la exportación: se envía todo lo pendiente.",
  evExportados: "Exportados",
  evRechazadosPorBC: "Rechazados por BC",
  evOmitidosPorValidacion: "Omitidos por BC",
  evResultadoPendientesTexto: "Lo que no se ha exportado sigue pendiente y aparece en la tabla con sus avisos.",
  evResultadosExportacion: "Resultados de la exportación",
  evDescargarInformeExcel: "Descargar Excel",
  evInformeEstaTanda: "Última exportación",
  evActualizarInformes: "Actualizar",
  evSinInformes: "Todavía no hay informes. Si la exportación sigue en curso, el informe aparecerá aquí cuando termine.",
  evSinRespuestaTanda: "No se ha recibido respuesta del servidor. La exportación puede seguir en curso: los estados de las ventas y el informe Excel aparecerán cuando termine. Actualiza la lista en unos minutos.",
  evDepartamentos: "Departamentos",
  evEligeDepartamentos: "Elige departamentos",
  evTodosLosDepartamentos: "Todos los departamentos",
  evTpvsAExportar: "TPVs a exportar",
  evTpvsAyuda: "Entre paréntesis, documentos sin exportar.",
  evAperturasAExportar: "Aperturas de caja a exportar",
  evAperturaMasAntigua: "La apertura más antigua pendiente",
  evAperturaMasAntiguaCadaTpv: "La apertura más antigua pendiente de cada TPV",
  evIncluirFacturasQR: "Incluir facturas QR",
  evPendientesCorto: "pend.",
  evRechazadosCorto: "rechazados BC",
  evOmitidosCorto: "omitidos",
  evExcluidosCorto: "excluidos",
  evSeExportaraSeleccion: "Se exportarán los siguientes datos",
  evResumenSeleccion: "Departamentos: {departamentos}. TPV: {tpvs}. Aperturas: {aperturas}. {qr}.",
  evConFacturasQR: "Con las facturas QR pendientes",
  evSinFacturasQR: "Sin facturas QR",
  evExportacionTpvATpv: "Se envía TPV a TPV y por tramos; lo rechazado u omitido se queda pendiente con su motivo en el Excel de la tanda.",
  evCifrasDeLaSeleccion: "Cifras de la selección actual.",
  evEstadoRechazadoBC: "Previamente rechazada",
  evEstadoOmitido: "Previamente Omitida",
  evEstadoExcluido: "Excluida",
  evExcluirDeExportacion: "Excluir de la exportación",
  evIncluirEnExportacion: "Volver a incluir en la exportación",
  evVentaExcluida: "Venta excluida de la exportación",
  evVentaIncluida: "Venta incluida de nuevo en la exportación",
  evVentasIncluidasN: "{n} ventas incluidas de nuevo en la exportación",
  evVentasExcluidasN: "{n} ventas excluidas de la exportación",
  evIncluirSoloEste: "Incluir esta",
  evIncluirTambienAsociados: "Incluir asociadas",
  evExcluirSoloEste: "Excluir esta",
  evExcluirTambienAsociados: "Excluir asociadas",
  evAsociadosIncluirPregunta: "¿Quieres volver a incluir también los asociados o solo este documento?",
  evAsociadosExcluirPregunta: "¿Quieres excluir también los asociados o solo este documento?",
  evAsociadosIncluirTexto: "El documento {doc} tiene {n} documentos asociados excluidos de la exportación:",
  evAsociadosExcluirTexto: "El documento {doc} tiene {n} documentos asociados sin exportar que no se pueden exportar sin él:",
  evAsociadosTitulo: "Documentos asociados",
  evFechaDoc: "Fecha doc.",
  avisoOriginalNoExportado: "El documento al que hace referencia no está exportado; se enviará cuando entre el original",
  avisoExcluidaManual: "Excluidas de la exportación",

  evCargarVentas: "Cargar ventas",
  evSeleccionCambiada: "Selección cambiada, pulsa para actualizar la lista.",
  evCambiosSinCargar: "Has cambiado la selección y la lista no está actualizada. Pulsa Cargar ventas antes de exportar.",
  evModoAvanzadasTitulo: "Cómo contar las ventas con varios pagos (avanzadas)",
  evAvanzadasTodas: "Todas las ventas",
  evAvanzadasSolo: "Solo avanzadas",
  evAvanzadasSin: "Sin avanzadas",
  evMasEnExcel: "… y {n} más. El detalle completo está en el Excel de exportación.",
  evMensajeEjemploParcial: "Envío parcial: algunas ventas omitidas por validación y otras rechazadas (datos de ejemplo)",
  evPrevisualizarRespuesta: "Previsualizar respuesta",
  evExcluidaTexto: "Excluida por el usuario: no se exportará hasta que se vuelva a incluir.",
  evActualizandoVentas: "Actualizando las ventas con los nuevos parámetros...",
  evActualizarVentas: "Actualizar ventas",
  evTramoNotaDefecto: "En ambas opciones la exportación se hace en lotes de 100 documentos, salvo que se configure otro tamaño más abajo.",
  evDocumentosCada: "documentos (mínimo 50)",
  evTramoDeN: "En lotes de",
  evTramoTodoDeUnaVez: "Todo de una vez",
  evPersonalizarTramos: "Configurar el tamaño del lote por envío",
  evTramoNotaTodo: "Toda la exportación irá en un único lote.",
  evTramoNota: "En ambas opciones la exportación se hace en lotes de {n} documentos.",
  evQrNoIncluidas: "No incluidas",
  evQrIncluidas: "Incluidas en la exportación",
  evFacturasQR: "Facturas QR",
  evCargandoInformes: "Cargando informes...",
  evConteoNoDisponible: "Conteo no disponible",
  evVentasExportadasN: "{n} ventas exportadas",
  evEnvioTodoJuntoDesc: "Las ventas de todos los TPV elegidos se envían juntas, en el orden en que se hicieron.",
  evEnvioTodoJunto: "Todos los TPV juntos",
  evEnvioPorTpvDesc: "Recorre los TPV elegidos uno a uno: cada TPV se envía y se resuelve por separado.",
  evEnvioPorTpv: "Por TPV",
  evModoEnvio: "Envío",
  evInformesExportacion: "Últimos informes de exportación",
  evLineasVenta: "Líneas de la venta",
  evCargandoLineas: "Cargando las líneas…",
  evErrorCargandoLineas: "No se han podido cargar las líneas.",
  evVolverAIntentar: "Volver a intentar",
  evSinLineas: "La venta no tiene líneas.",
  evCodigoBC: "Código BC",
  evUds: "Uds.",
  evUnidadBC: "Unidad",
  evMenu: "Menú",
  evIncluidoEnMenu: "Incluido",
  evTotalLineas: "Total",
  evImporteDeLaVenta: "Importe de la venta",
  evDescuento: "Dto.",
  // Informe de cierre de caja (Z)
  cierreCajaZDescripcion: "Arqueo completo de cada Z: ventas, formas de pago, impuestos, productos y tickets",
  todaLaEmpresa: "Toda la empresa",
  estadoZ: "Estado de la Z",
  zCerradas: "Solo cerradas",
  zAbiertas: "Solo abiertas",
  zAbierta: "Abierta",
  zCerrada: "Cerrada",
  consultarRangoFechas: "Consultar un rango de fechas",
  ocultarFilasSinDatos: "Ocultar filas sin datos",
  zEnElInforme: "Z en el informe",
  ocultarDetalle: "Ocultar detalle",
  quitarFranja: "Quitar franja horaria",
  documentos: "Documentos",
  buscarDocumento: "Buscar documento (nº, cliente, operario, mesa)",
  limpiar: "Limpiar",
  sector: "Sector",
  seleccionaSector: "Selecciona un sector",
  desplazarIzquierda: "Desplazar a la izquierda",
  desplazarDerecha: "Desplazar a la derecha",
  verIncidencias: "Ver incidencias",
  incidenciasTexto: "Precios, cantidades y líneas modificadas o eliminadas en el TPV durante la Z",
  todasLasIncidencias: "Todas las incidencias",
  todasLasZ: "Todas las Z",
  caja: "Caja",
  sinIncidencias: "No hay incidencias con ese filtro",
  bloqueResumen: "Resumen",
  bloqueAnalisisVentas: "Análisis de ventas",
  fechaCaja: "Fecha de caja",
  propinas: "Propinas",
  ventasSinPropinas: "Ventas sin propinas",
  formaPagoTipoSaldo: "Pago saldo",
  incidenciasPrecioModificado: "Precio modificado",
  incidenciasLineaEliminada: "Línea eliminada",
  incidenciasCantidadModificada: "Cantidad modificada",
  incidenciasDescuentoModificado: "Descuento modificado",
  incidenciasOtras: "Otras incidencias",
  rangoNoDisponibleSectores: "Con sectores solo se puede consultar un día: el sector agrupa muchos TPV y un rango de fechas haría el informe inmanejable. Para acotar por TPV usa el filtro de la barra de vista, una vez cargado el informe.",
  analisisNegocio: "Análisis de negocio",
  analisisNegocioDescripcion: "Comparativas de ventas, formas de pago, incidencias y rentabilidad entre meses y años",
  anPeriodo: "Periodo",
  anModoMes: "Mes",
  anModoRango: "Rango",
  anModoAnio: "Año",
  anMes: "Mes a analizar",
  anCompararCon: "Comparar con",
  anMesAnteriorYAnioAnterior: "Mes anterior y mismo mes del año anterior",
  anMesAnterior: "Mes anterior",
  anMismoMesAnioAnterior: "Mismo mes del año anterior",
  anSinComparar: "Sin comparar",
  anPeriodoA: "Periodo A",
  anPeriodoB: "Periodo B",
  anPeriodoC: "Periodo C",
  anAnio: "Año a analizar",
  anAnioAnteriorMismaFecha: "Año anterior hasta la misma fecha",
  anRecalcular: "Recalcular",
  anRecalcularAyuda: "Recalcular ignorando los datos guardados. Úsalo si se han resubido datos de un TPV. Máximo una vez por hora y tres al día.",
  anRecalcularEspera: "Ya se ha recalculado hace poco. Podrás volver a hacerlo en {tiempo}.",
  anRecalcularEsperaDia: "Ya se han hecho tres recálculos en las últimas 24 horas. Podrás volver a recalcular en {tiempo}.",
  anRecalcularConfirmacion: "Se borrarán los datos guardados de los TPV y meses consultados y se volverán a calcular. Puede tardar unos segundos.",
  anCalculandoPeriodos: "Calculando los periodos seleccionados…",
  anSinDatos: "Sin ventas en el periodo",
  anSinDatosTexto: "No hay sesiones de caja ni documentos en el ámbito y el periodo seleccionados.",
  anPeriodosDistintaLongitud: "Periodos de distinta duración: compara las medias",
  anPestanaVentas: "Ventas",
  anPestanaFormasPago: "Formas de pago",
  anPestanaIncidencias: "Incidencias",
  anPestanaRentabilidad: "Rentabilidad",
  anProximamente: "Disponible en la siguiente fase",
  anEvolucionMensual: "Evolución mensual",
  anUltimos13Meses: "últimos 13 meses",
  anMediaDiaria: "Media diaria",
  anCalculandoMesesAntiguos: "Calculando meses anteriores…",
  anVentasPorDia: "Ventas por día",
  anAlinearPorDiaSemana: "Alinear por día de la semana",
  anVentasPorDiaSemana: "Ventas por día de la semana",
  anMediaPorDiaConVentas: "media por día con ventas",
  anVentasPorHora: "Ventas por hora",
  anPorNegocioYTpv: "Por negocio y TPV",
  anVariacion: "Variación",
  sesiones: "Sesiones",
  anCompletaPeriodo: "Completa el periodo para consultar",
  anPeriodoInvertido: "El fin del periodo es anterior a su inicio",
  anMaximo12Meses: "Cada periodo puede abarcar como máximo 12 meses",
  anCalculadosAhora: "{n} de {total} TPV·mes calculados ahora; el resto de los datos guardados",
  anDatosDeCache: "Datos guardados (calculados el {fecha})",
  anHasta: "hasta",
  anNotaDistintaLongitud: "Los periodos no tienen la misma duración: fíjate en las medias",
  anNotaAlineadoSemana: "Alineado por día de la semana: el día 1 es el primer lunes de cada periodo",
  anNotaBisiesto: "{periodo} incluye el 29 de febrero de {anio}, que no tiene pareja en el otro periodo",
  anDia: "Día",
  anFormasPagoMesesCompletos: "El reparto por forma de pago se calcula sobre meses completos: el corte por día del periodo no se aplica aquí.",
  anRepartoPorTipo: "Reparto por tipo de pago",
  anTiposPorPeriodo: "Tipos de pago por periodo",
  anEvolucionFormasPago: "Evolución de las formas de pago",
  anEnPorcentaje: "En porcentaje",
  anPorTipoYMedio: "Por tipo y medio de pago",
  formaPago: "Forma de pago",
  anPorcentajeMediosNota: "El % de cada tipo es sobre el total del periodo; el de cada medio, sobre su tipo.",
  anRatioIncidencias: "{n} incidencias por cada 100 documentos",
  anRatioFrenteA: "ratio frente a",
  anTipoPredominante: "Tipo predominante",
  anEvolucionIncidencias: "Evolución de las incidencias",
  anBarrasTotalLineaRatio: "barras: total · línea: por 100 documentos",
  anIncidenciasPorDia: "Incidencias por día",
  anPulsaDiaParaCierreZ: "pulsa un día para abrir su Cierre de caja Z",
  anIncidenciasPorTipo: "Incidencias por tipo",
  anIncidenciasPorOperario: "Incidencias por operario",
  anIncidenciasPorProducto: "Incidencias por producto afectado",
  anAQueSeDeben: "a qué se deben",
  anPor100Docs: "Por 100 docs.",
  anVariacionRatio: "Variación del ratio",
  anCoberturaCoste: "{conCoste} de {total} ítems vendidos tienen coste de escandallo ({pct} % de las ventas sin IVA); solo esos se clasifican.",
  anCosteActualNota: "El coste es el actual del escandallo de cada producto, no el que tenía en el periodo.",
  anRentabilidadMesesCompletos: "La rentabilidad se calcula sobre meses completos: el corte por día no se aplica aquí.",
  anPorProductoYTarifa: "Producto × tarifa",
  anPorProducto: "Producto",
  anTodasLasCategorias: "Todas las categorías",
  anTodosLosCuadrantes: "Todos los cuadrantes",
  anSinCoste: "Sin coste",
  anItems: "ítems",
  anMargenContribucion: "Margen de contribución",
  anUmbrales: "Umbrales del periodo",
  anIndicePopularidadMedio: "Índice de popularidad medio",
  anRentabilidadMedia: "Rentabilidad media (MC por unidad)",
  anMediaCoste: "Media de coste",
  anMatrizPopularidadMargen: "Matriz popularidad × margen",
  anMatrizExplicacion: "cada burbuja es un ítem; el tamaño, su margen total; las líneas, los umbrales",
  anMargenPorCuadrante: "Margen total por cuadrante",
  anTopMargen: "Mayor margen total",
  anCambiosCuadrante: "Cambios de cuadrante",
  anTablaIngenieriaMenu: "Ingeniería de menú",
  anNumeroVentas: "Nº ventas",
  anCosteProducto: "Coste",
  anPrecioVentaSinIva: "PVP sin IVA",
  anIndicePopularidad: "Índice de popularidad",
  anCosteProductoPct: "% coste",
  anTotalCoste: "Total coste",
  anTotalVentas: "Total ventas",
  anMargenContribucionTotal: "MC total",
  anClasifRentabilidad: "Rentabilidad",
  anClasifPopularidad: "Popularidad",
  anClasifFinal: "Clasificación",
  anTarifaNoIdentificada: "Tarifa no identificada: se ha asignado a la tarifa 1",
  anNuevo: "nuevo",
  anAlta: "Alta",
  anBaja: "Baja",
  anSinUnidades: "Sin unidades netas",
  anPrincipiosOmnes: "Precios: principios de Omnes",
  anTodaLaCarta: "Toda la carta vendida",
  anDispersionPrecios: "Dispersión de precios",
  anDispersionTexto: "Precio más alto {max} / más bajo {min}",
  anDispersionIdeal: "Ideal entre 2,5 y 3 en gamas de más de 12 platos",
  anDispersionNoAplica: "El criterio (2,5–3) se aplica a gamas de más de 12 platos",
  anAmplitudGama: "Amplitud de gama",
  anAmplitudTexto: "Bandas de igual anchura; cortes en {bajo} y {alto}. Ideal 25 / 50 / 25 %.",
  anRelacionCalidadPrecio: "Relación calidad-precio",
  anPrecioMedioSolicitado: "Precio medio solicitado",
  anPrecioMedioOfertado: "Precio medio ofertado",
  anSimularCambioPrecios: "Simular cambio de precios",
  anBandaBaja: "Banda baja",
  anBandaMedia: "Banda media",
  anBandaAlta: "Banda alta",
  anActual: "Actual",
  anIdeal: "Ideal",
  anRecomendableSubir: "Recomendable subir precios (ratio > 1,00)",
  anRecomendableBajar: "Recomendable bajar precios (ratio < 0,90)",
  anRecomendableMantener: "Precios adecuados: mantener (ratio 0,90–1,00)",
  anCuadranteLider: "Líder",
  anCuadrantePopular: "Popular",
  anCuadranteRentable: "Rentable",
  anCuadranteRevisar: "A revisar",
  anCuadranteLiderAyuda: "Popularidad alta y margen alto: los platos que sostienen el negocio. Mantener y destacar.",
  anCuadrantePopularAyuda: "Se vende mucho pero deja poco margen: revisar coste o precio.",
  anCuadranteRentableAyuda: "Buen margen pero se vende poco: darle visibilidad o reubicarlo en la carta.",
  anCuadranteRevisarAyuda: "Ni se vende ni deja margen: candidato a cambiar o retirar.",
  anExportarPdfAyuda: "Exportar la pestaña actual a PDF (gráficas y tablas)",
  anExportarExcelAyuda: "Exportar la pestaña actual a Excel (una hoja por bloque)",
  verAnalisisNegocio: "Ver análisis",
  verAnalisisNegocioAyuda: "Abrir 'Análisis de negocio' con esta empresa, estos negocios y el mes de la fecha consultada",
  proximamente: "Próximamente",
  verAnalisisNegocioProximamente: "El informe 'Análisis de negocio' estará disponible próximamente",
  anPeriodosReordenados: "Los periodos se muestran del más reciente al más antiguo: {reciente} es el periodo principal y la variación indica cuánto ha cambiado respecto a {antiguo}.",
  anVariacionDireccion: "Variación de {antiguo} a {reciente}: cuánto ha cambiado el periodo reciente respecto al anterior.",
  anExportarEsperaCarga: "Espera a que termine de cargar la pestaña para exportarla.",
  sinSesionesDeCaja: "No hay sesiones de caja",
  sinSesionesDeCajaTexto: "Ningún TPV del ámbito abrió caja en la fecha seleccionada. La Z se asigna al día en que se abre, aunque cierre pasada la medianoche.",
  tpvsSinApertura: "TPV sin apertura",
  facturasQRExcluidasTexto: "Las facturas QR no pertenecen a ninguna Z y no se incluyen en este informe: tienen su propio informe.",
  franjaHoraria: "Franja horaria",
  franjaHorariaSoloAnalisis: "La franja solo filtra productos y tickets. El arqueo es de la sesión completa y no se ve afectado.",
  aplicar: "Aplicar",
  productosVendidos: "Productos vendidos",
  productosVendidosTexto: "Cantidad de cada producto que sale por Z. No incluye anulaciones, stock ni mermas.",
  todosLosDocumentos: "Todos los documentos",
  formasPago: "Formas de pago",
  invitacion: "Invitación",
  cuentaCasa: "Cuenta casa",
  valeRegalo: "Vale regalo",
  bloqueIdentificacion: "Identificación",
  bloqueVentas: "Ventas",
  bloqueFormasPago: "Formas de pago",
  bloqueArqueo: "Arqueo",
  bloqueImpuestos: "Impuestos",
  numeroZ: "Nº de Z",
  operarioCierre: "Operario",
  duracionHoras: "Duración (horas)",
  primerDocumento: "Primer documento",
  ultimoDocumento: "Último documento",
  numIncidencias: "Incidencias",
  numAnulados: "Documentos anulados",
  ventasBrutas: "Ventas",
  abonos: "Abonos",
  ventasTotales: "Ventas totales",
  numDocumentos: "Nº de documentos",
  numTickets: "Tickets",
  numFacturas: "Facturas",
  numRectificativas: "Rectificativas",
  ticketMedio: "Ticket medio",
  mediaPorComensal: "Media por comensal",
  numInvitaciones: "Nº de invitaciones",
  importeInvitaciones: "Importe invitaciones",
  formaPagoTipoEfectivo: "Efectivo",
  formaPagoTipoTarjeta: "Tarjeta",
  formaPagoTipoCheque: "Cheque",
  formaPagoTipoOtros: "Otros",
  totalFormasPago: "Total formas de pago",
  ventaSegunTpv: "Venta según el TPV",
  diferenciaConDocumentos: "Diferencia con los documentos",
  cambioInicial: "Cambio inicial",
  gastosCaja: "Gastos de caja",
  totalCalculado: "Total calculado",
  totalDeclarado: "Total declarado",
  retirado: "Retirado",
  nuevaFianza: "Nueva fianza",
  baseImponibleIva: "Base imponible IVA",
  cuotaIva: "Cuota IVA",
  baseImponibleTotal: "Base imponible total",
  totalImpuestos: "Total impuestos",
  avisoZAbierta: "Z sin cerrar: no se puede arquear",
  avisoZDuracionExcesiva: "Z abierta más tiempo del normal",
  avisoZConIncidencias: "Z con incidencias",
  avisoZSinVentas: "Z sin ventas",

  // --- Horario de disponibilidad Sinqro ---
  configurarHorarioSinqro: "Configurar horario de disponibilidad",
  horarioSinqroOnAyuda: "Selecciona un horario o crea uno nuevo; el activo es el que se envía a Sinqro.",
  horarioSinqroOffAyuda: "Si no configuras un horario, en Sinqro la carta quedará disponible las 24 h.",
  copiarATodosLosDias: "Copiar al resto de días",
  anadirTramo: "Añadir tramo",
  horarioSinqroSinTramos: "Has activado el horario pero hay días sin tramos válidos. Completa las horas o desactiva el horario.",
  horarioSinqroRangoInvalido: "Hay tramos con la hora de fin anterior o igual a la de inicio.",

  // --- Biblioteca de horarios Sinqro ---
  seleccionaHorario: "Selecciona un horario",
  crearNuevoHorario: "Crear nuevo horario",
  nombreHorario: "Nombre del horario",
  guardarHorario: "Guardar horario",
  horarioGuardado: "Horario guardado",
  horarioEliminado: "Horario eliminado",
  confirmarEliminarHorario: "¿Eliminar este horario? Esta acción no se puede deshacer.",
  sinHorarios: "Este negocio aún no tiene horarios. Crea uno nuevo.",
  nombreHorarioObligatorio: "Ponle un nombre al horario.",
  horarioActivoAyuda: "El horario seleccionado será el que se envíe a Sinqro.",

  // --- Etiquetas del negocio (pantalla nueva) ---
  etiquetasDelNegocio: "Etiquetas del negocio",
  etiquetasClasifican: "Clasifican materias primas y proveedores.",
  etiquetasDosFamilias: "Dos familias que no se mezclan: una materia prima solo lleva etiquetas de materia prima.",
  deMateriaPrima: "De materia prima",
  deProveedor: "De proveedor",
  conProblema: "Con problema",
  familiasDeEtiquetas: "Familias de etiquetas",
  sinTipo: "Sin tipo",
  verTodas: "Ver todas",
  sinNombre: "(sin nombre)",
  sinEtiquetaExplica: "materias primas que no tienen ninguna etiqueta asignada",
  sinEtiquetasEnEstaFamilia: "Este negocio no tiene etiquetas de esta familia.",
  notaEtiquetas: "Las etiquetas viven en el TPV servidor del negocio, no una por terminal. Esta pantalla las enseña todas, incluidas las que el resto del panel no llega a mostrar.",
  estadoRaiz: "etiqueta principal",
  estadoDentroDe: "dentro de «{padre}»",
  estadoDeBaja: "dada de baja",
  estadoNombreRepetido: "hay más de una etiqueta con este nombre",
  estadoSinTipo: "no es ni de materia prima ni de proveedor",
  estadoBucle: "es su propia etiqueta padre",
  estadoHuerfana: "cuelga de la etiqueta {code}, que no existe o no es de esta familia",
  estadoNoSeVe: "no se ve en el resto del panel: su rama se corta antes de llegar a ella",
  avisoEtiquetasOcultas: "<b>Una etiqueta de materia prima no se ve en el resto del panel</b>, «{nombre}», con {m} materias primas dentro. Sale en el listado, pero no se puede elegir al editar una ficha. | <b>{n} etiquetas de materia prima no se ven en el resto del panel</b>, entre ellas «{nombre}», con {m} materias primas dentro. Salen en el listado, pero no se pueden elegir al editar una ficha.",
  avisoMpConEtiquetaProveedor: "<b>Una materia prima lleva una etiqueta de proveedor.</b> Son dos familias distintas: esa etiqueta no debería poder elegirse aquí. | <b>{n} materias primas llevan una etiqueta de proveedor.</b> Son dos familias distintas: esas etiquetas no deberían poder elegirse aquí.",
  avisoMpConEtiquetaSinTipo: "<b>Una materia prima lleva una etiqueta sin tipo.</b> No es ni de materia prima ni de proveedor, así que no se agrupa en ninguna parte. | <b>{n} materias primas llevan una etiqueta sin tipo.</b> No son ni de materia prima ni de proveedor, así que no se agrupan en ninguna parte.",
  avisoMpConEtiquetaDeBaja: "<b>Una materia prima lleva una etiqueta dada de baja.</b> La etiqueta existe, pero la ficha ya no la ofrece, así que desde el panel no hay forma de sacarla de ahí. | <b>{n} materias primas llevan una etiqueta dada de baja.</b> Las etiquetas existen, pero la ficha ya no las ofrece, así que desde el panel no hay forma de sacarlas de ahí.",
  avisoMpConEtiquetaInexistente: "<b>Una materia prima apunta a una etiqueta que no existe.</b> La referencia está rota: no aparece en ningún informe por etiqueta. | <b>{n} materias primas apuntan a una etiqueta que no existe.</b> Las referencias están rotas: no aparecen en ningún informe por etiqueta.",
  avisoEtiquetasSinTipo: "<b>Hay una etiqueta sin tipo.</b> No sale en ninguna lista, y las que cuelgan de ella tampoco. | <b>Hay {n} etiquetas sin tipo.</b> No salen en ninguna lista, y las que cuelgan de ellas tampoco.",
  avisoMpSinEtiqueta: "<b>Una materia prima no tiene etiqueta.</b> No aparece agrupada en ningún informe por etiqueta. | <b>{n} materias primas no tienen etiqueta.</b> No aparecen agrupadas en ningún informe por etiqueta.",
  avisoEtiquetaRepetida: "<b>Hay {n} etiquetas llamadas «{nombre}»</b> en {familia}. Al elegir una no hay forma de saber cuál es cuál.",

  // --- Alta de etiqueta ---
  familia: "Familia",
  queEsCadaFamilia: "Qué es cada familia",
  ayudaFamiliaMateriaPrima: "clasifica las materias primas del almacén. Es la única que se puede asignar a una materia prima, y la que agrupa los informes de compras e inventario.",
  ayudaFamiliaProveedor: "clasifica a los proveedores, para agruparlos en los informes de gasto. No se puede asignar a una materia prima.",
  ningunaEsPrincipal: "Ninguna — será una etiqueta principal",
  ayudaEtiquetaPadre: "Solo se ofrecen etiquetas activas de la misma familia: una etiqueta que cuelga de otra familia deja de verse en el resto del panel.",
  nombreEtiquetaObligatorio: "Ponle un nombre a la etiqueta.",
  etiquetaCreada: "Etiqueta creada.",
  noSeHaPodidoGuardar: "No se ha podido guardar. Inténtalo de nuevo.",

  // --- Edicion y baja de etiqueta ---
  editarEtiqueta: "Editar etiqueta",
  reactivar: "Reactivar",
  padreCode: "código {code} (no existe)",
  laFamiliaNoSeCambia: "La familia no se cambia: las materias primas que ya la llevan dejarían de cumplir la regla. Si hace falta otra, crea una etiqueta nueva.",
  etiquetaGuardada: "Etiqueta guardada.",
  etiquetaDadaDeBaja: "Etiqueta dada de baja.",
  etiquetaReactivada: "Etiqueta reactivada.",
  darDeBajaEtiqueta: "Dar de baja «{nombre}»",
  bajaConMateriasPrimas: "Tiene 1 materia prima dentro, que se quedará apuntando a una etiqueta de baja. | Tiene {n} materias primas dentro, que se quedarán apuntando a una etiqueta de baja.",
  bajaConHijas: "Cuelga 1 etiqueta de ella, que se quedará sin padre válido. | Cuelgan {n} etiquetas de ella, que se quedarán sin padre válido.",
  bajaSinConsecuencias: "No tiene materias primas ni otras etiquetas dentro. Podrás reactivarla cuando quieras.",
  aQueEtiquetaVan: "¿A qué etiqueta van?",
  bajaHijasSuben: "Cuelga 1 etiqueta de ella, que pasará a {padre}. | Cuelgan {n} etiquetas de ella, que pasarán a {padre}.",
  ningunaSeranPrincipales: "ser etiquetas principales",
  bajaDejarSinEtiqueta: "Dejarla sin etiqueta en vez de reasignarla | Dejar las {n} sin etiqueta en vez de reasignarlas",
  bajaMpReasignadas: "1 materia prima reasignada. | {n} materias primas reasignadas.",
  bajaMpSinEtiqueta: "1 materia prima se ha quedado sin etiqueta. | {n} materias primas se han quedado sin etiqueta.",
  bajaHijasMovidas: "1 etiqueta ha subido de nivel. | {n} etiquetas han subido de nivel.",

  // --- Materias primas a revisar (modal de la pantalla de etiquetas) ---
  verYAsignar: "Ver y asignar",
  asignarFamilia: "Asignar familia",
  tituloSinTipo: "Etiquetas sin familia",
  ayudaSinTipo: "No son ni de materia prima ni de proveedor, así que no salen en ninguna lista, y lo que cuelga de ellas tampoco. Marca las que quieras y elige la familia que les corresponde.",
  queFamiliaLesCorresponde: "¿Qué familia les corresponde?",
  pistaMateriasPrimas: "1 materia prima dentro | {n} materias primas dentro",
  pistaHijas: "1 etiqueta dentro, de {familia} | {n} etiquetas dentro, de {familia}",
  pistaNadie: "nadie la usa",
  sinTipoNadaQueVer: "Todas las etiquetas tienen su familia.",
  familiaAsignada: "Familia asignada a 1 etiqueta. | Familia asignada a {n} etiquetas.",
  tituloRevisar_sinEtiqueta: "Materias primas sin etiqueta",
  tituloRevisar_etiquetaProveedor: "Materias primas con etiqueta de proveedor",
  tituloRevisar_etiquetaSinTipo: "Materias primas con etiqueta sin tipo",
  tituloRevisar_etiquetaDeBaja: "Materias primas con etiqueta de baja",
  tituloRevisar_etiquetaInexistente: "Materias primas con etiqueta inexistente",
  ayudaRevisar_sinEtiqueta: "No están agrupadas en ningún informe por etiqueta. Marca las que quieras y elige abajo a qué etiqueta van.",
  ayudaRevisar_etiquetaProveedor: "Llevan una etiqueta de otra familia. Marca las que quieras y elige abajo una etiqueta de materia prima.",
  ayudaRevisar_etiquetaSinTipo: "Su etiqueta no es ni de materia prima ni de proveedor, así que no agrupa en ninguna parte. Marca las que quieras y elige abajo una etiqueta de materia prima.",
  ayudaRevisar_etiquetaDeBaja: "Su etiqueta está dada de baja, así que la ficha de la materia prima ya no la ofrece. Marca las que quieras y elige abajo una etiqueta que esté de alta.",
  ayudaRevisar_etiquetaInexistente: "Apuntan a una etiqueta que ya no está. Marca las que quieras y elige abajo a qué etiqueta van.",
  seleccionarNinguna: "Ninguna",
  revisarTruncado: "Se muestra la primera de {total}. Usa el buscador para llegar al resto. | Se muestran las primeras {n} de {total}. Usa el buscador para llegar al resto.",
  revisarSinPermiso: "Puedes ver el listado, pero no tienes permiso para editar materias primas, así que no puedes reasignarlas.",
  revisarNadaQueVer: "No queda ninguna en este estado.",
  asignarEtiqueta: "Asignar esta etiqueta",
  elegirEtiquetaDestino: "Elige una etiqueta de materia prima",
  etiquetasDeMateriaPrima: "Etiquetas de materia prima",
  quitarEtiqueta: "Quitar la etiqueta",
  sinResultados: "Ninguna etiqueta coincide",
  dejarSinEtiqueta: "Dejar sin etiqueta",
  asignarACuantas: "Asignar | Asignar a {n}",
  confirmarDejarSinEtiqueta: "Se quedará sin ninguna etiqueta y no aparecerá agrupada en los informes por etiqueta. | Las {n} se quedarán sin ninguna etiqueta y no aparecerán agrupadas en los informes por etiqueta.",
  materiasPrimasAsignadas: "Etiqueta asignada a 1 materia prima. | Etiqueta asignada a {n} materias primas.",
  etiquetaSinNombre: "(etiqueta sin nombre)",
  destinoOculto: "No se ven en el resto del panel",
  avisoDestinoOculto: "Esa etiqueta no se ve en el resto del panel: su rama se corta antes de llegar a ella. Las materias primas quedarán agrupadas, pero seguirás sin poder elegirla al editar una ficha.",
  errorInesperado: "Ha pasado algo inesperado. Inténtalo de nuevo.",
  // Pausas en el informe de turnos (app de gestión de turnos)
  tpPausas: "Pausas",
  tpPorDias: "Por días",
  tpPorTurnos: "Por turnos",
  tpHorario: "Horario",
  tpDesayuno: "Desayuno",
  tpCigarro: "Cigarro",
  tpDescanso: "Descanso",
  tpOtra: "Otra",
  tpEnCurso: "en curso",
  tpTurnoDe: "turno de",
  tpJornadaPartida: "Jornada partida",
  tpParon: "Parón entre turnos",
  tpDias: "días",
  tpNota: "Pulsa un día para ver su detalle. Las pausas son informativas: no cambian las horas ni el sueldo.",
  // --- Categorias del negocio (Configuracion > Categorias) ---
  terminales: "Terminales",
  desiguales: "Desiguales",
  gruposDeCategorias: "Grupos de categorías",
  vistaListado: "Vista en lista",
  vistaColumnas: "Vista en columnas",
  verLos4Grupos: "Ver los 4 grupos",
  catDe: "de",
  pantallaDelTerminal: "{n}ª pantalla del TPV",
  reindexar: "Reindexar",
  grupoCompleto: "Grupo completo",
  seGuardaEnTerminales: "Se guardará en el terminal del negocio. | Se guardará en los {n} terminales del negocio.",
  sinCategoriaExplica: "productos de este grupo que no están en ninguna categoría",
  huecoConBajasExplica: "solo le quedan productos de baja; libérala para poder reutilizarla",
  liberarRanura: "Liberar",
  liberarRanuraTitulo: "¿Liberar esta ranura?",
  liberarRanuraTexto: "Sus productos de baja se quedan sin categoría y la ranura queda libre para una categoría nueva o para reindexar. Los productos de alta no se tocan.",
  ranuraLiberada: "Ranura liberada",
  huecoLibreExplica: "aquí había una categoría; su sitio sigue reservado",
  verProductos: "Ver productos",
  usarEsteHueco: "Usar este hueco",
  nombreCategoriaNueva: "Nombre de la categoría nueva",
  seCrearaAlFinalDelGrupo: "Se creará vacía, al final del grupo {g}, en el terminal del negocio. | Se creará vacía, al final del grupo {g}, en los {n} terminales.",
  grupoVacio: "Este grupo está vacío. Las categorías que crees aquí saldrán en la {n}ª pantalla del TPV.",
  fueraDeLosGrupos: "Fuera de los cuatro grupos",
  fueraDeLosGruposExplica: "el terminal las usa, pero su tecla no es de las 40 habituales",
  verDeUnoEnUno: "Ver los grupos de uno en uno",
  mostrarLos4Grupos: "Mostrar los 4 grupos",
  notaGruposTerminal: "Los cuatro grupos son los que el camarero ve en el terminal. Una categoría se crea dentro de un grupo y se queda ahí; añadir la coloca al final de su grupo, y editar o eliminar no mueve a las demás.",
  productosAsignados: "1 producto asignado a «{categoria}». | {n} productos asignados a «{categoria}».",
  reordenar: "Reordenar",
  avisoOrdenDistinto: "<b>En 1 terminal las categorías están en otras teclas que en el servidor.</b> Reordénalas antes de nada: mientras tanto, los demás avisos pueden no ser ciertos. | <b>En {n} terminales las categorías están en otras teclas que en el servidor.</b> Reordénalas antes de nada: mientras tanto, los demás avisos pueden no ser ciertos.",
  avisoOtroNombre: "<b>Un terminal llama «{otro}» a la categoría «{nombre}», del grupo {g}.</b> Los camareros que usen ese terminal ven otro nombre para la categoría.",
  unificar: "Unificar",
  avisoNombreRepetido: "<b>Hay dos categorías llamadas «{nombre}»</b>, en el grupo {g1} y en el {g2}, con {p1} y {p2} productos.",
  avisoDesiguales: "<b>Una categoría no ha llegado a todos los terminales.</b> Está creada en el negocio pero falta el nombre en alguno, así que allí sus productos no salen agrupados. | <b>{n} categorías no han llegado a todos los terminales.</b> Están creadas en el negocio pero falta el nombre en alguno, así que allí sus productos no salen agrupados.",
  avisoDesigualesSinNinguna: "El terminal {terminales} no tiene ninguna. | Los terminales {terminales} no tienen ninguna.",
  aplicarATodos: "Aplicar a todos",
  avisoTerminalesSinCategorias: "<b>Un terminal no tiene ninguna categoría.</b> Un producto creado ahí no aparecerá en ninguna. | <b>{n} terminales no tienen ninguna categoría.</b> Un producto creado ahí no aparecerá en ninguna.",
  avisoProductosSinCategoria: "<b>Un producto no está en ninguna categoría.</b> Se vende, pero los camareros solo llegan a él buscando. | <b>{n} productos no están en ninguna categoría.</b> Se venden, pero los camareros solo llegan a ellos buscando.",
  avisoTerminalPendiente: "<b>El terminal {terminales} es nuevo y aún no ha subido su carta.</b> La copiará del servidor al arrancar y la subirá; hasta entonces no se le escribe nada desde aquí ni cuenta en estos avisos. | <b>Los terminales {terminales} son nuevos y aún no han subido su carta.</b> La copiarán del servidor al arrancar y la subirán; hasta entonces no se les escribe nada desde aquí ni cuentan en estos avisos.",
  unTerminalLaLlama: "un terminal la llama «{otro}»",
  pendienteEnTerminales: "pendiente en 1 terminal | pendiente en {n} terminales",
  enOtraTeclaEnTerminal: "en un terminal está en otra tecla; se arregla al reordenar",
  avisoSoloEnClientes: "<b>«{nombre}», del grupo {g}, solo existe en el terminal {terminales}.</b> El servidor no la tiene, y es quien manda: créala en él si es buena, o quítala del terminal. | <b>«{nombre}», del grupo {g}, solo existe en los terminales {terminales}.</b> El servidor no la tiene, y es quien manda: créala en él si es buena, o quítala de esos terminales.",
  crearEnServidor: "Crear en el servidor",
  quitarDelTerminal: "Quitar del terminal | Quitar de los terminales",
  soloEnTerminalSinServidor: "solo en {terminales}; el servidor no la tiene",
  crearEnServidorTitulo: "¿Crear «{nombre}» en el servidor?",
  crearEnServidorExplica: "El servidor no la tiene. Se crea en él y en los terminales donde falte.",
  bajaSoloEnClientes: "Solo la tiene {terminales}. El servidor no cambia.",
  enTodosLosTerminales: "en el único terminal | en los {n} terminales",
  nombreVacio: "El nombre no puede quedar vacío. Si quieres quitarla, usa Eliminar.",
  categoriaGuardada: "Categoría guardada en el terminal. | Categoría guardada en los {n} terminales.",
  categoriaCreada: "Categoría creada en el terminal. | Categoría creada en los {n} terminales.",
  productosMovidos: "1 producto movido a la otra categoría. | {n} productos movidos a la otra categoría.",
  productosSinCategoriaAhora: "1 producto se ha quedado sin categoría. | {n} productos se han quedado sin categoría.",
  categoriaEliminada: "Categoría eliminada en el terminal. | Categoría eliminada en los {n} terminales.",
  yaEstabanOrdenadas: "Las categorías de este grupo ya estaban seguidas.",
  categoriasReindexadas: "1 categoría movida. El grupo ya no tiene huecos. | {n} categorías movidas. El grupo ya no tiene huecos.",
  categoriasReordenadas: "1 categoría puesta en su tecla. | {n} categorías puestas en su tecla.",
  reordenarSaltados: "No se ha podido reordenar en: {terminales}.",
  categoriasIgualadas: "1 categoría igualada en todos los terminales. | {n} categorías igualadas en todos los terminales.",
  categoriasSaltadas: "1 categoría tiene nombres distintos entre terminales: elige tú cuál vale. | {n} categorías tienen nombres distintos entre terminales: elige tú cuál vale.",
  huecoConBajas: "Ranura ocupada",
  huecoLibre: "Hueco libre",
  eliminarCategoria: "Eliminar «{nombre}»",
  eliminarConProductos: "Tiene 1 producto dentro. Elige a dónde va antes de eliminarla. | Tiene {n} productos dentro. Elige a dónde van antes de eliminarla.",
  eliminarSinProductos: "No tiene productos dentro. Se eliminará en el terminal. | No tiene productos dentro. Se eliminará en los {n} terminales.",
  eliminarHuecoSeQueda: "El hueco se queda en su sitio: no se recoloca ninguna otra categoría.",
  eligeDestino: "Elige a dónde van sus productos.",
  moverProductosA: "Mover sus productos a...",
  sinResultadosCategoria: "Ninguna categoría coincide",
  grupoNumero: "Grupo {g}",
  dejarlosSinCategoria: "Dejarlos sin categoría",
  confirmarSinCategoriaTexto: "Ese producto dejará de salir agrupado en el terminal. Se seguirá vendiendo, pero los camareros solo llegarán a él buscándolo. | Esos {n} productos dejarán de salir agrupados en el terminal. Se seguirán vendiendo, pero los camareros solo llegarán a ellos buscándolos.",
  productosSinCategoriaTitulo: "Productos sin categoría",
  productosSinCategoriaAyuda: "No salen agrupados en el terminal, así que los camareros solo llegan a ellos buscándolos. Marca los que quieras y elige abajo a qué categoría van.",
  productoSinNombre: "(sin nombre)",
  enNTerminales: "en 1 de {t} terminales | en {n} de {t} terminales",
  sinProductosSinCategoria: "No queda ningún producto sin categoría.",
  asignarEstaCategoria: "Asignar esta categoría",
  elegirCategoriaDestino: "Elige una categoría",
  reindexarTitulo: "¿Reindexar el grupo {g}?",
  reindexarQuitaHuecos: "Se quita 1 hueco: las categorías quedan seguidas al principio del grupo. | Se quitan {n} huecos: las categorías quedan seguidas al principio del grupo.",
  reindexarCambiaTecla: "1 categoría cambia de tecla: en el terminal aparecerá en otro sitio. | {n} categorías cambian de tecla: en el terminal aparecerán en otro sitio.",
  reindexarProductosSeQuedan: "Los productos no cambian de categoría: se van con la suya.",
  reindexarComoQueda: "Cómo queda:",
  reindexarSinCambios: "Este grupo ya está seguido: no hay nada que reindexar.",
  unificarTitulo: "¿Unificar «{nombre}»?",
  aplicarTodosTitulo: "¿Aplicar las categorías a todos los terminales?",
  unificarTodosLaLlaman: "Todos los terminales pasarán a llamarla «{nombre}».",
  unificarPorServidor: "Se queda el nombre que tiene el terminal servidor.",
  unificarPorMayoria: "Se queda el nombre que usan más terminales.",
  unificarCambiaEn: "Cambia en 1 terminal: sus camareros verán el nombre nuevo y el anterior se pierde. | Cambia en {n} terminales: sus camareros verán el nombre nuevo y el anterior se pierde.",
  igualarProductosSeQuedan: "Los productos no se tocan: siguen en su categoría.",
  aplicarTodosEscribe: "Se escribirá el nombre de 1 categoría en los terminales donde falta. | Se escribirá el nombre de {n} categorías en los terminales donde falta.",
  aplicarTodosSaltadas: "1 categoría con nombres distintos entre terminales se queda como está: unifícala desde su aviso. | {n} categorías con nombres distintos entre terminales se quedan como están: unifícalas desde su aviso.",
  igualarQueCambia: "Qué cambia:",
  unificarOtroNombreBueno: "Si el nombre bueno es otro, cancela y renómbrala con el lápiz: el nombre que pongas se guardará en todos los terminales.",
  aplicarTodosFaltaEn: "falta en {terminales}",
  aplicarTodosNada: "No hay nada que aplicar: las categorías pendientes tienen nombres distintos entre terminales y hay que unificarlas antes.",
  igualarSeCrea: "no la tiene",
  igualarSinNombre: "sin nombre",
  reordenarTitulo: "¿Reordenar las categorías como en el servidor?",
  reordenarMandaServidor: "Manda el orden del servidor «{servidor}»: en los demás terminales, cada categoría pasa a la tecla que tiene allí.",
  reordenarCambianTecla: "1 categoría cambia de tecla: en su terminal aparecerá en otro sitio. | {n} categorías cambian de tecla: en su terminal aparecerán en otro sitio.",
  reordenarApartadas: "1 categoría que el servidor no tiene se aparta a otra tecla para dejar sitio. | {n} categorías que el servidor no tiene se apartan a otra tecla para dejar sitio.",
  reordenarProductosSeVan: "Los productos se van con su categoría: ninguno cambia de categoría.",
  reordenarNombresNoSeTocan: "No se cambia ningún nombre. Si después queda alguna diferencia de nombre, se arregla con Unificar.",
  reordenarSinSitio: "No se reordena este terminal: no queda ninguna tecla libre donde apartar las categorías que estorban.",
  reordenarSeAparta: "se aparta",
  reordenarAmbiguos: "No se mueven porque su nombre está repetido: {nombres}.",
  reordenarSinCambios: "Las categorías ya están en las mismas teclas que en el servidor.",
  ordenPrimeroTitulo: "Antes conviene reordenar",
  ordenPrimeroTexto: "Hay terminales con las categorías en otras teclas que el servidor. Conviene reordenarlas antes de hacer esto: si no, se pueden producir cambios erróneos —por ejemplo, poner un nombre encima de otra categoría— y no se garantiza que todo funcione bien después.",
  continuarIgualmente: "Continuar igualmente",
  reordenarPrimero: "Reordenar primero",
  // Los "¿Como lo soluciono?" de los avisos. Texto fijo: se pinta con v-html.
  comoLoSoluciono: "¿Cómo lo soluciono?",
  consejoOrdenAvisos: "Arréglalos de arriba abajo: cada arreglo puede cambiar o quitar los avisos de debajo. Recarga la pantalla después de cada uno.",
  consejoOrdenDistinto: "<p>Suele pasar cuando alguien ha creado o movido categorías desde el propio TPV: la misma categoría está en una tecla en el servidor y en otra en ese terminal.</p><ol><li>Pulsa <b>Reordenar</b>. El aviso enseña, terminal por terminal, qué categoría pasa a qué tecla.</li><li>Confirma. Los productos se van con su categoría: no hay que volver a colocarlos.</li><li>Espera a que el terminal sincronice y comprueba en él que cada tecla tiene sus productos.</li><li>Recarga la pantalla y sigue con el resto de avisos: ahora ya cuentan bien.</li></ol><p>Si un terminal sale como «no se ha podido reordenar», es que tiene las 40 teclas ocupadas. Elimina en él las categorías que sobren y vuelve a reordenar.</p><p>Mientras este aviso esté en pie, no unifiques nombres: pondrías el nombre en la tecla que no es.</p>",
  consejoOtroNombre: "<p>Casi siempre es que alguien la ha renombrado en el TPV. El servidor manda.</p><ul><li><b>Si vale el nombre del servidor:</b> pulsa <b>Unificar</b> y todos los terminales pasan a llamarla así.</li><li><b>Si vale el del terminal:</b> edítala con el lápiz y escribe ese nombre. Se guarda en todos los terminales.</li><li><b>Si los dos nombres parecen de categorías distintas</b> (por ejemplo, «BOTELLAS» y «CHUPITOS»), no es un nombre cambiado sino teclas cruzadas: reordena primero.</li></ul><p>Hasta que esté resuelto, ese grupo no se puede reindexar.</p>",
  consejoSoloEnClientes: "<p>Se ha creado en un terminal cliente y no en el servidor. Antes de decidir, mira cuántos productos tiene y, si dudas, pregunta en el local si la usan.</p><ul><li><b>Si la usan:</b> pulsa <b>Crear en el servidor</b>. Se crea en él y en los terminales donde falte, en la misma tecla.</li><li><b>Si sobra:</b> pulsa <b>Quitar del terminal</b> y elige a qué categoría pasan sus productos, para que no se queden sin categoría.</li></ul>",
  consejoNombreRepetido: "<p>Dos teclas con el mismo nombre confunden al camarero, y Reordenar no las mueve porque no sabe cuál es cuál.</p><ul><li><b>Si las dos hacen falta:</b> edita una con el lápiz y dale un nombre que la distinga (por ejemplo, «VINOS BLANCOS»).</li><li><b>Si una sobra:</b> elimínala con la X y pasa sus productos a la otra.</li></ul><p>Normalmente la buena es la que tiene más productos.</p>",
  consejoDesiguales: "<p>Pasa con terminales que estaban apagados o sin conexión cuando se creó la categoría, o con terminales que se han añadido después. En cada fila, el estado en ámbar dice en cuántos terminales falta.</p><ol><li>Si hay avisos rojos de nombre distinto, arréglalos antes: esas categorías se saltan.</li><li>Pulsa <b>Aplicar a todos</b>. Antes de escribir, enseña qué terminal recibe qué.</li><li>Confirma y espera a que los terminales sincronicen.</li></ol><p>Si tras sincronizar sigue faltando en un terminal, comprueba que está encendido y con conexión.</p>",
  consejoTerminalesSinCategorias: "<p>El negocio aún no tiene categorías que llevarle. Créalas con <b>Añadir categoría</b> en cada grupo: se crean a la vez en todos los terminales.</p><p>Si ese terminal ya no se usa, pide que lo den de baja para que deje de contar aquí.</p>",
  consejoProductosSinCategoria: "<p>Suelen venir de eliminar una categoría sin elegir destino, o de productos creados en el TPV sin categoría. Se siguen vendiendo, pero el camarero solo los encuentra buscándolos.</p><ol><li>Si no existe la categoría donde deberían ir, créala antes con <b>Añadir categoría</b>.</li><li>Pulsa <b>Ver productos</b>, marca los que van juntos y elige la categoría.</li><li>Pulsa <b>Asignar esta categoría</b>. Se mueven en todos los terminales.</li><li>Repite con el resto.</li></ol><p>Los de un grupo concreto también se ven desde el ojo de su fila «Sin categoría».</p>",
  consejoTerminalPendiente: "<p>No hay que hacer nada aquí. Enciende el terminal con conexión: copiará la carta del servidor y, al subirla, entrará en estas cuentas como uno más.</p><p>Si pasa el tiempo y sigue saliendo, comprueba que el terminal se ha encendido y tiene conexión.</p>",
};



// WEBPACK FOOTER //
// ./src/language/spain.js